/* eslint-disable */

// Generated by JavaScript APG, Version [`apg-js2`](https://github.com/ldthomas/apg-js2)
module.exports = {
  grammarObject: function(){
  "use strict";
    //```
    // SUMMARY
    //      rules = 403
    //       udts = 0
    //    opcodes = 1722
    //        ---   ABNF original opcodes
    //        ALT = 74
    //        CAT = 171
    //        REP = 164
    //        RNM = 581
    //        TLS = 697
    //        TBS = 30
    //        TRG = 5
    //        ---   SABNF superset opcodes
    //        UDT = 0
    //        AND = 0
    //        NOT = 0
    //        BKA = 0
    //        BKN = 0
    //        BKR = 0
    //        ABG = 0
    //        AEN = 0
    // characters = [33 - 126]
    //```
    /* OBJECT IDENTIFIER (for internal parser use) */
    this.grammarObject = 'grammarObject';

    /* RULES */
    this.rules = [];
    this.rules[0] = {name: 'DIGIT', lower: 'digit', index: 0, isBkr: false};
    this.rules[1] = {name: 'UPPERALPHA', lower: 'upperalpha', index: 1, isBkr: false};
    this.rules[2] = {name: 'LOWERALPHA', lower: 'loweralpha', index: 2, isBkr: false};
    this.rules[3] = {name: 'ALPHA', lower: 'alpha', index: 3, isBkr: false};
    this.rules[4] = {name: 'HEXDIG', lower: 'hexdig', index: 4, isBkr: false};
    this.rules[5] = {name: 'DoubleQuote', lower: 'doublequote', index: 5, isBkr: false};
    this.rules[6] = {name: 'Octothorpe', lower: 'octothorpe', index: 6, isBkr: false};
    this.rules[7] = {name: 'ForwardSlash', lower: 'forwardslash', index: 7, isBkr: false};
    this.rules[8] = {name: 'Percent', lower: 'percent', index: 8, isBkr: false};
    this.rules[9] = {name: 'Ampersand', lower: 'ampersand', index: 9, isBkr: false};
    this.rules[10] = {name: 'Plus', lower: 'plus', index: 10, isBkr: false};
    this.rules[11] = {name: 'Comma', lower: 'comma', index: 11, isBkr: false};
    this.rules[12] = {name: 'Exclamation', lower: 'exclamation', index: 12, isBkr: false};
    this.rules[13] = {name: 'LeftBracket', lower: 'leftbracket', index: 13, isBkr: false};
    this.rules[14] = {name: 'RightBracket', lower: 'rightbracket', index: 14, isBkr: false};
    this.rules[15] = {name: 'Asterisk', lower: 'asterisk', index: 15, isBkr: false};
    this.rules[16] = {name: 'Apostrophe', lower: 'apostrophe', index: 16, isBkr: false};
    this.rules[17] = {name: 'Colon', lower: 'colon', index: 17, isBkr: false};
    this.rules[18] = {name: 'Semicolon', lower: 'semicolon', index: 18, isBkr: false};
    this.rules[19] = {name: 'LeftAngleBracket', lower: 'leftanglebracket', index: 19, isBkr: false};
    this.rules[20] = {name: 'Equals', lower: 'equals', index: 20, isBkr: false};
    this.rules[21] = {name: 'RightAngleBracket', lower: 'rightanglebracket', index: 21, isBkr: false};
    this.rules[22] = {name: 'QuestionMark', lower: 'questionmark', index: 22, isBkr: false};
    this.rules[23] = {name: 'XSYMBOL', lower: 'xsymbol', index: 23, isBkr: false};
    this.rules[24] = {name: 'YSYMBOL', lower: 'ysymbol', index: 24, isBkr: false};
    this.rules[25] = {name: 'XCHAR', lower: 'xchar', index: 25, isBkr: false};
    this.rules[26] = {name: 'YCHAR', lower: 'ychar', index: 26, isBkr: false};
    this.rules[27] = {name: 'gtin-code', lower: 'gtin-code', index: 27, isBkr: false};
    this.rules[28] = {name: 'itip-code', lower: 'itip-code', index: 28, isBkr: false};
    this.rules[29] = {name: 'gmn-code', lower: 'gmn-code', index: 29, isBkr: false};
    this.rules[30] = {name: 'cpid-code', lower: 'cpid-code', index: 30, isBkr: false};
    this.rules[31] = {name: 'shipTo-code', lower: 'shipto-code', index: 31, isBkr: false};
    this.rules[32] = {name: 'billTo-code', lower: 'billto-code', index: 32, isBkr: false};
    this.rules[33] = {name: 'purchasedFrom-code', lower: 'purchasedfrom-code', index: 33, isBkr: false};
    this.rules[34] = {name: 'shipFor-code', lower: 'shipfor-code', index: 34, isBkr: false};
    this.rules[35] = {name: 'gln-code', lower: 'gln-code', index: 35, isBkr: false};
    this.rules[36] = {name: 'payTo-code', lower: 'payto-code', index: 36, isBkr: false};
    this.rules[37] = {name: 'glnProd-code', lower: 'glnprod-code', index: 37, isBkr: false};
    this.rules[38] = {name: 'gsrnp-code', lower: 'gsrnp-code', index: 38, isBkr: false};
    this.rules[39] = {name: 'gsrn-code', lower: 'gsrn-code', index: 39, isBkr: false};
    this.rules[40] = {name: 'gcn-code', lower: 'gcn-code', index: 40, isBkr: false};
    this.rules[41] = {name: 'sscc-code', lower: 'sscc-code', index: 41, isBkr: false};
    this.rules[42] = {name: 'gdti-code', lower: 'gdti-code', index: 42, isBkr: false};
    this.rules[43] = {name: 'ginc-code', lower: 'ginc-code', index: 43, isBkr: false};
    this.rules[44] = {name: 'gsin-code', lower: 'gsin-code', index: 44, isBkr: false};
    this.rules[45] = {name: 'grai-code', lower: 'grai-code', index: 45, isBkr: false};
    this.rules[46] = {name: 'giai-code', lower: 'giai-code', index: 46, isBkr: false};
    this.rules[47] = {name: 'cpv-code', lower: 'cpv-code', index: 47, isBkr: false};
    this.rules[48] = {name: 'lot-code', lower: 'lot-code', index: 48, isBkr: false};
    this.rules[49] = {name: 'ser-code', lower: 'ser-code', index: 49, isBkr: false};
    this.rules[50] = {name: 'cpsn-code', lower: 'cpsn-code', index: 50, isBkr: false};
    this.rules[51] = {name: 'glnx-code', lower: 'glnx-code', index: 51, isBkr: false};
    this.rules[52] = {name: 'refno-code', lower: 'refno-code', index: 52, isBkr: false};
    this.rules[53] = {name: 'srin-code', lower: 'srin-code', index: 53, isBkr: false};
    this.rules[54] = {name: 'gtin-value', lower: 'gtin-value', index: 54, isBkr: false};
    this.rules[55] = {name: 'itip-value', lower: 'itip-value', index: 55, isBkr: false};
    this.rules[56] = {name: 'gmn-value', lower: 'gmn-value', index: 56, isBkr: false};
    this.rules[57] = {name: 'cpid-value', lower: 'cpid-value', index: 57, isBkr: false};
    this.rules[58] = {name: 'shipTo-value', lower: 'shipto-value', index: 58, isBkr: false};
    this.rules[59] = {name: 'billTo-value', lower: 'billto-value', index: 59, isBkr: false};
    this.rules[60] = {name: 'purchasedFrom-value', lower: 'purchasedfrom-value', index: 60, isBkr: false};
    this.rules[61] = {name: 'shipFor-value', lower: 'shipfor-value', index: 61, isBkr: false};
    this.rules[62] = {name: 'gln-value', lower: 'gln-value', index: 62, isBkr: false};
    this.rules[63] = {name: 'payTo-value', lower: 'payto-value', index: 63, isBkr: false};
    this.rules[64] = {name: 'glnProd-value', lower: 'glnprod-value', index: 64, isBkr: false};
    this.rules[65] = {name: 'gsrnp-value', lower: 'gsrnp-value', index: 65, isBkr: false};
    this.rules[66] = {name: 'gsrn-value', lower: 'gsrn-value', index: 66, isBkr: false};
    this.rules[67] = {name: 'gcn-value', lower: 'gcn-value', index: 67, isBkr: false};
    this.rules[68] = {name: 'sscc-value', lower: 'sscc-value', index: 68, isBkr: false};
    this.rules[69] = {name: 'gdti-value', lower: 'gdti-value', index: 69, isBkr: false};
    this.rules[70] = {name: 'ginc-value', lower: 'ginc-value', index: 70, isBkr: false};
    this.rules[71] = {name: 'gsin-value', lower: 'gsin-value', index: 71, isBkr: false};
    this.rules[72] = {name: 'grai-value', lower: 'grai-value', index: 72, isBkr: false};
    this.rules[73] = {name: 'giai-value', lower: 'giai-value', index: 73, isBkr: false};
    this.rules[74] = {name: 'cpv-value', lower: 'cpv-value', index: 74, isBkr: false};
    this.rules[75] = {name: 'lot-value', lower: 'lot-value', index: 75, isBkr: false};
    this.rules[76] = {name: 'ser-value', lower: 'ser-value', index: 76, isBkr: false};
    this.rules[77] = {name: 'cpsn-value', lower: 'cpsn-value', index: 77, isBkr: false};
    this.rules[78] = {name: 'glnx-value', lower: 'glnx-value', index: 78, isBkr: false};
    this.rules[79] = {name: 'refno-value', lower: 'refno-value', index: 79, isBkr: false};
    this.rules[80] = {name: 'srin-value', lower: 'srin-value', index: 80, isBkr: false};
    this.rules[81] = {name: 'gtin-comp', lower: 'gtin-comp', index: 81, isBkr: false};
    this.rules[82] = {name: 'itip-comp', lower: 'itip-comp', index: 82, isBkr: false};
    this.rules[83] = {name: 'gmn-comp', lower: 'gmn-comp', index: 83, isBkr: false};
    this.rules[84] = {name: 'cpid-comp', lower: 'cpid-comp', index: 84, isBkr: false};
    this.rules[85] = {name: 'shipTo-comp', lower: 'shipto-comp', index: 85, isBkr: false};
    this.rules[86] = {name: 'billTo-comp', lower: 'billto-comp', index: 86, isBkr: false};
    this.rules[87] = {name: 'purchasedFrom-comp', lower: 'purchasedfrom-comp', index: 87, isBkr: false};
    this.rules[88] = {name: 'shipFor-comp', lower: 'shipfor-comp', index: 88, isBkr: false};
    this.rules[89] = {name: 'gln-comp', lower: 'gln-comp', index: 89, isBkr: false};
    this.rules[90] = {name: 'payTo-comp', lower: 'payto-comp', index: 90, isBkr: false};
    this.rules[91] = {name: 'glnProd-comp', lower: 'glnprod-comp', index: 91, isBkr: false};
    this.rules[92] = {name: 'gsrnp-comp', lower: 'gsrnp-comp', index: 92, isBkr: false};
    this.rules[93] = {name: 'gsrn-comp', lower: 'gsrn-comp', index: 93, isBkr: false};
    this.rules[94] = {name: 'gcn-comp', lower: 'gcn-comp', index: 94, isBkr: false};
    this.rules[95] = {name: 'sscc-comp', lower: 'sscc-comp', index: 95, isBkr: false};
    this.rules[96] = {name: 'gdti-comp', lower: 'gdti-comp', index: 96, isBkr: false};
    this.rules[97] = {name: 'ginc-comp', lower: 'ginc-comp', index: 97, isBkr: false};
    this.rules[98] = {name: 'gsin-comp', lower: 'gsin-comp', index: 98, isBkr: false};
    this.rules[99] = {name: 'grai-comp', lower: 'grai-comp', index: 99, isBkr: false};
    this.rules[100] = {name: 'giai-comp', lower: 'giai-comp', index: 100, isBkr: false};
    this.rules[101] = {name: 'cpv-comp', lower: 'cpv-comp', index: 101, isBkr: false};
    this.rules[102] = {name: 'lot-comp', lower: 'lot-comp', index: 102, isBkr: false};
    this.rules[103] = {name: 'ser-comp', lower: 'ser-comp', index: 103, isBkr: false};
    this.rules[104] = {name: 'cpsn-comp', lower: 'cpsn-comp', index: 104, isBkr: false};
    this.rules[105] = {name: 'glnx-comp', lower: 'glnx-comp', index: 105, isBkr: false};
    this.rules[106] = {name: 'refno-comp', lower: 'refno-comp', index: 106, isBkr: false};
    this.rules[107] = {name: 'srin-comp', lower: 'srin-comp', index: 107, isBkr: false};
    this.rules[108] = {name: 'gtin-path', lower: 'gtin-path', index: 108, isBkr: false};
    this.rules[109] = {name: 'itip-path', lower: 'itip-path', index: 109, isBkr: false};
    this.rules[110] = {name: 'gmn-path', lower: 'gmn-path', index: 110, isBkr: false};
    this.rules[111] = {name: 'cpid-path', lower: 'cpid-path', index: 111, isBkr: false};
    this.rules[112] = {name: 'shipTo-path', lower: 'shipto-path', index: 112, isBkr: false};
    this.rules[113] = {name: 'billTo-path', lower: 'billto-path', index: 113, isBkr: false};
    this.rules[114] = {name: 'purchasedFrom-path', lower: 'purchasedfrom-path', index: 114, isBkr: false};
    this.rules[115] = {name: 'shipFor-path', lower: 'shipfor-path', index: 115, isBkr: false};
    this.rules[116] = {name: 'gln-path', lower: 'gln-path', index: 116, isBkr: false};
    this.rules[117] = {name: 'payTo-path', lower: 'payto-path', index: 117, isBkr: false};
    this.rules[118] = {name: 'glnProd-path', lower: 'glnprod-path', index: 118, isBkr: false};
    this.rules[119] = {name: 'gsrnp-path', lower: 'gsrnp-path', index: 119, isBkr: false};
    this.rules[120] = {name: 'gsrn-path', lower: 'gsrn-path', index: 120, isBkr: false};
    this.rules[121] = {name: 'gcn-path', lower: 'gcn-path', index: 121, isBkr: false};
    this.rules[122] = {name: 'sscc-path', lower: 'sscc-path', index: 122, isBkr: false};
    this.rules[123] = {name: 'gdti-path', lower: 'gdti-path', index: 123, isBkr: false};
    this.rules[124] = {name: 'ginc-path', lower: 'ginc-path', index: 124, isBkr: false};
    this.rules[125] = {name: 'gsin-path', lower: 'gsin-path', index: 125, isBkr: false};
    this.rules[126] = {name: 'grai-path', lower: 'grai-path', index: 126, isBkr: false};
    this.rules[127] = {name: 'giai-path', lower: 'giai-path', index: 127, isBkr: false};
    this.rules[128] = {name: 'gs1path', lower: 'gs1path', index: 128, isBkr: false};
    this.rules[129] = {name: 'netWeightVMTICode', lower: 'netweightvmticode', index: 129, isBkr: false};
    this.rules[130] = {name: 'netWeightVMTIValue', lower: 'netweightvmtivalue', index: 130, isBkr: false};
    this.rules[131] = {name: 'netWeightVMTIParameter', lower: 'netweightvmtiparameter', index: 131, isBkr: false};
    this.rules[132] = {name: 'lengthVMTICode', lower: 'lengthvmticode', index: 132, isBkr: false};
    this.rules[133] = {name: 'lengthVMTIValue', lower: 'lengthvmtivalue', index: 133, isBkr: false};
    this.rules[134] = {name: 'lengthVMTIParameter', lower: 'lengthvmtiparameter', index: 134, isBkr: false};
    this.rules[135] = {name: 'widthVMTICode', lower: 'widthvmticode', index: 135, isBkr: false};
    this.rules[136] = {name: 'widthVMTIValue', lower: 'widthvmtivalue', index: 136, isBkr: false};
    this.rules[137] = {name: 'widthVMTIParameter', lower: 'widthvmtiparameter', index: 137, isBkr: false};
    this.rules[138] = {name: 'depthVMTICode', lower: 'depthvmticode', index: 138, isBkr: false};
    this.rules[139] = {name: 'depthVMTIValue', lower: 'depthvmtivalue', index: 139, isBkr: false};
    this.rules[140] = {name: 'depthVMTIParameter', lower: 'depthvmtiparameter', index: 140, isBkr: false};
    this.rules[141] = {name: 'areaVMTICode', lower: 'areavmticode', index: 141, isBkr: false};
    this.rules[142] = {name: 'areaVMTIValue', lower: 'areavmtivalue', index: 142, isBkr: false};
    this.rules[143] = {name: 'areaVMTIParameter', lower: 'areavmtiparameter', index: 143, isBkr: false};
    this.rules[144] = {name: 'netVolumeVMTICode', lower: 'netvolumevmticode', index: 144, isBkr: false};
    this.rules[145] = {name: 'netVolumeVMTIValue', lower: 'netvolumevmtivalue', index: 145, isBkr: false};
    this.rules[146] = {name: 'netVolumeVMTIParameter', lower: 'netvolumevmtiparameter', index: 146, isBkr: false};
    this.rules[147] = {name: 'massPerUnitAreaVMTICode', lower: 'massperunitareavmticode', index: 147, isBkr: false};
    this.rules[148] = {name: 'massPerUnitAreaVMTIValue', lower: 'massperunitareavmtivalue', index: 148, isBkr: false};
    this.rules[149] = {name: 'massPerUnitAreaVMTIParameter', lower: 'massperunitareavmtiparameter', index: 149, isBkr: false};
    this.rules[150] = {name: 'grossWeightCode', lower: 'grossweightcode', index: 150, isBkr: false};
    this.rules[151] = {name: 'grossWeightValue', lower: 'grossweightvalue', index: 151, isBkr: false};
    this.rules[152] = {name: 'grossWeightParameter', lower: 'grossweightparameter', index: 152, isBkr: false};
    this.rules[153] = {name: 'logisticLengthCode', lower: 'logisticlengthcode', index: 153, isBkr: false};
    this.rules[154] = {name: 'logisticLengthValue', lower: 'logisticlengthvalue', index: 154, isBkr: false};
    this.rules[155] = {name: 'logisticLengthParameter', lower: 'logisticlengthparameter', index: 155, isBkr: false};
    this.rules[156] = {name: 'logisticWidthCode', lower: 'logisticwidthcode', index: 156, isBkr: false};
    this.rules[157] = {name: 'logisticWidthValue', lower: 'logisticwidthvalue', index: 157, isBkr: false};
    this.rules[158] = {name: 'logisticWidthParameter', lower: 'logisticwidthparameter', index: 158, isBkr: false};
    this.rules[159] = {name: 'logisticDepthCode', lower: 'logisticdepthcode', index: 159, isBkr: false};
    this.rules[160] = {name: 'logisticDepthValue', lower: 'logisticdepthvalue', index: 160, isBkr: false};
    this.rules[161] = {name: 'logisticDepthParameter', lower: 'logisticdepthparameter', index: 161, isBkr: false};
    this.rules[162] = {name: 'logisticAreaCode', lower: 'logisticareacode', index: 162, isBkr: false};
    this.rules[163] = {name: 'logisticAreaValue', lower: 'logisticareavalue', index: 163, isBkr: false};
    this.rules[164] = {name: 'logisticAreaParameter', lower: 'logisticareaparameter', index: 164, isBkr: false};
    this.rules[165] = {name: 'logisticVolumeCode', lower: 'logisticvolumecode', index: 165, isBkr: false};
    this.rules[166] = {name: 'logisticVolumeValue', lower: 'logisticvolumevalue', index: 166, isBkr: false};
    this.rules[167] = {name: 'logisticVolumeParameter', lower: 'logisticvolumeparameter', index: 167, isBkr: false};
    this.rules[168] = {name: 'processorCode', lower: 'processorcode', index: 168, isBkr: false};
    this.rules[169] = {name: 'processorValue', lower: 'processorvalue', index: 169, isBkr: false};
    this.rules[170] = {name: 'processorParameter', lower: 'processorparameter', index: 170, isBkr: false};
    this.rules[171] = {name: 'contentCode', lower: 'contentcode', index: 171, isBkr: false};
    this.rules[172] = {name: 'contentValue', lower: 'contentvalue', index: 172, isBkr: false};
    this.rules[173] = {name: 'contentParameter', lower: 'contentparameter', index: 173, isBkr: false};
    this.rules[174] = {name: 'prodDateCode', lower: 'proddatecode', index: 174, isBkr: false};
    this.rules[175] = {name: 'prodDateValue', lower: 'proddatevalue', index: 175, isBkr: false};
    this.rules[176] = {name: 'prodDateParameter', lower: 'proddateparameter', index: 176, isBkr: false};
    this.rules[177] = {name: 'dueDateCode', lower: 'duedatecode', index: 177, isBkr: false};
    this.rules[178] = {name: 'dueDateValue', lower: 'duedatevalue', index: 178, isBkr: false};
    this.rules[179] = {name: 'dueDateParameter', lower: 'duedateparameter', index: 179, isBkr: false};
    this.rules[180] = {name: 'packDateCode', lower: 'packdatecode', index: 180, isBkr: false};
    this.rules[181] = {name: 'packDateValue', lower: 'packdatevalue', index: 181, isBkr: false};
    this.rules[182] = {name: 'packDateParameter', lower: 'packdateparameter', index: 182, isBkr: false};
    this.rules[183] = {name: 'bestBeforeDateCode', lower: 'bestbeforedatecode', index: 183, isBkr: false};
    this.rules[184] = {name: 'bestBeforeDateValue', lower: 'bestbeforedatevalue', index: 184, isBkr: false};
    this.rules[185] = {name: 'bestBeforeDateParameter', lower: 'bestbeforedateparameter', index: 185, isBkr: false};
    this.rules[186] = {name: 'sellByDateCode', lower: 'sellbydatecode', index: 186, isBkr: false};
    this.rules[187] = {name: 'sellByDateValue', lower: 'sellbydatevalue', index: 187, isBkr: false};
    this.rules[188] = {name: 'sellByDateParameter', lower: 'sellbydateparameter', index: 188, isBkr: false};
    this.rules[189] = {name: 'firstFreezeDateCode', lower: 'firstfreezedatecode', index: 189, isBkr: false};
    this.rules[190] = {name: 'firstFreezeDateValue', lower: 'firstfreezedatevalue', index: 190, isBkr: false};
    this.rules[191] = {name: 'firstFreezeDateParameter', lower: 'firstfreezedateparameter', index: 191, isBkr: false};
    this.rules[192] = {name: 'harvestDateCode', lower: 'harvestdatecode', index: 192, isBkr: false};
    this.rules[193] = {name: 'harvestDateValue', lower: 'harvestdatevalue', index: 193, isBkr: false};
    this.rules[194] = {name: 'harvestDateParameter', lower: 'harvestdateparameter', index: 194, isBkr: false};
    this.rules[195] = {name: 'pricePerUnitCode', lower: 'priceperunitcode', index: 195, isBkr: false};
    this.rules[196] = {name: 'pricePerUnitValue', lower: 'priceperunitvalue', index: 196, isBkr: false};
    this.rules[197] = {name: 'pricePerUnitParameter', lower: 'priceperunitparameter', index: 197, isBkr: false};
    this.rules[198] = {name: 'variantCode', lower: 'variantcode', index: 198, isBkr: false};
    this.rules[199] = {name: 'variantValue', lower: 'variantvalue', index: 199, isBkr: false};
    this.rules[200] = {name: 'variantParameter', lower: 'variantparameter', index: 200, isBkr: false};
    this.rules[201] = {name: 'varCountCode', lower: 'varcountcode', index: 201, isBkr: false};
    this.rules[202] = {name: 'varCountValue', lower: 'varcountvalue', index: 202, isBkr: false};
    this.rules[203] = {name: 'varCountParameter', lower: 'varcountparameter', index: 203, isBkr: false};
    this.rules[204] = {name: 'countCode', lower: 'countcode', index: 204, isBkr: false};
    this.rules[205] = {name: 'countValue', lower: 'countvalue', index: 205, isBkr: false};
    this.rules[206] = {name: 'countParameter', lower: 'countparameter', index: 206, isBkr: false};
    this.rules[207] = {name: 'mutualCode', lower: 'mutualcode', index: 207, isBkr: false};
    this.rules[208] = {name: 'mutualValue', lower: 'mutualvalue', index: 208, isBkr: false};
    this.rules[209] = {name: 'mutualParameter', lower: 'mutualparameter', index: 209, isBkr: false};
    this.rules[210] = {name: 'additionalIdCode', lower: 'additionalidcode', index: 210, isBkr: false};
    this.rules[211] = {name: 'additionalIdValue', lower: 'additionalidvalue', index: 211, isBkr: false};
    this.rules[212] = {name: 'additionalIdParameter', lower: 'additionalidparameter', index: 212, isBkr: false};
    this.rules[213] = {name: 'custPartNoCode', lower: 'custpartnocode', index: 213, isBkr: false};
    this.rules[214] = {name: 'custPartNoValue', lower: 'custpartnovalue', index: 214, isBkr: false};
    this.rules[215] = {name: 'custPartNoParameter', lower: 'custpartnoparameter', index: 215, isBkr: false};
    this.rules[216] = {name: 'mtoVariantCode', lower: 'mtovariantcode', index: 216, isBkr: false};
    this.rules[217] = {name: 'mtoVariantValue', lower: 'mtovariantvalue', index: 217, isBkr: false};
    this.rules[218] = {name: 'mtoVariantParameter', lower: 'mtovariantparameter', index: 218, isBkr: false};
    this.rules[219] = {name: 'pcnCode', lower: 'pcncode', index: 219, isBkr: false};
    this.rules[220] = {name: 'pcnValue', lower: 'pcnvalue', index: 220, isBkr: false};
    this.rules[221] = {name: 'pcnParameter', lower: 'pcnparameter', index: 221, isBkr: false};
    this.rules[222] = {name: 'secondarySerialCode', lower: 'secondaryserialcode', index: 222, isBkr: false};
    this.rules[223] = {name: 'secondarySerialValue', lower: 'secondaryserialvalue', index: 223, isBkr: false};
    this.rules[224] = {name: 'secondarySerialParameter', lower: 'secondaryserialparameter', index: 224, isBkr: false};
    this.rules[225] = {name: 'refToSourceCode', lower: 'reftosourcecode', index: 225, isBkr: false};
    this.rules[226] = {name: 'refToSourceValue', lower: 'reftosourcevalue', index: 226, isBkr: false};
    this.rules[227] = {name: 'refToSourceParameter', lower: 'reftosourceparameter', index: 227, isBkr: false};
    this.rules[228] = {name: 'amountCode', lower: 'amountcode', index: 228, isBkr: false};
    this.rules[229] = {name: 'amountValue', lower: 'amountvalue', index: 229, isBkr: false};
    this.rules[230] = {name: 'amountParameter', lower: 'amountparameter', index: 230, isBkr: false};
    this.rules[231] = {name: 'amountISOCode', lower: 'amountisocode', index: 231, isBkr: false};
    this.rules[232] = {name: 'amountISOValue', lower: 'amountisovalue', index: 232, isBkr: false};
    this.rules[233] = {name: 'amountISOParameter', lower: 'amountisoparameter', index: 233, isBkr: false};
    this.rules[234] = {name: 'priceCode', lower: 'pricecode', index: 234, isBkr: false};
    this.rules[235] = {name: 'priceValue', lower: 'pricevalue', index: 235, isBkr: false};
    this.rules[236] = {name: 'priceParameter', lower: 'priceparameter', index: 236, isBkr: false};
    this.rules[237] = {name: 'priceISOCode', lower: 'priceisocode', index: 237, isBkr: false};
    this.rules[238] = {name: 'priceISOValue', lower: 'priceisovalue', index: 238, isBkr: false};
    this.rules[239] = {name: 'priceISOParameter', lower: 'priceisoparameter', index: 239, isBkr: false};
    this.rules[240] = {name: 'percentOffCode', lower: 'percentoffcode', index: 240, isBkr: false};
    this.rules[241] = {name: 'percentOffValue', lower: 'percentoffvalue', index: 241, isBkr: false};
    this.rules[242] = {name: 'percentOffParameter', lower: 'percentoffparameter', index: 242, isBkr: false};
    this.rules[243] = {name: 'orderNumberCode', lower: 'ordernumbercode', index: 243, isBkr: false};
    this.rules[244] = {name: 'orderNumberValue', lower: 'ordernumbervalue', index: 244, isBkr: false};
    this.rules[245] = {name: 'orderNumberParameter', lower: 'ordernumberparameter', index: 245, isBkr: false};
    this.rules[246] = {name: 'routeCode', lower: 'routecode', index: 246, isBkr: false};
    this.rules[247] = {name: 'routeValue', lower: 'routevalue', index: 247, isBkr: false};
    this.rules[248] = {name: 'routeParameter', lower: 'routeparameter', index: 248, isBkr: false};
    this.rules[249] = {name: 'shipToLocCode', lower: 'shiptoloccode', index: 249, isBkr: false};
    this.rules[250] = {name: 'shipToLocValue', lower: 'shiptolocvalue', index: 250, isBkr: false};
    this.rules[251] = {name: 'shipToLocParameter', lower: 'shiptolocparameter', index: 251, isBkr: false};
    this.rules[252] = {name: 'billToCode', lower: 'billtocode', index: 252, isBkr: false};
    this.rules[253] = {name: 'billToValue', lower: 'billtovalue', index: 253, isBkr: false};
    this.rules[254] = {name: 'billToParameter', lower: 'billtoparameter', index: 254, isBkr: false};
    this.rules[255] = {name: 'purchaseFromCode', lower: 'purchasefromcode', index: 255, isBkr: false};
    this.rules[256] = {name: 'purchaseFromValue', lower: 'purchasefromvalue', index: 256, isBkr: false};
    this.rules[257] = {name: 'purchaseFromParameter', lower: 'purchasefromparameter', index: 257, isBkr: false};
    this.rules[258] = {name: 'shipForLocCode', lower: 'shipforloccode', index: 258, isBkr: false};
    this.rules[259] = {name: 'shipForLocValue', lower: 'shipforlocvalue', index: 259, isBkr: false};
    this.rules[260] = {name: 'shipForLocParameter', lower: 'shipforlocparameter', index: 260, isBkr: false};
    this.rules[261] = {name: 'locNoCode', lower: 'locnocode', index: 261, isBkr: false};
    this.rules[262] = {name: 'locNoValue', lower: 'locnovalue', index: 262, isBkr: false};
    this.rules[263] = {name: 'locNoParameter', lower: 'locnoparameter', index: 263, isBkr: false};
    this.rules[264] = {name: 'payToCode', lower: 'paytocode', index: 264, isBkr: false};
    this.rules[265] = {name: 'payToValue', lower: 'paytovalue', index: 265, isBkr: false};
    this.rules[266] = {name: 'payToParameter', lower: 'paytoparameter', index: 266, isBkr: false};
    this.rules[267] = {name: 'prodServLocCode', lower: 'prodservloccode', index: 267, isBkr: false};
    this.rules[268] = {name: 'prodServLocValue', lower: 'prodservlocvalue', index: 268, isBkr: false};
    this.rules[269] = {name: 'prodServLocParameter', lower: 'prodservlocparameter', index: 269, isBkr: false};
    this.rules[270] = {name: 'shipToPostCode', lower: 'shiptopostcode', index: 270, isBkr: false};
    this.rules[271] = {name: 'shipToPostValue', lower: 'shiptopostvalue', index: 271, isBkr: false};
    this.rules[272] = {name: 'shipToPostParameter', lower: 'shiptopostparameter', index: 272, isBkr: false};
    this.rules[273] = {name: 'shipToPostISOCode', lower: 'shiptopostisocode', index: 273, isBkr: false};
    this.rules[274] = {name: 'shipToPostISOValue', lower: 'shiptopostisovalue', index: 274, isBkr: false};
    this.rules[275] = {name: 'shipToPostISOParameter', lower: 'shiptopostisoparameter', index: 275, isBkr: false};
    this.rules[276] = {name: 'originCode', lower: 'origincode', index: 276, isBkr: false};
    this.rules[277] = {name: 'originValue', lower: 'originvalue', index: 277, isBkr: false};
    this.rules[278] = {name: 'originParameter', lower: 'originparameter', index: 278, isBkr: false};
    this.rules[279] = {name: 'countryProcessCode', lower: 'countryprocesscode', index: 279, isBkr: false};
    this.rules[280] = {name: 'countryProcessValue', lower: 'countryprocessvalue', index: 280, isBkr: false};
    this.rules[281] = {name: 'countryProcessParameter', lower: 'countryprocessparameter', index: 281, isBkr: false};
    this.rules[282] = {name: 'countryFullProcessCode', lower: 'countryfullprocesscode', index: 282, isBkr: false};
    this.rules[283] = {name: 'countryFullProcessValue', lower: 'countryfullprocessvalue', index: 283, isBkr: false};
    this.rules[284] = {name: 'countryFullProcessParameter', lower: 'countryfullprocessparameter', index: 284, isBkr: false};
    this.rules[285] = {name: 'countryInitialProcessCode', lower: 'countryinitialprocesscode', index: 285, isBkr: false};
    this.rules[286] = {name: 'countryInitialProcessValue', lower: 'countryinitialprocessvalue', index: 286, isBkr: false};
    this.rules[287] = {name: 'countryInitialProcessParameter', lower: 'countryinitialprocessparameter', index: 287, isBkr: false};
    this.rules[288] = {name: 'countryDisassemblyCode', lower: 'countrydisassemblycode', index: 288, isBkr: false};
    this.rules[289] = {name: 'countryDisassemblyValue', lower: 'countrydisassemblyvalue', index: 289, isBkr: false};
    this.rules[290] = {name: 'countryDisassemblyParameter', lower: 'countrydisassemblyparameter', index: 290, isBkr: false};
    this.rules[291] = {name: 'originSubdivisionCode', lower: 'originsubdivisioncode', index: 291, isBkr: false};
    this.rules[292] = {name: 'originSubdivisionValue', lower: 'originsubdivisionvalue', index: 292, isBkr: false};
    this.rules[293] = {name: 'originSubdivisionParameter', lower: 'originsubdivisionparameter', index: 293, isBkr: false};
    this.rules[294] = {name: 'nhrnPZNCode', lower: 'nhrnpzncode', index: 294, isBkr: false};
    this.rules[295] = {name: 'nhrnPZNValue', lower: 'nhrnpznvalue', index: 295, isBkr: false};
    this.rules[296] = {name: 'nhrnPZNParameter', lower: 'nhrnpznparameter', index: 296, isBkr: false};
    this.rules[297] = {name: 'nhrnCIPCode', lower: 'nhrncipcode', index: 297, isBkr: false};
    this.rules[298] = {name: 'nhrnCIPValue', lower: 'nhrncipvalue', index: 298, isBkr: false};
    this.rules[299] = {name: 'nhrnCIPParameter', lower: 'nhrncipparameter', index: 299, isBkr: false};
    this.rules[300] = {name: 'nhrnCNCode', lower: 'nhrncncode', index: 300, isBkr: false};
    this.rules[301] = {name: 'nhrnCNValue', lower: 'nhrncnvalue', index: 301, isBkr: false};
    this.rules[302] = {name: 'nhrnCNParameter', lower: 'nhrncnparameter', index: 302, isBkr: false};
    this.rules[303] = {name: 'nhrnDRNCode', lower: 'nhrndrncode', index: 303, isBkr: false};
    this.rules[304] = {name: 'nhrnDRNValue', lower: 'nhrndrnvalue', index: 304, isBkr: false};
    this.rules[305] = {name: 'nhrnDRNParameter', lower: 'nhrndrnparameter', index: 305, isBkr: false};
    this.rules[306] = {name: 'nhrnAIMCode', lower: 'nhrnaimcode', index: 306, isBkr: false};
    this.rules[307] = {name: 'nhrnAIMValue', lower: 'nhrnaimvalue', index: 307, isBkr: false};
    this.rules[308] = {name: 'nhrnAIMParameter', lower: 'nhrnaimparameter', index: 308, isBkr: false};
    this.rules[309] = {name: 'nsnCode', lower: 'nsncode', index: 309, isBkr: false};
    this.rules[310] = {name: 'nsnValue', lower: 'nsnvalue', index: 310, isBkr: false};
    this.rules[311] = {name: 'nsnParameter', lower: 'nsnparameter', index: 311, isBkr: false};
    this.rules[312] = {name: 'meatCutCode', lower: 'meatcutcode', index: 312, isBkr: false};
    this.rules[313] = {name: 'meatCutValue', lower: 'meatcutvalue', index: 313, isBkr: false};
    this.rules[314] = {name: 'meatCutParameter', lower: 'meatcutparameter', index: 314, isBkr: false};
    this.rules[315] = {name: 'activePotencyCode', lower: 'activepotencycode', index: 315, isBkr: false};
    this.rules[316] = {name: 'activePotencyValue', lower: 'activepotencyvalue', index: 316, isBkr: false};
    this.rules[317] = {name: 'activePotencyParameter', lower: 'activepotencyparameter', index: 317, isBkr: false};
    this.rules[318] = {name: 'catchAreaCode', lower: 'catchareacode', index: 318, isBkr: false};
    this.rules[319] = {name: 'catchAreaValue', lower: 'catchareavalue', index: 319, isBkr: false};
    this.rules[320] = {name: 'catchAreaParameter', lower: 'catchareaparameter', index: 320, isBkr: false};
    this.rules[321] = {name: 'fishingGearTypeCode', lower: 'fishinggeartypecode', index: 321, isBkr: false};
    this.rules[322] = {name: 'fishingGearTypeValue', lower: 'fishinggeartypevalue', index: 322, isBkr: false};
    this.rules[323] = {name: 'fishingGearTypeParameter', lower: 'fishinggeartypeparameter', index: 323, isBkr: false};
    this.rules[324] = {name: 'prodMethodCode', lower: 'prodmethodcode', index: 324, isBkr: false};
    this.rules[325] = {name: 'prodMethodValue', lower: 'prodmethodvalue', index: 325, isBkr: false};
    this.rules[326] = {name: 'prodMethodParameter', lower: 'prodmethodparameter', index: 326, isBkr: false};
    this.rules[327] = {name: 'refurbLotCode', lower: 'refurblotcode', index: 327, isBkr: false};
    this.rules[328] = {name: 'refurbLotValue', lower: 'refurblotvalue', index: 328, isBkr: false};
    this.rules[329] = {name: 'refurbLotParameter', lower: 'refurblotparameter', index: 329, isBkr: false};
    this.rules[330] = {name: 'funcStatCode', lower: 'funcstatcode', index: 330, isBkr: false};
    this.rules[331] = {name: 'funcStatValue', lower: 'funcstatvalue', index: 331, isBkr: false};
    this.rules[332] = {name: 'funcStatParameter', lower: 'funcstatparameter', index: 332, isBkr: false};
    this.rules[333] = {name: 'revStatCode', lower: 'revstatcode', index: 333, isBkr: false};
    this.rules[334] = {name: 'revStatValue', lower: 'revstatvalue', index: 334, isBkr: false};
    this.rules[335] = {name: 'revStatParameter', lower: 'revstatparameter', index: 335, isBkr: false};
    this.rules[336] = {name: 'giaiAssemblyCode', lower: 'giaiassemblycode', index: 336, isBkr: false};
    this.rules[337] = {name: 'giaiAssemblyValue', lower: 'giaiassemblyvalue', index: 337, isBkr: false};
    this.rules[338] = {name: 'giaiAssemblyParameter', lower: 'giaiassemblyparameter', index: 338, isBkr: false};
    this.rules[339] = {name: 'dimensionsCode', lower: 'dimensionscode', index: 339, isBkr: false};
    this.rules[340] = {name: 'dimensionsValue', lower: 'dimensionsvalue', index: 340, isBkr: false};
    this.rules[341] = {name: 'dimensionsParameter', lower: 'dimensionsparameter', index: 341, isBkr: false};
    this.rules[342] = {name: 'cmtNoCode', lower: 'cmtnocode', index: 342, isBkr: false};
    this.rules[343] = {name: 'cmtNoValue', lower: 'cmtnovalue', index: 343, isBkr: false};
    this.rules[344] = {name: 'cmtNoParameter', lower: 'cmtnoparameter', index: 344, isBkr: false};
    this.rules[345] = {name: 'ibanCode', lower: 'ibancode', index: 345, isBkr: false};
    this.rules[346] = {name: 'ibanValue', lower: 'ibanvalue', index: 346, isBkr: false};
    this.rules[347] = {name: 'ibanParameter', lower: 'ibanparameter', index: 347, isBkr: false};
    this.rules[348] = {name: 'prodTimeCode', lower: 'prodtimecode', index: 348, isBkr: false};
    this.rules[349] = {name: 'prodTimeValue', lower: 'prodtimevalue', index: 349, isBkr: false};
    this.rules[350] = {name: 'prodTimeParameter', lower: 'prodtimeparameter', index: 350, isBkr: false};
    this.rules[351] = {name: 'versionCode', lower: 'versioncode', index: 351, isBkr: false};
    this.rules[352] = {name: 'versionValue', lower: 'versionvalue', index: 352, isBkr: false};
    this.rules[353] = {name: 'versionParameter', lower: 'versionparameter', index: 353, isBkr: false};
    this.rules[354] = {name: 'refNoCode', lower: 'refnocode', index: 354, isBkr: false};
    this.rules[355] = {name: 'refNoValue', lower: 'refnovalue', index: 355, isBkr: false};
    this.rules[356] = {name: 'refNoParameter', lower: 'refnoparameter', index: 356, isBkr: false};
    this.rules[357] = {name: 'couponIDNACode', lower: 'couponidnacode', index: 357, isBkr: false};
    this.rules[358] = {name: 'couponIDNAValue', lower: 'couponidnavalue', index: 358, isBkr: false};
    this.rules[359] = {name: 'couponIDNAParameter', lower: 'couponidnaparameter', index: 359, isBkr: false};
    this.rules[360] = {name: 'pointsCode', lower: 'pointscode', index: 360, isBkr: false};
    this.rules[361] = {name: 'pointsValue', lower: 'pointsvalue', index: 361, isBkr: false};
    this.rules[362] = {name: 'pointsParameter', lower: 'pointsparameter', index: 362, isBkr: false};
    this.rules[363] = {name: 'paperlessCouponIDNACode', lower: 'paperlesscouponidnacode', index: 363, isBkr: false};
    this.rules[364] = {name: 'paperlessCouponIDNAValue', lower: 'paperlesscouponidnavalue', index: 364, isBkr: false};
    this.rules[365] = {name: 'paperlessCouponIDNAParameter', lower: 'paperlesscouponidnaparameter', index: 365, isBkr: false};
    this.rules[366] = {name: 'internalCode', lower: 'internalcode', index: 366, isBkr: false};
    this.rules[367] = {name: 'internalValue', lower: 'internalvalue', index: 367, isBkr: false};
    this.rules[368] = {name: 'internalParameter', lower: 'internalparameter', index: 368, isBkr: false};
    this.rules[369] = {name: 'LotParameter', lower: 'lotparameter', index: 369, isBkr: false};
    this.rules[370] = {name: 'expiryDateCode', lower: 'expirydatecode', index: 370, isBkr: false};
    this.rules[371] = {name: 'expiryDateValue', lower: 'expirydatevalue', index: 371, isBkr: false};
    this.rules[372] = {name: 'expiryDateParameter', lower: 'expirydateparameter', index: 372, isBkr: false};
    this.rules[373] = {name: 'expiryTimeCode', lower: 'expirytimecode', index: 373, isBkr: false};
    this.rules[374] = {name: 'expiryTimeValue', lower: 'expirytimevalue', index: 374, isBkr: false};
    this.rules[375] = {name: 'expiryTimeParameter', lower: 'expirytimeparameter', index: 375, isBkr: false};
    this.rules[376] = {name: 'extensionParameter', lower: 'extensionparameter', index: 376, isBkr: false};
    this.rules[377] = {name: 'queryStringParam', lower: 'querystringparam', index: 377, isBkr: false};
    this.rules[378] = {name: 'scheme', lower: 'scheme', index: 378, isBkr: false};
    this.rules[379] = {name: 'unreserved', lower: 'unreserved', index: 379, isBkr: false};
    this.rules[380] = {name: 'reserved', lower: 'reserved', index: 380, isBkr: false};
    this.rules[381] = {name: 'pct-encoded', lower: 'pct-encoded', index: 381, isBkr: false};
    this.rules[382] = {name: 'gen-delims', lower: 'gen-delims', index: 382, isBkr: false};
    this.rules[383] = {name: 'sub-delims', lower: 'sub-delims', index: 383, isBkr: false};
    this.rules[384] = {name: 'pchar', lower: 'pchar', index: 384, isBkr: false};
    this.rules[385] = {name: 'segment', lower: 'segment', index: 385, isBkr: false};
    this.rules[386] = {name: 'reg-name', lower: 'reg-name', index: 386, isBkr: false};
    this.rules[387] = {name: 'dec-octet', lower: 'dec-octet', index: 387, isBkr: false};
    this.rules[388] = {name: 'IPv4address', lower: 'ipv4address', index: 388, isBkr: false};
    this.rules[389] = {name: 'IPv6address', lower: 'ipv6address', index: 389, isBkr: false};
    this.rules[390] = {name: 'ls32', lower: 'ls32', index: 390, isBkr: false};
    this.rules[391] = {name: 'h16', lower: 'h16', index: 391, isBkr: false};
    this.rules[392] = {name: 'IP-literal', lower: 'ip-literal', index: 392, isBkr: false};
    this.rules[393] = {name: 'IPvFuture', lower: 'ipvfuture', index: 393, isBkr: false};
    this.rules[394] = {name: 'host', lower: 'host', index: 394, isBkr: false};
    this.rules[395] = {name: 'port', lower: 'port', index: 395, isBkr: false};
    this.rules[396] = {name: 'hostname', lower: 'hostname', index: 396, isBkr: false};
    this.rules[397] = {name: 'queryStringDelim', lower: 'querystringdelim', index: 397, isBkr: false};
    this.rules[398] = {name: 'queryStringComp', lower: 'querystringcomp', index: 398, isBkr: false};
    this.rules[399] = {name: 'gs1uriPattern', lower: 'gs1uripattern', index: 399, isBkr: false};
    this.rules[400] = {name: 'canonicalGS1webURI', lower: 'canonicalgs1weburi', index: 400, isBkr: false};
    this.rules[401] = {name: 'customURIstem', lower: 'customuristem', index: 401, isBkr: false};
    this.rules[402] = {name: 'customGS1webURI', lower: 'customgs1weburi', index: 402, isBkr: false};

    /* UDTS */
    this.udts = [];

    /* OPCODES */
    /* DIGIT */
    this.rules[0].opcodes = [];
    this.rules[0].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10]};// ALT
    this.rules[0].opcodes[1] = {type: 7, string: [48]};// TLS
    this.rules[0].opcodes[2] = {type: 7, string: [49]};// TLS
    this.rules[0].opcodes[3] = {type: 7, string: [50]};// TLS
    this.rules[0].opcodes[4] = {type: 7, string: [51]};// TLS
    this.rules[0].opcodes[5] = {type: 7, string: [52]};// TLS
    this.rules[0].opcodes[6] = {type: 7, string: [53]};// TLS
    this.rules[0].opcodes[7] = {type: 7, string: [54]};// TLS
    this.rules[0].opcodes[8] = {type: 7, string: [55]};// TLS
    this.rules[0].opcodes[9] = {type: 7, string: [56]};// TLS
    this.rules[0].opcodes[10] = {type: 7, string: [57]};// TLS

    /* UPPERALPHA */
    this.rules[1].opcodes = [];
    this.rules[1].opcodes[0] = {type: 5, min: 65, max: 90};// TRG

    /* LOWERALPHA */
    this.rules[2].opcodes = [];
    this.rules[2].opcodes[0] = {type: 5, min: 97, max: 122};// TRG

    /* ALPHA */
    this.rules[3].opcodes = [];
    this.rules[3].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[3].opcodes[1] = {type: 4, index: 1};// RNM(UPPERALPHA)
    this.rules[3].opcodes[2] = {type: 4, index: 2};// RNM(LOWERALPHA)

    /* HEXDIG */
    this.rules[4].opcodes = [];
    this.rules[4].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7]};// ALT
    this.rules[4].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[4].opcodes[2] = {type: 7, string: [97]};// TLS
    this.rules[4].opcodes[3] = {type: 7, string: [98]};// TLS
    this.rules[4].opcodes[4] = {type: 7, string: [99]};// TLS
    this.rules[4].opcodes[5] = {type: 7, string: [100]};// TLS
    this.rules[4].opcodes[6] = {type: 7, string: [101]};// TLS
    this.rules[4].opcodes[7] = {type: 7, string: [102]};// TLS

    /* DoubleQuote */
    this.rules[5].opcodes = [];
    this.rules[5].opcodes[0] = {type: 6, string: [34]};// TBS

    /* Octothorpe */
    this.rules[6].opcodes = [];
    this.rules[6].opcodes[0] = {type: 7, string: [37,120,50,51]};// TLS

    /* ForwardSlash */
    this.rules[7].opcodes = [];
    this.rules[7].opcodes[0] = {type: 7, string: [37,120,50,102]};// TLS

    /* Percent */
    this.rules[8].opcodes = [];
    this.rules[8].opcodes[0] = {type: 7, string: [37,120,50,53]};// TLS

    /* Ampersand */
    this.rules[9].opcodes = [];
    this.rules[9].opcodes[0] = {type: 7, string: [37,120,50,54]};// TLS

    /* Plus */
    this.rules[10].opcodes = [];
    this.rules[10].opcodes[0] = {type: 7, string: [37,120,50,98]};// TLS

    /* Comma */
    this.rules[11].opcodes = [];
    this.rules[11].opcodes[0] = {type: 7, string: [37,120,50,99]};// TLS

    /* Exclamation */
    this.rules[12].opcodes = [];
    this.rules[12].opcodes[0] = {type: 7, string: [37,120,50,49]};// TLS

    /* LeftBracket */
    this.rules[13].opcodes = [];
    this.rules[13].opcodes[0] = {type: 7, string: [37,120,50,56]};// TLS

    /* RightBracket */
    this.rules[14].opcodes = [];
    this.rules[14].opcodes[0] = {type: 7, string: [37,120,50,57]};// TLS

    /* Asterisk */
    this.rules[15].opcodes = [];
    this.rules[15].opcodes[0] = {type: 7, string: [37,120,50,97]};// TLS

    /* Apostrophe */
    this.rules[16].opcodes = [];
    this.rules[16].opcodes[0] = {type: 7, string: [37,120,50,55]};// TLS

    /* Colon */
    this.rules[17].opcodes = [];
    this.rules[17].opcodes[0] = {type: 7, string: [37,120,51,97]};// TLS

    /* Semicolon */
    this.rules[18].opcodes = [];
    this.rules[18].opcodes[0] = {type: 7, string: [37,120,51,98]};// TLS

    /* LeftAngleBracket */
    this.rules[19].opcodes = [];
    this.rules[19].opcodes[0] = {type: 7, string: [37,120,51,99]};// TLS

    /* Equals */
    this.rules[20].opcodes = [];
    this.rules[20].opcodes[0] = {type: 7, string: [37,120,51,100]};// TLS

    /* RightAngleBracket */
    this.rules[21].opcodes = [];
    this.rules[21].opcodes[0] = {type: 7, string: [37,120,51,101]};// TLS

    /* QuestionMark */
    this.rules[22].opcodes = [];
    this.rules[22].opcodes[0] = {type: 7, string: [37,120,51,102]};// TLS

    /* XSYMBOL */
    this.rules[23].opcodes = [];
    this.rules[23].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]};// ALT
    this.rules[23].opcodes[1] = {type: 4, index: 5};// RNM(DoubleQuote)
    this.rules[23].opcodes[2] = {type: 7, string: [45]};// TLS
    this.rules[23].opcodes[3] = {type: 7, string: [46]};// TLS
    this.rules[23].opcodes[4] = {type: 7, string: [95]};// TLS
    this.rules[23].opcodes[5] = {type: 4, index: 12};// RNM(Exclamation)
    this.rules[23].opcodes[6] = {type: 4, index: 8};// RNM(Percent)
    this.rules[23].opcodes[7] = {type: 4, index: 9};// RNM(Ampersand)
    this.rules[23].opcodes[8] = {type: 4, index: 10};// RNM(Plus)
    this.rules[23].opcodes[9] = {type: 4, index: 11};// RNM(Comma)
    this.rules[23].opcodes[10] = {type: 4, index: 7};// RNM(ForwardSlash)
    this.rules[23].opcodes[11] = {type: 4, index: 15};// RNM(Asterisk)
    this.rules[23].opcodes[12] = {type: 4, index: 13};// RNM(LeftBracket)
    this.rules[23].opcodes[13] = {type: 4, index: 14};// RNM(RightBracket)
    this.rules[23].opcodes[14] = {type: 4, index: 16};// RNM(Apostrophe)
    this.rules[23].opcodes[15] = {type: 4, index: 18};// RNM(Semicolon)
    this.rules[23].opcodes[16] = {type: 4, index: 17};// RNM(Colon)
    this.rules[23].opcodes[17] = {type: 4, index: 19};// RNM(LeftAngleBracket)
    this.rules[23].opcodes[18] = {type: 4, index: 21};// RNM(RightAngleBracket)
    this.rules[23].opcodes[19] = {type: 4, index: 20};// RNM(Equals)
    this.rules[23].opcodes[20] = {type: 4, index: 22};// RNM(QuestionMark)

    /* YSYMBOL */
    this.rules[24].opcodes = [];
    this.rules[24].opcodes[0] = {type: 1, children: [1,2,3]};// ALT
    this.rules[24].opcodes[1] = {type: 7, string: [45]};// TLS
    this.rules[24].opcodes[2] = {type: 4, index: 6};// RNM(Octothorpe)
    this.rules[24].opcodes[3] = {type: 4, index: 7};// RNM(ForwardSlash)

    /* XCHAR */
    this.rules[25].opcodes = [];
    this.rules[25].opcodes[0] = {type: 1, children: [1,2,3,4]};// ALT
    this.rules[25].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[25].opcodes[2] = {type: 4, index: 1};// RNM(UPPERALPHA)
    this.rules[25].opcodes[3] = {type: 4, index: 2};// RNM(LOWERALPHA)
    this.rules[25].opcodes[4] = {type: 4, index: 23};// RNM(XSYMBOL)

    /* YCHAR */
    this.rules[26].opcodes = [];
    this.rules[26].opcodes[0] = {type: 1, children: [1,2,3]};// ALT
    this.rules[26].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[26].opcodes[2] = {type: 4, index: 1};// RNM(UPPERALPHA)
    this.rules[26].opcodes[3] = {type: 4, index: 24};// RNM(YSYMBOL)

    /* gtin-code */
    this.rules[27].opcodes = [];
    this.rules[27].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[27].opcodes[1] = {type: 7, string: [48,49]};// TLS
    this.rules[27].opcodes[2] = {type: 6, string: [103,116,105,110]};// TBS

    /* itip-code */
    this.rules[28].opcodes = [];
    this.rules[28].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[28].opcodes[1] = {type: 7, string: [56,48,48,54]};// TLS
    this.rules[28].opcodes[2] = {type: 6, string: [105,116,105,112]};// TBS

    /* gmn-code */
    this.rules[29].opcodes = [];
    this.rules[29].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[29].opcodes[1] = {type: 7, string: [56,48,49,51]};// TLS
    this.rules[29].opcodes[2] = {type: 6, string: [103,109,110]};// TBS

    /* cpid-code */
    this.rules[30].opcodes = [];
    this.rules[30].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[30].opcodes[1] = {type: 7, string: [56,48,49,48]};// TLS
    this.rules[30].opcodes[2] = {type: 6, string: [99,112,105,100]};// TBS

    /* shipTo-code */
    this.rules[31].opcodes = [];
    this.rules[31].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[31].opcodes[1] = {type: 7, string: [52,49,48]};// TLS
    this.rules[31].opcodes[2] = {type: 6, string: [115,104,105,112,84,111]};// TBS

    /* billTo-code */
    this.rules[32].opcodes = [];
    this.rules[32].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[32].opcodes[1] = {type: 7, string: [52,49,49]};// TLS
    this.rules[32].opcodes[2] = {type: 6, string: [98,105,108,108,84,111]};// TBS

    /* purchasedFrom-code */
    this.rules[33].opcodes = [];
    this.rules[33].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[33].opcodes[1] = {type: 7, string: [52,49,50]};// TLS
    this.rules[33].opcodes[2] = {type: 6, string: [112,117,114,99,104,97,115,101,100,70,114,111,109]};// TBS

    /* shipFor-code */
    this.rules[34].opcodes = [];
    this.rules[34].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[34].opcodes[1] = {type: 7, string: [52,49,51]};// TLS
    this.rules[34].opcodes[2] = {type: 6, string: [115,104,105,112,70,111,114]};// TBS

    /* gln-code */
    this.rules[35].opcodes = [];
    this.rules[35].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[35].opcodes[1] = {type: 7, string: [52,49,52]};// TLS
    this.rules[35].opcodes[2] = {type: 6, string: [103,108,110]};// TBS

    /* payTo-code */
    this.rules[36].opcodes = [];
    this.rules[36].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[36].opcodes[1] = {type: 7, string: [52,49,53]};// TLS
    this.rules[36].opcodes[2] = {type: 6, string: [112,97,121,84,111]};// TBS

    /* glnProd-code */
    this.rules[37].opcodes = [];
    this.rules[37].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[37].opcodes[1] = {type: 7, string: [52,49,54]};// TLS
    this.rules[37].opcodes[2] = {type: 6, string: [103,108,110,80,114,111,100]};// TBS

    /* gsrnp-code */
    this.rules[38].opcodes = [];
    this.rules[38].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[38].opcodes[1] = {type: 7, string: [56,48,49,55]};// TLS
    this.rules[38].opcodes[2] = {type: 6, string: [103,115,114,110,112]};// TBS

    /* gsrn-code */
    this.rules[39].opcodes = [];
    this.rules[39].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[39].opcodes[1] = {type: 7, string: [56,48,49,56]};// TLS
    this.rules[39].opcodes[2] = {type: 6, string: [103,115,114,110]};// TBS

    /* gcn-code */
    this.rules[40].opcodes = [];
    this.rules[40].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[40].opcodes[1] = {type: 7, string: [50,53,53]};// TLS
    this.rules[40].opcodes[2] = {type: 6, string: [103,99,110]};// TBS

    /* sscc-code */
    this.rules[41].opcodes = [];
    this.rules[41].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[41].opcodes[1] = {type: 7, string: [48,48]};// TLS
    this.rules[41].opcodes[2] = {type: 6, string: [115,115,99,99]};// TBS

    /* gdti-code */
    this.rules[42].opcodes = [];
    this.rules[42].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[42].opcodes[1] = {type: 7, string: [50,53,51]};// TLS
    this.rules[42].opcodes[2] = {type: 6, string: [103,100,116,105]};// TBS

    /* ginc-code */
    this.rules[43].opcodes = [];
    this.rules[43].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[43].opcodes[1] = {type: 7, string: [52,48,49]};// TLS
    this.rules[43].opcodes[2] = {type: 6, string: [103,105,110,99]};// TBS

    /* gsin-code */
    this.rules[44].opcodes = [];
    this.rules[44].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[44].opcodes[1] = {type: 7, string: [52,48,50]};// TLS
    this.rules[44].opcodes[2] = {type: 6, string: [103,115,105,110]};// TBS

    /* grai-code */
    this.rules[45].opcodes = [];
    this.rules[45].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[45].opcodes[1] = {type: 7, string: [56,48,48,51]};// TLS
    this.rules[45].opcodes[2] = {type: 6, string: [103,114,97,105]};// TBS

    /* giai-code */
    this.rules[46].opcodes = [];
    this.rules[46].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[46].opcodes[1] = {type: 7, string: [56,48,48,52]};// TLS
    this.rules[46].opcodes[2] = {type: 6, string: [103,105,97,105]};// TBS

    /* cpv-code */
    this.rules[47].opcodes = [];
    this.rules[47].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[47].opcodes[1] = {type: 7, string: [50,50]};// TLS
    this.rules[47].opcodes[2] = {type: 6, string: [99,112,118]};// TBS

    /* lot-code */
    this.rules[48].opcodes = [];
    this.rules[48].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[48].opcodes[1] = {type: 7, string: [49,48]};// TLS
    this.rules[48].opcodes[2] = {type: 6, string: [108,111,116]};// TBS

    /* ser-code */
    this.rules[49].opcodes = [];
    this.rules[49].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[49].opcodes[1] = {type: 7, string: [50,49]};// TLS
    this.rules[49].opcodes[2] = {type: 6, string: [115,101,114]};// TBS

    /* cpsn-code */
    this.rules[50].opcodes = [];
    this.rules[50].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[50].opcodes[1] = {type: 7, string: [56,48,49,49]};// TLS
    this.rules[50].opcodes[2] = {type: 6, string: [99,112,115,110]};// TBS

    /* glnx-code */
    this.rules[51].opcodes = [];
    this.rules[51].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[51].opcodes[1] = {type: 7, string: [50,53,52]};// TLS
    this.rules[51].opcodes[2] = {type: 6, string: [103,108,110,120]};// TBS

    /* refno-code */
    this.rules[52].opcodes = [];
    this.rules[52].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[52].opcodes[1] = {type: 7, string: [56,48,50,48]};// TLS
    this.rules[52].opcodes[2] = {type: 6, string: [114,101,102,110,111]};// TBS

    /* srin-code */
    this.rules[53].opcodes = [];
    this.rules[53].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[53].opcodes[1] = {type: 7, string: [56,48,49,57]};// TLS
    this.rules[53].opcodes[2] = {type: 6, string: [115,114,105,110]};// TBS

    /* gtin-value */
    this.rules[54].opcodes = [];
    this.rules[54].opcodes[0] = {type: 1, children: [1,3,5,7]};// ALT
    this.rules[54].opcodes[1] = {type: 3, min: 14, max: 14};// REP
    this.rules[54].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[54].opcodes[3] = {type: 3, min: 13, max: 13};// REP
    this.rules[54].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[54].opcodes[5] = {type: 3, min: 12, max: 12};// REP
    this.rules[54].opcodes[6] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[54].opcodes[7] = {type: 3, min: 8, max: 8};// REP
    this.rules[54].opcodes[8] = {type: 4, index: 0};// RNM(DIGIT)

    /* itip-value */
    this.rules[55].opcodes = [];
    this.rules[55].opcodes[0] = {type: 2, children: [1,3,5]};// CAT
    this.rules[55].opcodes[1] = {type: 3, min: 14, max: 14};// REP
    this.rules[55].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[55].opcodes[3] = {type: 3, min: 2, max: 2};// REP
    this.rules[55].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[55].opcodes[5] = {type: 3, min: 2, max: 2};// REP
    this.rules[55].opcodes[6] = {type: 4, index: 0};// RNM(DIGIT)

    /* gmn-value */
    this.rules[56].opcodes = [];
    this.rules[56].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[56].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* cpid-value */
    this.rules[57].opcodes = [];
    this.rules[57].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[57].opcodes[1] = {type: 4, index: 26};// RNM(YCHAR)

    /* shipTo-value */
    this.rules[58].opcodes = [];
    this.rules[58].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[58].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* billTo-value */
    this.rules[59].opcodes = [];
    this.rules[59].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[59].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* purchasedFrom-value */
    this.rules[60].opcodes = [];
    this.rules[60].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[60].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* shipFor-value */
    this.rules[61].opcodes = [];
    this.rules[61].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[61].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* gln-value */
    this.rules[62].opcodes = [];
    this.rules[62].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[62].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* payTo-value */
    this.rules[63].opcodes = [];
    this.rules[63].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[63].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* glnProd-value */
    this.rules[64].opcodes = [];
    this.rules[64].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[64].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* gsrnp-value */
    this.rules[65].opcodes = [];
    this.rules[65].opcodes[0] = {type: 3, min: 18, max: 18};// REP
    this.rules[65].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* gsrn-value */
    this.rules[66].opcodes = [];
    this.rules[66].opcodes[0] = {type: 3, min: 18, max: 18};// REP
    this.rules[66].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* gcn-value */
    this.rules[67].opcodes = [];
    this.rules[67].opcodes[0] = {type: 2, children: [1,3]};// CAT
    this.rules[67].opcodes[1] = {type: 3, min: 13, max: 13};// REP
    this.rules[67].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[67].opcodes[3] = {type: 3, min: 1, max: 12};// REP
    this.rules[67].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)

    /* sscc-value */
    this.rules[68].opcodes = [];
    this.rules[68].opcodes[0] = {type: 3, min: 18, max: 18};// REP
    this.rules[68].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* gdti-value */
    this.rules[69].opcodes = [];
    this.rules[69].opcodes[0] = {type: 2, children: [1,3]};// CAT
    this.rules[69].opcodes[1] = {type: 3, min: 13, max: 13};// REP
    this.rules[69].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[69].opcodes[3] = {type: 3, min: 1, max: 17};// REP
    this.rules[69].opcodes[4] = {type: 4, index: 25};// RNM(XCHAR)

    /* ginc-value */
    this.rules[70].opcodes = [];
    this.rules[70].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[70].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* gsin-value */
    this.rules[71].opcodes = [];
    this.rules[71].opcodes[0] = {type: 3, min: 17, max: 17};// REP
    this.rules[71].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* grai-value */
    this.rules[72].opcodes = [];
    this.rules[72].opcodes[0] = {type: 2, children: [1,3]};// CAT
    this.rules[72].opcodes[1] = {type: 3, min: 14, max: 14};// REP
    this.rules[72].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[72].opcodes[3] = {type: 3, min: 1, max: 16};// REP
    this.rules[72].opcodes[4] = {type: 4, index: 25};// RNM(XCHAR)

    /* giai-value */
    this.rules[73].opcodes = [];
    this.rules[73].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[73].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* cpv-value */
    this.rules[74].opcodes = [];
    this.rules[74].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[74].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* lot-value */
    this.rules[75].opcodes = [];
    this.rules[75].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[75].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* ser-value */
    this.rules[76].opcodes = [];
    this.rules[76].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[76].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* cpsn-value */
    this.rules[77].opcodes = [];
    this.rules[77].opcodes[0] = {type: 3, min: 1, max: 12};// REP
    this.rules[77].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* glnx-value */
    this.rules[78].opcodes = [];
    this.rules[78].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[78].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* refno-value */
    this.rules[79].opcodes = [];
    this.rules[79].opcodes[0] = {type: 3, min: 1, max: 25};// REP
    this.rules[79].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* srin-value */
    this.rules[80].opcodes = [];
    this.rules[80].opcodes[0] = {type: 3, min: 1, max: 10};// REP
    this.rules[80].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* gtin-comp */
    this.rules[81].opcodes = [];
    this.rules[81].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[81].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[81].opcodes[2] = {type: 4, index: 27};// RNM(gtin-code)
    this.rules[81].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[81].opcodes[4] = {type: 4, index: 54};// RNM(gtin-value)

    /* itip-comp */
    this.rules[82].opcodes = [];
    this.rules[82].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[82].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[82].opcodes[2] = {type: 4, index: 28};// RNM(itip-code)
    this.rules[82].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[82].opcodes[4] = {type: 4, index: 55};// RNM(itip-value)

    /* gmn-comp */
    this.rules[83].opcodes = [];
    this.rules[83].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[83].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[83].opcodes[2] = {type: 4, index: 29};// RNM(gmn-code)
    this.rules[83].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[83].opcodes[4] = {type: 4, index: 56};// RNM(gmn-value)

    /* cpid-comp */
    this.rules[84].opcodes = [];
    this.rules[84].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[84].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[84].opcodes[2] = {type: 4, index: 30};// RNM(cpid-code)
    this.rules[84].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[84].opcodes[4] = {type: 4, index: 57};// RNM(cpid-value)

    /* shipTo-comp */
    this.rules[85].opcodes = [];
    this.rules[85].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[85].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[85].opcodes[2] = {type: 4, index: 31};// RNM(shipTo-code)
    this.rules[85].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[85].opcodes[4] = {type: 4, index: 58};// RNM(shipTo-value)

    /* billTo-comp */
    this.rules[86].opcodes = [];
    this.rules[86].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[86].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[86].opcodes[2] = {type: 4, index: 32};// RNM(billTo-code)
    this.rules[86].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[86].opcodes[4] = {type: 4, index: 59};// RNM(billTo-value)

    /* purchasedFrom-comp */
    this.rules[87].opcodes = [];
    this.rules[87].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[87].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[87].opcodes[2] = {type: 4, index: 33};// RNM(purchasedFrom-code)
    this.rules[87].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[87].opcodes[4] = {type: 4, index: 60};// RNM(purchasedFrom-value)

    /* shipFor-comp */
    this.rules[88].opcodes = [];
    this.rules[88].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[88].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[88].opcodes[2] = {type: 4, index: 34};// RNM(shipFor-code)
    this.rules[88].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[88].opcodes[4] = {type: 4, index: 61};// RNM(shipFor-value)

    /* gln-comp */
    this.rules[89].opcodes = [];
    this.rules[89].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[89].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[89].opcodes[2] = {type: 4, index: 35};// RNM(gln-code)
    this.rules[89].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[89].opcodes[4] = {type: 4, index: 62};// RNM(gln-value)

    /* payTo-comp */
    this.rules[90].opcodes = [];
    this.rules[90].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[90].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[90].opcodes[2] = {type: 4, index: 36};// RNM(payTo-code)
    this.rules[90].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[90].opcodes[4] = {type: 4, index: 63};// RNM(payTo-value)

    /* glnProd-comp */
    this.rules[91].opcodes = [];
    this.rules[91].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[91].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[91].opcodes[2] = {type: 4, index: 37};// RNM(glnProd-code)
    this.rules[91].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[91].opcodes[4] = {type: 4, index: 64};// RNM(glnProd-value)

    /* gsrnp-comp */
    this.rules[92].opcodes = [];
    this.rules[92].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[92].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[92].opcodes[2] = {type: 4, index: 38};// RNM(gsrnp-code)
    this.rules[92].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[92].opcodes[4] = {type: 4, index: 65};// RNM(gsrnp-value)

    /* gsrn-comp */
    this.rules[93].opcodes = [];
    this.rules[93].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[93].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[93].opcodes[2] = {type: 4, index: 39};// RNM(gsrn-code)
    this.rules[93].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[93].opcodes[4] = {type: 4, index: 66};// RNM(gsrn-value)

    /* gcn-comp */
    this.rules[94].opcodes = [];
    this.rules[94].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[94].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[94].opcodes[2] = {type: 4, index: 40};// RNM(gcn-code)
    this.rules[94].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[94].opcodes[4] = {type: 4, index: 67};// RNM(gcn-value)

    /* sscc-comp */
    this.rules[95].opcodes = [];
    this.rules[95].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[95].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[95].opcodes[2] = {type: 4, index: 41};// RNM(sscc-code)
    this.rules[95].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[95].opcodes[4] = {type: 4, index: 68};// RNM(sscc-value)

    /* gdti-comp */
    this.rules[96].opcodes = [];
    this.rules[96].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[96].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[96].opcodes[2] = {type: 4, index: 42};// RNM(gdti-code)
    this.rules[96].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[96].opcodes[4] = {type: 4, index: 69};// RNM(gdti-value)

    /* ginc-comp */
    this.rules[97].opcodes = [];
    this.rules[97].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[97].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[97].opcodes[2] = {type: 4, index: 43};// RNM(ginc-code)
    this.rules[97].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[97].opcodes[4] = {type: 4, index: 70};// RNM(ginc-value)

    /* gsin-comp */
    this.rules[98].opcodes = [];
    this.rules[98].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[98].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[98].opcodes[2] = {type: 4, index: 44};// RNM(gsin-code)
    this.rules[98].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[98].opcodes[4] = {type: 4, index: 71};// RNM(gsin-value)

    /* grai-comp */
    this.rules[99].opcodes = [];
    this.rules[99].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[99].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[99].opcodes[2] = {type: 4, index: 45};// RNM(grai-code)
    this.rules[99].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[99].opcodes[4] = {type: 4, index: 72};// RNM(grai-value)

    /* giai-comp */
    this.rules[100].opcodes = [];
    this.rules[100].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[100].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[100].opcodes[2] = {type: 4, index: 46};// RNM(giai-code)
    this.rules[100].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[100].opcodes[4] = {type: 4, index: 73};// RNM(giai-value)

    /* cpv-comp */
    this.rules[101].opcodes = [];
    this.rules[101].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[101].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[101].opcodes[2] = {type: 4, index: 47};// RNM(cpv-code)
    this.rules[101].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[101].opcodes[4] = {type: 4, index: 74};// RNM(cpv-value)

    /* lot-comp */
    this.rules[102].opcodes = [];
    this.rules[102].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[102].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[102].opcodes[2] = {type: 4, index: 48};// RNM(lot-code)
    this.rules[102].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[102].opcodes[4] = {type: 4, index: 75};// RNM(lot-value)

    /* ser-comp */
    this.rules[103].opcodes = [];
    this.rules[103].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[103].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[103].opcodes[2] = {type: 4, index: 49};// RNM(ser-code)
    this.rules[103].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[103].opcodes[4] = {type: 4, index: 76};// RNM(ser-value)

    /* cpsn-comp */
    this.rules[104].opcodes = [];
    this.rules[104].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[104].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[104].opcodes[2] = {type: 4, index: 50};// RNM(cpsn-code)
    this.rules[104].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[104].opcodes[4] = {type: 4, index: 77};// RNM(cpsn-value)

    /* glnx-comp */
    this.rules[105].opcodes = [];
    this.rules[105].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[105].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[105].opcodes[2] = {type: 4, index: 51};// RNM(glnx-code)
    this.rules[105].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[105].opcodes[4] = {type: 4, index: 78};// RNM(glnx-value)

    /* refno-comp */
    this.rules[106].opcodes = [];
    this.rules[106].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[106].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[106].opcodes[2] = {type: 4, index: 52};// RNM(refno-code)
    this.rules[106].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[106].opcodes[4] = {type: 4, index: 79};// RNM(refno-value)

    /* srin-comp */
    this.rules[107].opcodes = [];
    this.rules[107].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
    this.rules[107].opcodes[1] = {type: 7, string: [47]};// TLS
    this.rules[107].opcodes[2] = {type: 4, index: 53};// RNM(srin-code)
    this.rules[107].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[107].opcodes[4] = {type: 4, index: 80};// RNM(srin-value)

    /* gtin-path */
    this.rules[108].opcodes = [];
    this.rules[108].opcodes[0] = {type: 2, children: [1,2,4,6]};// CAT
    this.rules[108].opcodes[1] = {type: 4, index: 81};// RNM(gtin-comp)
    this.rules[108].opcodes[2] = {type: 3, min: 0, max: 1};// REP
    this.rules[108].opcodes[3] = {type: 4, index: 101};// RNM(cpv-comp)
    this.rules[108].opcodes[4] = {type: 3, min: 0, max: 1};// REP
    this.rules[108].opcodes[5] = {type: 4, index: 102};// RNM(lot-comp)
    this.rules[108].opcodes[6] = {type: 3, min: 0, max: 1};// REP
    this.rules[108].opcodes[7] = {type: 4, index: 103};// RNM(ser-comp)

    /* itip-path */
    this.rules[109].opcodes = [];
    this.rules[109].opcodes[0] = {type: 2, children: [1,2,4,6]};// CAT
    this.rules[109].opcodes[1] = {type: 4, index: 82};// RNM(itip-comp)
    this.rules[109].opcodes[2] = {type: 3, min: 0, max: 1};// REP
    this.rules[109].opcodes[3] = {type: 4, index: 101};// RNM(cpv-comp)
    this.rules[109].opcodes[4] = {type: 3, min: 0, max: 1};// REP
    this.rules[109].opcodes[5] = {type: 4, index: 102};// RNM(lot-comp)
    this.rules[109].opcodes[6] = {type: 3, min: 0, max: 1};// REP
    this.rules[109].opcodes[7] = {type: 4, index: 103};// RNM(ser-comp)

    /* gmn-path */
    this.rules[110].opcodes = [];
    this.rules[110].opcodes[0] = {type: 4, index: 83};// RNM(gmn-comp)

    /* cpid-path */
    this.rules[111].opcodes = [];
    this.rules[111].opcodes[0] = {type: 2, children: [1,2]};// CAT
    this.rules[111].opcodes[1] = {type: 4, index: 84};// RNM(cpid-comp)
    this.rules[111].opcodes[2] = {type: 3, min: 0, max: 1};// REP
    this.rules[111].opcodes[3] = {type: 4, index: 104};// RNM(cpsn-comp)

    /* shipTo-path */
    this.rules[112].opcodes = [];
    this.rules[112].opcodes[0] = {type: 4, index: 85};// RNM(shipTo-comp)

    /* billTo-path */
    this.rules[113].opcodes = [];
    this.rules[113].opcodes[0] = {type: 4, index: 86};// RNM(billTo-comp)

    /* purchasedFrom-path */
    this.rules[114].opcodes = [];
    this.rules[114].opcodes[0] = {type: 4, index: 87};// RNM(purchasedFrom-comp)

    /* shipFor-path */
    this.rules[115].opcodes = [];
    this.rules[115].opcodes[0] = {type: 4, index: 88};// RNM(shipFor-comp)

    /* gln-path */
    this.rules[116].opcodes = [];
    this.rules[116].opcodes[0] = {type: 2, children: [1,2]};// CAT
    this.rules[116].opcodes[1] = {type: 4, index: 89};// RNM(gln-comp)
    this.rules[116].opcodes[2] = {type: 3, min: 0, max: 1};// REP
    this.rules[116].opcodes[3] = {type: 4, index: 105};// RNM(glnx-comp)

    /* payTo-path */
    this.rules[117].opcodes = [];
    this.rules[117].opcodes[0] = {type: 4, index: 90};// RNM(payTo-comp)

    /* glnProd-path */
    this.rules[118].opcodes = [];
    this.rules[118].opcodes[0] = {type: 4, index: 91};// RNM(glnProd-comp)

    /* gsrnp-path */
    this.rules[119].opcodes = [];
    this.rules[119].opcodes[0] = {type: 2, children: [1,2]};// CAT
    this.rules[119].opcodes[1] = {type: 4, index: 92};// RNM(gsrnp-comp)
    this.rules[119].opcodes[2] = {type: 3, min: 0, max: 1};// REP
    this.rules[119].opcodes[3] = {type: 4, index: 107};// RNM(srin-comp)

    /* gsrn-path */
    this.rules[120].opcodes = [];
    this.rules[120].opcodes[0] = {type: 2, children: [1,2]};// CAT
    this.rules[120].opcodes[1] = {type: 4, index: 93};// RNM(gsrn-comp)
    this.rules[120].opcodes[2] = {type: 3, min: 0, max: 1};// REP
    this.rules[120].opcodes[3] = {type: 4, index: 107};// RNM(srin-comp)

    /* gcn-path */
    this.rules[121].opcodes = [];
    this.rules[121].opcodes[0] = {type: 4, index: 94};// RNM(gcn-comp)

    /* sscc-path */
    this.rules[122].opcodes = [];
    this.rules[122].opcodes[0] = {type: 4, index: 95};// RNM(sscc-comp)

    /* gdti-path */
    this.rules[123].opcodes = [];
    this.rules[123].opcodes[0] = {type: 4, index: 96};// RNM(gdti-comp)

    /* ginc-path */
    this.rules[124].opcodes = [];
    this.rules[124].opcodes[0] = {type: 4, index: 97};// RNM(ginc-comp)

    /* gsin-path */
    this.rules[125].opcodes = [];
    this.rules[125].opcodes[0] = {type: 4, index: 98};// RNM(gsin-comp)

    /* grai-path */
    this.rules[126].opcodes = [];
    this.rules[126].opcodes[0] = {type: 4, index: 99};// RNM(grai-comp)

    /* giai-path */
    this.rules[127].opcodes = [];
    this.rules[127].opcodes[0] = {type: 4, index: 100};// RNM(giai-comp)

    /* gs1path */
    this.rules[128].opcodes = [];
    this.rules[128].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]};// ALT
    this.rules[128].opcodes[1] = {type: 4, index: 108};// RNM(gtin-path)
    this.rules[128].opcodes[2] = {type: 4, index: 109};// RNM(itip-path)
    this.rules[128].opcodes[3] = {type: 4, index: 110};// RNM(gmn-path)
    this.rules[128].opcodes[4] = {type: 4, index: 111};// RNM(cpid-path)
    this.rules[128].opcodes[5] = {type: 4, index: 112};// RNM(shipTo-path)
    this.rules[128].opcodes[6] = {type: 4, index: 113};// RNM(billTo-path)
    this.rules[128].opcodes[7] = {type: 4, index: 114};// RNM(purchasedFrom-path)
    this.rules[128].opcodes[8] = {type: 4, index: 115};// RNM(shipFor-path)
    this.rules[128].opcodes[9] = {type: 4, index: 116};// RNM(gln-path)
    this.rules[128].opcodes[10] = {type: 4, index: 117};// RNM(payTo-path)
    this.rules[128].opcodes[11] = {type: 4, index: 118};// RNM(glnProd-path)
    this.rules[128].opcodes[12] = {type: 4, index: 119};// RNM(gsrnp-path)
    this.rules[128].opcodes[13] = {type: 4, index: 120};// RNM(gsrn-path)
    this.rules[128].opcodes[14] = {type: 4, index: 121};// RNM(gcn-path)
    this.rules[128].opcodes[15] = {type: 4, index: 122};// RNM(sscc-path)
    this.rules[128].opcodes[16] = {type: 4, index: 123};// RNM(gdti-path)
    this.rules[128].opcodes[17] = {type: 4, index: 124};// RNM(ginc-path)
    this.rules[128].opcodes[18] = {type: 4, index: 125};// RNM(gsin-path)
    this.rules[128].opcodes[19] = {type: 4, index: 126};// RNM(grai-path)
    this.rules[128].opcodes[20] = {type: 4, index: 127};// RNM(giai-path)

    /* netWeightVMTICode */
    this.rules[129].opcodes = [];
    this.rules[129].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
    this.rules[129].opcodes[1] = {type: 7, string: [51,49,48,48]};// TLS
    this.rules[129].opcodes[2] = {type: 7, string: [51,49,48,49]};// TLS
    this.rules[129].opcodes[3] = {type: 7, string: [51,49,48,50]};// TLS
    this.rules[129].opcodes[4] = {type: 7, string: [51,49,48,51]};// TLS
    this.rules[129].opcodes[5] = {type: 7, string: [51,49,48,52]};// TLS
    this.rules[129].opcodes[6] = {type: 7, string: [51,49,48,53]};// TLS
    this.rules[129].opcodes[7] = {type: 7, string: [51,50,48,48]};// TLS
    this.rules[129].opcodes[8] = {type: 7, string: [51,50,48,49]};// TLS
    this.rules[129].opcodes[9] = {type: 7, string: [51,50,48,50]};// TLS
    this.rules[129].opcodes[10] = {type: 7, string: [51,50,48,51]};// TLS
    this.rules[129].opcodes[11] = {type: 7, string: [51,50,48,52]};// TLS
    this.rules[129].opcodes[12] = {type: 7, string: [51,50,48,53]};// TLS
    this.rules[129].opcodes[13] = {type: 7, string: [51,53,54,48]};// TLS
    this.rules[129].opcodes[14] = {type: 7, string: [51,53,54,49]};// TLS
    this.rules[129].opcodes[15] = {type: 7, string: [51,53,54,50]};// TLS
    this.rules[129].opcodes[16] = {type: 7, string: [51,53,54,51]};// TLS
    this.rules[129].opcodes[17] = {type: 7, string: [51,53,54,52]};// TLS
    this.rules[129].opcodes[18] = {type: 7, string: [51,53,54,53]};// TLS
    this.rules[129].opcodes[19] = {type: 7, string: [51,53,55,48]};// TLS
    this.rules[129].opcodes[20] = {type: 7, string: [51,53,55,49]};// TLS
    this.rules[129].opcodes[21] = {type: 7, string: [51,53,55,50]};// TLS
    this.rules[129].opcodes[22] = {type: 7, string: [51,53,55,51]};// TLS
    this.rules[129].opcodes[23] = {type: 7, string: [51,53,55,52]};// TLS
    this.rules[129].opcodes[24] = {type: 7, string: [51,53,55,53]};// TLS

    /* netWeightVMTIValue */
    this.rules[130].opcodes = [];
    this.rules[130].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[130].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* netWeightVMTIParameter */
    this.rules[131].opcodes = [];
    this.rules[131].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[131].opcodes[1] = {type: 4, index: 129};// RNM(netWeightVMTICode)
    this.rules[131].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[131].opcodes[3] = {type: 4, index: 130};// RNM(netWeightVMTIValue)

    /* lengthVMTICode */
    this.rules[132].opcodes = [];
    this.rules[132].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
    this.rules[132].opcodes[1] = {type: 7, string: [51,49,49,48]};// TLS
    this.rules[132].opcodes[2] = {type: 7, string: [51,49,49,49]};// TLS
    this.rules[132].opcodes[3] = {type: 7, string: [51,49,49,50]};// TLS
    this.rules[132].opcodes[4] = {type: 7, string: [51,49,49,51]};// TLS
    this.rules[132].opcodes[5] = {type: 7, string: [51,49,49,52]};// TLS
    this.rules[132].opcodes[6] = {type: 7, string: [51,49,49,53]};// TLS
    this.rules[132].opcodes[7] = {type: 7, string: [51,50,49,48]};// TLS
    this.rules[132].opcodes[8] = {type: 7, string: [51,50,49,49]};// TLS
    this.rules[132].opcodes[9] = {type: 7, string: [51,50,49,50]};// TLS
    this.rules[132].opcodes[10] = {type: 7, string: [51,50,49,51]};// TLS
    this.rules[132].opcodes[11] = {type: 7, string: [51,50,49,52]};// TLS
    this.rules[132].opcodes[12] = {type: 7, string: [51,50,49,53]};// TLS
    this.rules[132].opcodes[13] = {type: 7, string: [51,50,50,48]};// TLS
    this.rules[132].opcodes[14] = {type: 7, string: [51,50,50,49]};// TLS
    this.rules[132].opcodes[15] = {type: 7, string: [51,50,50,50]};// TLS
    this.rules[132].opcodes[16] = {type: 7, string: [51,50,50,51]};// TLS
    this.rules[132].opcodes[17] = {type: 7, string: [51,50,50,52]};// TLS
    this.rules[132].opcodes[18] = {type: 7, string: [51,50,50,53]};// TLS
    this.rules[132].opcodes[19] = {type: 7, string: [51,50,51,48]};// TLS
    this.rules[132].opcodes[20] = {type: 7, string: [51,50,51,49]};// TLS
    this.rules[132].opcodes[21] = {type: 7, string: [51,50,51,50]};// TLS
    this.rules[132].opcodes[22] = {type: 7, string: [51,50,51,51]};// TLS
    this.rules[132].opcodes[23] = {type: 7, string: [51,50,51,52]};// TLS
    this.rules[132].opcodes[24] = {type: 7, string: [51,50,51,53]};// TLS

    /* lengthVMTIValue */
    this.rules[133].opcodes = [];
    this.rules[133].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[133].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* lengthVMTIParameter */
    this.rules[134].opcodes = [];
    this.rules[134].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[134].opcodes[1] = {type: 4, index: 132};// RNM(lengthVMTICode)
    this.rules[134].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[134].opcodes[3] = {type: 4, index: 133};// RNM(lengthVMTIValue)

    /* widthVMTICode */
    this.rules[135].opcodes = [];
    this.rules[135].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
    this.rules[135].opcodes[1] = {type: 7, string: [51,49,50,48]};// TLS
    this.rules[135].opcodes[2] = {type: 7, string: [51,49,50,49]};// TLS
    this.rules[135].opcodes[3] = {type: 7, string: [51,49,50,50]};// TLS
    this.rules[135].opcodes[4] = {type: 7, string: [51,49,50,51]};// TLS
    this.rules[135].opcodes[5] = {type: 7, string: [51,49,50,52]};// TLS
    this.rules[135].opcodes[6] = {type: 7, string: [51,49,50,53]};// TLS
    this.rules[135].opcodes[7] = {type: 7, string: [51,50,52,48]};// TLS
    this.rules[135].opcodes[8] = {type: 7, string: [51,50,52,49]};// TLS
    this.rules[135].opcodes[9] = {type: 7, string: [51,50,52,50]};// TLS
    this.rules[135].opcodes[10] = {type: 7, string: [51,50,52,51]};// TLS
    this.rules[135].opcodes[11] = {type: 7, string: [51,50,52,52]};// TLS
    this.rules[135].opcodes[12] = {type: 7, string: [51,50,52,53]};// TLS
    this.rules[135].opcodes[13] = {type: 7, string: [51,50,53,48]};// TLS
    this.rules[135].opcodes[14] = {type: 7, string: [51,50,53,49]};// TLS
    this.rules[135].opcodes[15] = {type: 7, string: [51,50,53,50]};// TLS
    this.rules[135].opcodes[16] = {type: 7, string: [51,50,53,51]};// TLS
    this.rules[135].opcodes[17] = {type: 7, string: [51,50,53,52]};// TLS
    this.rules[135].opcodes[18] = {type: 7, string: [51,50,53,53]};// TLS
    this.rules[135].opcodes[19] = {type: 7, string: [51,50,54,48]};// TLS
    this.rules[135].opcodes[20] = {type: 7, string: [51,50,54,49]};// TLS
    this.rules[135].opcodes[21] = {type: 7, string: [51,50,54,50]};// TLS
    this.rules[135].opcodes[22] = {type: 7, string: [51,50,54,51]};// TLS
    this.rules[135].opcodes[23] = {type: 7, string: [51,50,54,52]};// TLS
    this.rules[135].opcodes[24] = {type: 7, string: [51,50,54,53]};// TLS

    /* widthVMTIValue */
    this.rules[136].opcodes = [];
    this.rules[136].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[136].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* widthVMTIParameter */
    this.rules[137].opcodes = [];
    this.rules[137].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[137].opcodes[1] = {type: 4, index: 135};// RNM(widthVMTICode)
    this.rules[137].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[137].opcodes[3] = {type: 4, index: 136};// RNM(widthVMTIValue)

    /* depthVMTICode */
    this.rules[138].opcodes = [];
    this.rules[138].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
    this.rules[138].opcodes[1] = {type: 7, string: [51,49,51,48]};// TLS
    this.rules[138].opcodes[2] = {type: 7, string: [51,49,51,49]};// TLS
    this.rules[138].opcodes[3] = {type: 7, string: [51,49,51,50]};// TLS
    this.rules[138].opcodes[4] = {type: 7, string: [51,49,51,51]};// TLS
    this.rules[138].opcodes[5] = {type: 7, string: [51,49,51,52]};// TLS
    this.rules[138].opcodes[6] = {type: 7, string: [51,49,51,53]};// TLS
    this.rules[138].opcodes[7] = {type: 7, string: [51,50,55,48]};// TLS
    this.rules[138].opcodes[8] = {type: 7, string: [51,50,55,49]};// TLS
    this.rules[138].opcodes[9] = {type: 7, string: [51,50,55,50]};// TLS
    this.rules[138].opcodes[10] = {type: 7, string: [51,50,55,51]};// TLS
    this.rules[138].opcodes[11] = {type: 7, string: [51,50,55,52]};// TLS
    this.rules[138].opcodes[12] = {type: 7, string: [51,50,55,53]};// TLS
    this.rules[138].opcodes[13] = {type: 7, string: [51,50,56,48]};// TLS
    this.rules[138].opcodes[14] = {type: 7, string: [51,50,56,49]};// TLS
    this.rules[138].opcodes[15] = {type: 7, string: [51,50,56,50]};// TLS
    this.rules[138].opcodes[16] = {type: 7, string: [51,50,56,51]};// TLS
    this.rules[138].opcodes[17] = {type: 7, string: [51,50,56,52]};// TLS
    this.rules[138].opcodes[18] = {type: 7, string: [51,50,56,53]};// TLS
    this.rules[138].opcodes[19] = {type: 7, string: [51,50,57,48]};// TLS
    this.rules[138].opcodes[20] = {type: 7, string: [51,50,57,49]};// TLS
    this.rules[138].opcodes[21] = {type: 7, string: [51,50,57,50]};// TLS
    this.rules[138].opcodes[22] = {type: 7, string: [51,50,57,51]};// TLS
    this.rules[138].opcodes[23] = {type: 7, string: [51,50,57,52]};// TLS
    this.rules[138].opcodes[24] = {type: 7, string: [51,50,57,53]};// TLS

    /* depthVMTIValue */
    this.rules[139].opcodes = [];
    this.rules[139].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[139].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* depthVMTIParameter */
    this.rules[140].opcodes = [];
    this.rules[140].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[140].opcodes[1] = {type: 4, index: 138};// RNM(depthVMTICode)
    this.rules[140].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[140].opcodes[3] = {type: 4, index: 139};// RNM(depthVMTIValue)

    /* areaVMTICode */
    this.rules[141].opcodes = [];
    this.rules[141].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
    this.rules[141].opcodes[1] = {type: 7, string: [51,49,52,48]};// TLS
    this.rules[141].opcodes[2] = {type: 7, string: [51,49,52,49]};// TLS
    this.rules[141].opcodes[3] = {type: 7, string: [51,49,52,50]};// TLS
    this.rules[141].opcodes[4] = {type: 7, string: [51,49,52,51]};// TLS
    this.rules[141].opcodes[5] = {type: 7, string: [51,49,52,52]};// TLS
    this.rules[141].opcodes[6] = {type: 7, string: [51,49,52,53]};// TLS
    this.rules[141].opcodes[7] = {type: 7, string: [51,53,48,48]};// TLS
    this.rules[141].opcodes[8] = {type: 7, string: [51,53,48,49]};// TLS
    this.rules[141].opcodes[9] = {type: 7, string: [51,53,48,50]};// TLS
    this.rules[141].opcodes[10] = {type: 7, string: [51,53,48,51]};// TLS
    this.rules[141].opcodes[11] = {type: 7, string: [51,53,48,52]};// TLS
    this.rules[141].opcodes[12] = {type: 7, string: [51,53,48,53]};// TLS
    this.rules[141].opcodes[13] = {type: 7, string: [51,53,49,48]};// TLS
    this.rules[141].opcodes[14] = {type: 7, string: [51,53,49,49]};// TLS
    this.rules[141].opcodes[15] = {type: 7, string: [51,53,49,50]};// TLS
    this.rules[141].opcodes[16] = {type: 7, string: [51,53,49,51]};// TLS
    this.rules[141].opcodes[17] = {type: 7, string: [51,53,49,52]};// TLS
    this.rules[141].opcodes[18] = {type: 7, string: [51,53,49,53]};// TLS
    this.rules[141].opcodes[19] = {type: 7, string: [51,53,50,48]};// TLS
    this.rules[141].opcodes[20] = {type: 7, string: [51,53,50,49]};// TLS
    this.rules[141].opcodes[21] = {type: 7, string: [51,53,50,50]};// TLS
    this.rules[141].opcodes[22] = {type: 7, string: [51,53,50,51]};// TLS
    this.rules[141].opcodes[23] = {type: 7, string: [51,53,50,52]};// TLS
    this.rules[141].opcodes[24] = {type: 7, string: [51,53,50,53]};// TLS

    /* areaVMTIValue */
    this.rules[142].opcodes = [];
    this.rules[142].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[142].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* areaVMTIParameter */
    this.rules[143].opcodes = [];
    this.rules[143].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[143].opcodes[1] = {type: 4, index: 141};// RNM(areaVMTICode)
    this.rules[143].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[143].opcodes[3] = {type: 4, index: 142};// RNM(areaVMTIValue)

    /* netVolumeVMTICode */
    this.rules[144].opcodes = [];
    this.rules[144].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42]};// ALT
    this.rules[144].opcodes[1] = {type: 7, string: [51,49,53,48]};// TLS
    this.rules[144].opcodes[2] = {type: 7, string: [51,49,53,49]};// TLS
    this.rules[144].opcodes[3] = {type: 7, string: [51,49,53,50]};// TLS
    this.rules[144].opcodes[4] = {type: 7, string: [51,49,53,51]};// TLS
    this.rules[144].opcodes[5] = {type: 7, string: [51,49,53,52]};// TLS
    this.rules[144].opcodes[6] = {type: 7, string: [51,49,53,53]};// TLS
    this.rules[144].opcodes[7] = {type: 7, string: [51,49,54,48]};// TLS
    this.rules[144].opcodes[8] = {type: 7, string: [51,49,54,49]};// TLS
    this.rules[144].opcodes[9] = {type: 7, string: [51,49,54,50]};// TLS
    this.rules[144].opcodes[10] = {type: 7, string: [51,49,54,51]};// TLS
    this.rules[144].opcodes[11] = {type: 7, string: [51,49,54,52]};// TLS
    this.rules[144].opcodes[12] = {type: 7, string: [51,49,54,53]};// TLS
    this.rules[144].opcodes[13] = {type: 7, string: [51,54,48,48]};// TLS
    this.rules[144].opcodes[14] = {type: 7, string: [51,54,48,49]};// TLS
    this.rules[144].opcodes[15] = {type: 7, string: [51,54,48,50]};// TLS
    this.rules[144].opcodes[16] = {type: 7, string: [51,54,48,51]};// TLS
    this.rules[144].opcodes[17] = {type: 7, string: [51,54,48,52]};// TLS
    this.rules[144].opcodes[18] = {type: 7, string: [51,54,48,53]};// TLS
    this.rules[144].opcodes[19] = {type: 7, string: [51,54,49,48]};// TLS
    this.rules[144].opcodes[20] = {type: 7, string: [51,54,49,49]};// TLS
    this.rules[144].opcodes[21] = {type: 7, string: [51,54,49,50]};// TLS
    this.rules[144].opcodes[22] = {type: 7, string: [51,54,49,51]};// TLS
    this.rules[144].opcodes[23] = {type: 7, string: [51,54,49,52]};// TLS
    this.rules[144].opcodes[24] = {type: 7, string: [51,54,49,53]};// TLS
    this.rules[144].opcodes[25] = {type: 7, string: [51,54,52,48]};// TLS
    this.rules[144].opcodes[26] = {type: 7, string: [51,54,52,49]};// TLS
    this.rules[144].opcodes[27] = {type: 7, string: [51,54,52,50]};// TLS
    this.rules[144].opcodes[28] = {type: 7, string: [51,54,52,51]};// TLS
    this.rules[144].opcodes[29] = {type: 7, string: [51,54,52,52]};// TLS
    this.rules[144].opcodes[30] = {type: 7, string: [51,54,52,53]};// TLS
    this.rules[144].opcodes[31] = {type: 7, string: [51,54,53,48]};// TLS
    this.rules[144].opcodes[32] = {type: 7, string: [51,54,53,49]};// TLS
    this.rules[144].opcodes[33] = {type: 7, string: [51,54,53,50]};// TLS
    this.rules[144].opcodes[34] = {type: 7, string: [51,54,53,51]};// TLS
    this.rules[144].opcodes[35] = {type: 7, string: [51,54,53,52]};// TLS
    this.rules[144].opcodes[36] = {type: 7, string: [51,54,53,53]};// TLS
    this.rules[144].opcodes[37] = {type: 7, string: [51,54,54,48]};// TLS
    this.rules[144].opcodes[38] = {type: 7, string: [51,54,54,49]};// TLS
    this.rules[144].opcodes[39] = {type: 7, string: [51,54,54,50]};// TLS
    this.rules[144].opcodes[40] = {type: 7, string: [51,54,54,51]};// TLS
    this.rules[144].opcodes[41] = {type: 7, string: [51,54,54,52]};// TLS
    this.rules[144].opcodes[42] = {type: 7, string: [51,54,54,53]};// TLS

    /* netVolumeVMTIValue */
    this.rules[145].opcodes = [];
    this.rules[145].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[145].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* netVolumeVMTIParameter */
    this.rules[146].opcodes = [];
    this.rules[146].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[146].opcodes[1] = {type: 4, index: 144};// RNM(netVolumeVMTICode)
    this.rules[146].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[146].opcodes[3] = {type: 4, index: 145};// RNM(netVolumeVMTIValue)

    /* massPerUnitAreaVMTICode */
    this.rules[147].opcodes = [];
    this.rules[147].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
    this.rules[147].opcodes[1] = {type: 7, string: [51,51,55,48]};// TLS
    this.rules[147].opcodes[2] = {type: 7, string: [51,51,55,49]};// TLS
    this.rules[147].opcodes[3] = {type: 7, string: [51,51,55,50]};// TLS
    this.rules[147].opcodes[4] = {type: 7, string: [51,51,55,51]};// TLS
    this.rules[147].opcodes[5] = {type: 7, string: [51,51,55,52]};// TLS
    this.rules[147].opcodes[6] = {type: 7, string: [51,51,55,53]};// TLS

    /* massPerUnitAreaVMTIValue */
    this.rules[148].opcodes = [];
    this.rules[148].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[148].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* massPerUnitAreaVMTIParameter */
    this.rules[149].opcodes = [];
    this.rules[149].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[149].opcodes[1] = {type: 4, index: 147};// RNM(massPerUnitAreaVMTICode)
    this.rules[149].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[149].opcodes[3] = {type: 4, index: 148};// RNM(massPerUnitAreaVMTIValue)

    /* grossWeightCode */
    this.rules[150].opcodes = [];
    this.rules[150].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12]};// ALT
    this.rules[150].opcodes[1] = {type: 7, string: [51,51,48,48]};// TLS
    this.rules[150].opcodes[2] = {type: 7, string: [51,51,48,49]};// TLS
    this.rules[150].opcodes[3] = {type: 7, string: [51,51,48,50]};// TLS
    this.rules[150].opcodes[4] = {type: 7, string: [51,51,48,51]};// TLS
    this.rules[150].opcodes[5] = {type: 7, string: [51,51,48,52]};// TLS
    this.rules[150].opcodes[6] = {type: 7, string: [51,51,48,53]};// TLS
    this.rules[150].opcodes[7] = {type: 7, string: [51,52,48,48]};// TLS
    this.rules[150].opcodes[8] = {type: 7, string: [51,52,48,49]};// TLS
    this.rules[150].opcodes[9] = {type: 7, string: [51,52,48,50]};// TLS
    this.rules[150].opcodes[10] = {type: 7, string: [51,52,48,51]};// TLS
    this.rules[150].opcodes[11] = {type: 7, string: [51,52,48,52]};// TLS
    this.rules[150].opcodes[12] = {type: 7, string: [51,52,48,53]};// TLS

    /* grossWeightValue */
    this.rules[151].opcodes = [];
    this.rules[151].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[151].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* grossWeightParameter */
    this.rules[152].opcodes = [];
    this.rules[152].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[152].opcodes[1] = {type: 4, index: 150};// RNM(grossWeightCode)
    this.rules[152].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[152].opcodes[3] = {type: 4, index: 151};// RNM(grossWeightValue)

    /* logisticLengthCode */
    this.rules[153].opcodes = [];
    this.rules[153].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
    this.rules[153].opcodes[1] = {type: 7, string: [51,51,49,48]};// TLS
    this.rules[153].opcodes[2] = {type: 7, string: [51,51,49,49]};// TLS
    this.rules[153].opcodes[3] = {type: 7, string: [51,51,49,50]};// TLS
    this.rules[153].opcodes[4] = {type: 7, string: [51,51,49,51]};// TLS
    this.rules[153].opcodes[5] = {type: 7, string: [51,51,49,52]};// TLS
    this.rules[153].opcodes[6] = {type: 7, string: [51,51,49,53]};// TLS
    this.rules[153].opcodes[7] = {type: 7, string: [51,52,49,48]};// TLS
    this.rules[153].opcodes[8] = {type: 7, string: [51,52,49,49]};// TLS
    this.rules[153].opcodes[9] = {type: 7, string: [51,52,49,50]};// TLS
    this.rules[153].opcodes[10] = {type: 7, string: [51,52,49,51]};// TLS
    this.rules[153].opcodes[11] = {type: 7, string: [51,52,49,52]};// TLS
    this.rules[153].opcodes[12] = {type: 7, string: [51,52,49,53]};// TLS
    this.rules[153].opcodes[13] = {type: 7, string: [51,52,50,48]};// TLS
    this.rules[153].opcodes[14] = {type: 7, string: [51,52,50,49]};// TLS
    this.rules[153].opcodes[15] = {type: 7, string: [51,52,50,50]};// TLS
    this.rules[153].opcodes[16] = {type: 7, string: [51,52,50,51]};// TLS
    this.rules[153].opcodes[17] = {type: 7, string: [51,52,50,52]};// TLS
    this.rules[153].opcodes[18] = {type: 7, string: [51,52,50,53]};// TLS
    this.rules[153].opcodes[19] = {type: 7, string: [51,52,51,48]};// TLS
    this.rules[153].opcodes[20] = {type: 7, string: [51,52,51,49]};// TLS
    this.rules[153].opcodes[21] = {type: 7, string: [51,52,51,50]};// TLS
    this.rules[153].opcodes[22] = {type: 7, string: [51,52,51,51]};// TLS
    this.rules[153].opcodes[23] = {type: 7, string: [51,52,51,52]};// TLS
    this.rules[153].opcodes[24] = {type: 7, string: [51,52,51,53]};// TLS

    /* logisticLengthValue */
    this.rules[154].opcodes = [];
    this.rules[154].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[154].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* logisticLengthParameter */
    this.rules[155].opcodes = [];
    this.rules[155].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[155].opcodes[1] = {type: 4, index: 153};// RNM(logisticLengthCode)
    this.rules[155].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[155].opcodes[3] = {type: 4, index: 154};// RNM(logisticLengthValue)

    /* logisticWidthCode */
    this.rules[156].opcodes = [];
    this.rules[156].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
    this.rules[156].opcodes[1] = {type: 7, string: [51,51,50,48]};// TLS
    this.rules[156].opcodes[2] = {type: 7, string: [51,51,50,49]};// TLS
    this.rules[156].opcodes[3] = {type: 7, string: [51,51,50,50]};// TLS
    this.rules[156].opcodes[4] = {type: 7, string: [51,51,50,51]};// TLS
    this.rules[156].opcodes[5] = {type: 7, string: [51,51,50,52]};// TLS
    this.rules[156].opcodes[6] = {type: 7, string: [51,51,50,53]};// TLS
    this.rules[156].opcodes[7] = {type: 7, string: [51,52,52,48]};// TLS
    this.rules[156].opcodes[8] = {type: 7, string: [51,52,52,49]};// TLS
    this.rules[156].opcodes[9] = {type: 7, string: [51,52,52,50]};// TLS
    this.rules[156].opcodes[10] = {type: 7, string: [51,52,52,51]};// TLS
    this.rules[156].opcodes[11] = {type: 7, string: [51,52,52,52]};// TLS
    this.rules[156].opcodes[12] = {type: 7, string: [51,52,52,53]};// TLS
    this.rules[156].opcodes[13] = {type: 7, string: [51,52,53,48]};// TLS
    this.rules[156].opcodes[14] = {type: 7, string: [51,52,53,49]};// TLS
    this.rules[156].opcodes[15] = {type: 7, string: [51,52,53,50]};// TLS
    this.rules[156].opcodes[16] = {type: 7, string: [51,52,53,51]};// TLS
    this.rules[156].opcodes[17] = {type: 7, string: [51,52,53,52]};// TLS
    this.rules[156].opcodes[18] = {type: 7, string: [51,52,53,53]};// TLS
    this.rules[156].opcodes[19] = {type: 7, string: [51,52,54,48]};// TLS
    this.rules[156].opcodes[20] = {type: 7, string: [51,52,54,49]};// TLS
    this.rules[156].opcodes[21] = {type: 7, string: [51,52,54,50]};// TLS
    this.rules[156].opcodes[22] = {type: 7, string: [51,52,54,51]};// TLS
    this.rules[156].opcodes[23] = {type: 7, string: [51,52,54,52]};// TLS
    this.rules[156].opcodes[24] = {type: 7, string: [51,52,54,53]};// TLS

    /* logisticWidthValue */
    this.rules[157].opcodes = [];
    this.rules[157].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[157].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* logisticWidthParameter */
    this.rules[158].opcodes = [];
    this.rules[158].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[158].opcodes[1] = {type: 4, index: 156};// RNM(logisticWidthCode)
    this.rules[158].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[158].opcodes[3] = {type: 4, index: 157};// RNM(logisticWidthValue)

    /* logisticDepthCode */
    this.rules[159].opcodes = [];
    this.rules[159].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
    this.rules[159].opcodes[1] = {type: 7, string: [51,51,51,48]};// TLS
    this.rules[159].opcodes[2] = {type: 7, string: [51,51,51,49]};// TLS
    this.rules[159].opcodes[3] = {type: 7, string: [51,51,51,50]};// TLS
    this.rules[159].opcodes[4] = {type: 7, string: [51,51,51,51]};// TLS
    this.rules[159].opcodes[5] = {type: 7, string: [51,51,51,52]};// TLS
    this.rules[159].opcodes[6] = {type: 7, string: [51,51,51,53]};// TLS
    this.rules[159].opcodes[7] = {type: 7, string: [51,52,55,48]};// TLS
    this.rules[159].opcodes[8] = {type: 7, string: [51,52,55,49]};// TLS
    this.rules[159].opcodes[9] = {type: 7, string: [51,52,55,50]};// TLS
    this.rules[159].opcodes[10] = {type: 7, string: [51,52,55,51]};// TLS
    this.rules[159].opcodes[11] = {type: 7, string: [51,52,55,52]};// TLS
    this.rules[159].opcodes[12] = {type: 7, string: [51,52,55,53]};// TLS
    this.rules[159].opcodes[13] = {type: 7, string: [51,52,56,48]};// TLS
    this.rules[159].opcodes[14] = {type: 7, string: [51,52,56,49]};// TLS
    this.rules[159].opcodes[15] = {type: 7, string: [51,52,56,50]};// TLS
    this.rules[159].opcodes[16] = {type: 7, string: [51,52,56,51]};// TLS
    this.rules[159].opcodes[17] = {type: 7, string: [51,52,56,52]};// TLS
    this.rules[159].opcodes[18] = {type: 7, string: [51,52,56,53]};// TLS
    this.rules[159].opcodes[19] = {type: 7, string: [51,52,57,48]};// TLS
    this.rules[159].opcodes[20] = {type: 7, string: [51,52,57,49]};// TLS
    this.rules[159].opcodes[21] = {type: 7, string: [51,52,57,50]};// TLS
    this.rules[159].opcodes[22] = {type: 7, string: [51,52,57,51]};// TLS
    this.rules[159].opcodes[23] = {type: 7, string: [51,52,57,52]};// TLS
    this.rules[159].opcodes[24] = {type: 7, string: [51,52,57,53]};// TLS

    /* logisticDepthValue */
    this.rules[160].opcodes = [];
    this.rules[160].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[160].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* logisticDepthParameter */
    this.rules[161].opcodes = [];
    this.rules[161].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[161].opcodes[1] = {type: 4, index: 159};// RNM(logisticDepthCode)
    this.rules[161].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[161].opcodes[3] = {type: 4, index: 160};// RNM(logisticDepthValue)

    /* logisticAreaCode */
    this.rules[162].opcodes = [];
    this.rules[162].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
    this.rules[162].opcodes[1] = {type: 7, string: [51,51,52,48]};// TLS
    this.rules[162].opcodes[2] = {type: 7, string: [51,51,52,49]};// TLS
    this.rules[162].opcodes[3] = {type: 7, string: [51,51,52,50]};// TLS
    this.rules[162].opcodes[4] = {type: 7, string: [51,51,52,51]};// TLS
    this.rules[162].opcodes[5] = {type: 7, string: [51,51,52,52]};// TLS
    this.rules[162].opcodes[6] = {type: 7, string: [51,51,52,53]};// TLS
    this.rules[162].opcodes[7] = {type: 7, string: [51,53,51,48]};// TLS
    this.rules[162].opcodes[8] = {type: 7, string: [51,53,51,49]};// TLS
    this.rules[162].opcodes[9] = {type: 7, string: [51,53,51,50]};// TLS
    this.rules[162].opcodes[10] = {type: 7, string: [51,53,51,51]};// TLS
    this.rules[162].opcodes[11] = {type: 7, string: [51,53,51,52]};// TLS
    this.rules[162].opcodes[12] = {type: 7, string: [51,53,51,53]};// TLS
    this.rules[162].opcodes[13] = {type: 7, string: [51,53,52,48]};// TLS
    this.rules[162].opcodes[14] = {type: 7, string: [51,53,52,49]};// TLS
    this.rules[162].opcodes[15] = {type: 7, string: [51,53,52,50]};// TLS
    this.rules[162].opcodes[16] = {type: 7, string: [51,53,52,51]};// TLS
    this.rules[162].opcodes[17] = {type: 7, string: [51,53,52,52]};// TLS
    this.rules[162].opcodes[18] = {type: 7, string: [51,53,52,53]};// TLS
    this.rules[162].opcodes[19] = {type: 7, string: [51,53,53,48]};// TLS
    this.rules[162].opcodes[20] = {type: 7, string: [51,53,53,49]};// TLS
    this.rules[162].opcodes[21] = {type: 7, string: [51,53,53,50]};// TLS
    this.rules[162].opcodes[22] = {type: 7, string: [51,53,53,51]};// TLS
    this.rules[162].opcodes[23] = {type: 7, string: [51,53,53,52]};// TLS
    this.rules[162].opcodes[24] = {type: 7, string: [51,53,53,53]};// TLS

    /* logisticAreaValue */
    this.rules[163].opcodes = [];
    this.rules[163].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[163].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* logisticAreaParameter */
    this.rules[164].opcodes = [];
    this.rules[164].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[164].opcodes[1] = {type: 4, index: 162};// RNM(logisticAreaCode)
    this.rules[164].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[164].opcodes[3] = {type: 4, index: 163};// RNM(logisticAreaValue)

    /* logisticVolumeCode */
    this.rules[165].opcodes = [];
    this.rules[165].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42]};// ALT
    this.rules[165].opcodes[1] = {type: 7, string: [51,51,53,48]};// TLS
    this.rules[165].opcodes[2] = {type: 7, string: [51,51,53,49]};// TLS
    this.rules[165].opcodes[3] = {type: 7, string: [51,51,53,50]};// TLS
    this.rules[165].opcodes[4] = {type: 7, string: [51,51,53,51]};// TLS
    this.rules[165].opcodes[5] = {type: 7, string: [51,51,53,52]};// TLS
    this.rules[165].opcodes[6] = {type: 7, string: [51,51,53,53]};// TLS
    this.rules[165].opcodes[7] = {type: 7, string: [51,51,54,48]};// TLS
    this.rules[165].opcodes[8] = {type: 7, string: [51,51,54,49]};// TLS
    this.rules[165].opcodes[9] = {type: 7, string: [51,51,54,50]};// TLS
    this.rules[165].opcodes[10] = {type: 7, string: [51,51,54,51]};// TLS
    this.rules[165].opcodes[11] = {type: 7, string: [51,51,54,52]};// TLS
    this.rules[165].opcodes[12] = {type: 7, string: [51,51,54,53]};// TLS
    this.rules[165].opcodes[13] = {type: 7, string: [51,54,50,48]};// TLS
    this.rules[165].opcodes[14] = {type: 7, string: [51,54,50,49]};// TLS
    this.rules[165].opcodes[15] = {type: 7, string: [51,54,50,50]};// TLS
    this.rules[165].opcodes[16] = {type: 7, string: [51,54,50,51]};// TLS
    this.rules[165].opcodes[17] = {type: 7, string: [51,54,50,52]};// TLS
    this.rules[165].opcodes[18] = {type: 7, string: [51,54,50,53]};// TLS
    this.rules[165].opcodes[19] = {type: 7, string: [51,54,51,48]};// TLS
    this.rules[165].opcodes[20] = {type: 7, string: [51,54,51,49]};// TLS
    this.rules[165].opcodes[21] = {type: 7, string: [51,54,51,50]};// TLS
    this.rules[165].opcodes[22] = {type: 7, string: [51,54,51,51]};// TLS
    this.rules[165].opcodes[23] = {type: 7, string: [51,54,51,52]};// TLS
    this.rules[165].opcodes[24] = {type: 7, string: [51,54,51,53]};// TLS
    this.rules[165].opcodes[25] = {type: 7, string: [51,54,55,48]};// TLS
    this.rules[165].opcodes[26] = {type: 7, string: [51,54,55,49]};// TLS
    this.rules[165].opcodes[27] = {type: 7, string: [51,54,55,50]};// TLS
    this.rules[165].opcodes[28] = {type: 7, string: [51,54,55,51]};// TLS
    this.rules[165].opcodes[29] = {type: 7, string: [51,54,55,52]};// TLS
    this.rules[165].opcodes[30] = {type: 7, string: [51,54,55,53]};// TLS
    this.rules[165].opcodes[31] = {type: 7, string: [51,54,56,48]};// TLS
    this.rules[165].opcodes[32] = {type: 7, string: [51,54,56,49]};// TLS
    this.rules[165].opcodes[33] = {type: 7, string: [51,54,56,50]};// TLS
    this.rules[165].opcodes[34] = {type: 7, string: [51,54,56,51]};// TLS
    this.rules[165].opcodes[35] = {type: 7, string: [51,54,56,52]};// TLS
    this.rules[165].opcodes[36] = {type: 7, string: [51,54,56,53]};// TLS
    this.rules[165].opcodes[37] = {type: 7, string: [51,54,57,48]};// TLS
    this.rules[165].opcodes[38] = {type: 7, string: [51,54,57,49]};// TLS
    this.rules[165].opcodes[39] = {type: 7, string: [51,54,57,50]};// TLS
    this.rules[165].opcodes[40] = {type: 7, string: [51,54,57,51]};// TLS
    this.rules[165].opcodes[41] = {type: 7, string: [51,54,57,52]};// TLS
    this.rules[165].opcodes[42] = {type: 7, string: [51,54,57,53]};// TLS

    /* logisticVolumeValue */
    this.rules[166].opcodes = [];
    this.rules[166].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[166].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* logisticVolumeParameter */
    this.rules[167].opcodes = [];
    this.rules[167].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[167].opcodes[1] = {type: 4, index: 165};// RNM(logisticVolumeCode)
    this.rules[167].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[167].opcodes[3] = {type: 4, index: 166};// RNM(logisticVolumeValue)

    /* processorCode */
    this.rules[168].opcodes = [];
    this.rules[168].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10]};// ALT
    this.rules[168].opcodes[1] = {type: 7, string: [55,48,51,48]};// TLS
    this.rules[168].opcodes[2] = {type: 7, string: [55,48,51,49]};// TLS
    this.rules[168].opcodes[3] = {type: 7, string: [55,48,51,50]};// TLS
    this.rules[168].opcodes[4] = {type: 7, string: [55,48,51,51]};// TLS
    this.rules[168].opcodes[5] = {type: 7, string: [55,48,51,52]};// TLS
    this.rules[168].opcodes[6] = {type: 7, string: [55,48,51,53]};// TLS
    this.rules[168].opcodes[7] = {type: 7, string: [55,48,51,54]};// TLS
    this.rules[168].opcodes[8] = {type: 7, string: [55,48,51,55]};// TLS
    this.rules[168].opcodes[9] = {type: 7, string: [55,48,51,56]};// TLS
    this.rules[168].opcodes[10] = {type: 7, string: [55,48,51,57]};// TLS

    /* processorValue */
    this.rules[169].opcodes = [];
    this.rules[169].opcodes[0] = {type: 2, children: [1,3]};// CAT
    this.rules[169].opcodes[1] = {type: 3, min: 3, max: 3};// REP
    this.rules[169].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[169].opcodes[3] = {type: 3, min: 1, max: 27};// REP
    this.rules[169].opcodes[4] = {type: 4, index: 25};// RNM(XCHAR)

    /* processorParameter */
    this.rules[170].opcodes = [];
    this.rules[170].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[170].opcodes[1] = {type: 4, index: 168};// RNM(processorCode)
    this.rules[170].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[170].opcodes[3] = {type: 4, index: 169};// RNM(processorValue)

    /* contentCode */
    this.rules[171].opcodes = [];
    this.rules[171].opcodes[0] = {type: 7, string: [48,50]};// TLS

    /* contentValue */
    this.rules[172].opcodes = [];
    this.rules[172].opcodes[0] = {type: 3, min: 14, max: 14};// REP
    this.rules[172].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* contentParameter */
    this.rules[173].opcodes = [];
    this.rules[173].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[173].opcodes[1] = {type: 4, index: 171};// RNM(contentCode)
    this.rules[173].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[173].opcodes[3] = {type: 4, index: 172};// RNM(contentValue)

    /* prodDateCode */
    this.rules[174].opcodes = [];
    this.rules[174].opcodes[0] = {type: 7, string: [49,49]};// TLS

    /* prodDateValue */
    this.rules[175].opcodes = [];
    this.rules[175].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[175].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* prodDateParameter */
    this.rules[176].opcodes = [];
    this.rules[176].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[176].opcodes[1] = {type: 4, index: 174};// RNM(prodDateCode)
    this.rules[176].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[176].opcodes[3] = {type: 4, index: 175};// RNM(prodDateValue)

    /* dueDateCode */
    this.rules[177].opcodes = [];
    this.rules[177].opcodes[0] = {type: 7, string: [49,50]};// TLS

    /* dueDateValue */
    this.rules[178].opcodes = [];
    this.rules[178].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[178].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* dueDateParameter */
    this.rules[179].opcodes = [];
    this.rules[179].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[179].opcodes[1] = {type: 4, index: 177};// RNM(dueDateCode)
    this.rules[179].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[179].opcodes[3] = {type: 4, index: 178};// RNM(dueDateValue)

    /* packDateCode */
    this.rules[180].opcodes = [];
    this.rules[180].opcodes[0] = {type: 7, string: [49,51]};// TLS

    /* packDateValue */
    this.rules[181].opcodes = [];
    this.rules[181].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[181].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* packDateParameter */
    this.rules[182].opcodes = [];
    this.rules[182].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[182].opcodes[1] = {type: 4, index: 180};// RNM(packDateCode)
    this.rules[182].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[182].opcodes[3] = {type: 4, index: 181};// RNM(packDateValue)

    /* bestBeforeDateCode */
    this.rules[183].opcodes = [];
    this.rules[183].opcodes[0] = {type: 7, string: [49,53]};// TLS

    /* bestBeforeDateValue */
    this.rules[184].opcodes = [];
    this.rules[184].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[184].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* bestBeforeDateParameter */
    this.rules[185].opcodes = [];
    this.rules[185].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[185].opcodes[1] = {type: 4, index: 183};// RNM(bestBeforeDateCode)
    this.rules[185].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[185].opcodes[3] = {type: 4, index: 184};// RNM(bestBeforeDateValue)

    /* sellByDateCode */
    this.rules[186].opcodes = [];
    this.rules[186].opcodes[0] = {type: 7, string: [49,54]};// TLS

    /* sellByDateValue */
    this.rules[187].opcodes = [];
    this.rules[187].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[187].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* sellByDateParameter */
    this.rules[188].opcodes = [];
    this.rules[188].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[188].opcodes[1] = {type: 4, index: 186};// RNM(sellByDateCode)
    this.rules[188].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[188].opcodes[3] = {type: 4, index: 187};// RNM(sellByDateValue)

    /* firstFreezeDateCode */
    this.rules[189].opcodes = [];
    this.rules[189].opcodes[0] = {type: 7, string: [55,48,48,54]};// TLS

    /* firstFreezeDateValue */
    this.rules[190].opcodes = [];
    this.rules[190].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[190].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* firstFreezeDateParameter */
    this.rules[191].opcodes = [];
    this.rules[191].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[191].opcodes[1] = {type: 4, index: 189};// RNM(firstFreezeDateCode)
    this.rules[191].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[191].opcodes[3] = {type: 4, index: 190};// RNM(firstFreezeDateValue)

    /* harvestDateCode */
    this.rules[192].opcodes = [];
    this.rules[192].opcodes[0] = {type: 7, string: [55,48,48,55]};// TLS

    /* harvestDateValue */
    this.rules[193].opcodes = [];
    this.rules[193].opcodes[0] = {type: 3, min: 6, max: 12};// REP
    this.rules[193].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* harvestDateParameter */
    this.rules[194].opcodes = [];
    this.rules[194].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[194].opcodes[1] = {type: 4, index: 192};// RNM(harvestDateCode)
    this.rules[194].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[194].opcodes[3] = {type: 4, index: 193};// RNM(harvestDateValue)

    /* pricePerUnitCode */
    this.rules[195].opcodes = [];
    this.rules[195].opcodes[0] = {type: 7, string: [56,48,48,53]};// TLS

    /* pricePerUnitValue */
    this.rules[196].opcodes = [];
    this.rules[196].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[196].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* pricePerUnitParameter */
    this.rules[197].opcodes = [];
    this.rules[197].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[197].opcodes[1] = {type: 4, index: 195};// RNM(pricePerUnitCode)
    this.rules[197].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[197].opcodes[3] = {type: 4, index: 196};// RNM(pricePerUnitValue)

    /* variantCode */
    this.rules[198].opcodes = [];
    this.rules[198].opcodes[0] = {type: 7, string: [50,48]};// TLS

    /* variantValue */
    this.rules[199].opcodes = [];
    this.rules[199].opcodes[0] = {type: 3, min: 2, max: 2};// REP
    this.rules[199].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* variantParameter */
    this.rules[200].opcodes = [];
    this.rules[200].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[200].opcodes[1] = {type: 4, index: 198};// RNM(variantCode)
    this.rules[200].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[200].opcodes[3] = {type: 4, index: 199};// RNM(variantValue)

    /* varCountCode */
    this.rules[201].opcodes = [];
    this.rules[201].opcodes[0] = {type: 7, string: [51,48]};// TLS

    /* varCountValue */
    this.rules[202].opcodes = [];
    this.rules[202].opcodes[0] = {type: 3, min: 1, max: 8};// REP
    this.rules[202].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* varCountParameter */
    this.rules[203].opcodes = [];
    this.rules[203].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[203].opcodes[1] = {type: 4, index: 201};// RNM(varCountCode)
    this.rules[203].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[203].opcodes[3] = {type: 4, index: 202};// RNM(varCountValue)

    /* countCode */
    this.rules[204].opcodes = [];
    this.rules[204].opcodes[0] = {type: 7, string: [51,55]};// TLS

    /* countValue */
    this.rules[205].opcodes = [];
    this.rules[205].opcodes[0] = {type: 3, min: 1, max: 8};// REP
    this.rules[205].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* countParameter */
    this.rules[206].opcodes = [];
    this.rules[206].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[206].opcodes[1] = {type: 4, index: 204};// RNM(countCode)
    this.rules[206].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[206].opcodes[3] = {type: 4, index: 205};// RNM(countValue)

    /* mutualCode */
    this.rules[207].opcodes = [];
    this.rules[207].opcodes[0] = {type: 7, string: [57,48]};// TLS

    /* mutualValue */
    this.rules[208].opcodes = [];
    this.rules[208].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[208].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* mutualParameter */
    this.rules[209].opcodes = [];
    this.rules[209].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[209].opcodes[1] = {type: 4, index: 207};// RNM(mutualCode)
    this.rules[209].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[209].opcodes[3] = {type: 4, index: 208};// RNM(mutualValue)

    /* additionalIdCode */
    this.rules[210].opcodes = [];
    this.rules[210].opcodes[0] = {type: 7, string: [50,52,48]};// TLS

    /* additionalIdValue */
    this.rules[211].opcodes = [];
    this.rules[211].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[211].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* additionalIdParameter */
    this.rules[212].opcodes = [];
    this.rules[212].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[212].opcodes[1] = {type: 4, index: 210};// RNM(additionalIdCode)
    this.rules[212].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[212].opcodes[3] = {type: 4, index: 211};// RNM(additionalIdValue)

    /* custPartNoCode */
    this.rules[213].opcodes = [];
    this.rules[213].opcodes[0] = {type: 7, string: [50,52,49]};// TLS

    /* custPartNoValue */
    this.rules[214].opcodes = [];
    this.rules[214].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[214].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* custPartNoParameter */
    this.rules[215].opcodes = [];
    this.rules[215].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[215].opcodes[1] = {type: 4, index: 213};// RNM(custPartNoCode)
    this.rules[215].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[215].opcodes[3] = {type: 4, index: 214};// RNM(custPartNoValue)

    /* mtoVariantCode */
    this.rules[216].opcodes = [];
    this.rules[216].opcodes[0] = {type: 7, string: [50,52,50]};// TLS

    /* mtoVariantValue */
    this.rules[217].opcodes = [];
    this.rules[217].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[217].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* mtoVariantParameter */
    this.rules[218].opcodes = [];
    this.rules[218].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[218].opcodes[1] = {type: 4, index: 216};// RNM(mtoVariantCode)
    this.rules[218].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[218].opcodes[3] = {type: 4, index: 217};// RNM(mtoVariantValue)

    /* pcnCode */
    this.rules[219].opcodes = [];
    this.rules[219].opcodes[0] = {type: 7, string: [50,52,51]};// TLS

    /* pcnValue */
    this.rules[220].opcodes = [];
    this.rules[220].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[220].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* pcnParameter */
    this.rules[221].opcodes = [];
    this.rules[221].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[221].opcodes[1] = {type: 4, index: 219};// RNM(pcnCode)
    this.rules[221].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[221].opcodes[3] = {type: 4, index: 220};// RNM(pcnValue)

    /* secondarySerialCode */
    this.rules[222].opcodes = [];
    this.rules[222].opcodes[0] = {type: 7, string: [50,53,48]};// TLS

    /* secondarySerialValue */
    this.rules[223].opcodes = [];
    this.rules[223].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[223].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* secondarySerialParameter */
    this.rules[224].opcodes = [];
    this.rules[224].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[224].opcodes[1] = {type: 4, index: 222};// RNM(secondarySerialCode)
    this.rules[224].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[224].opcodes[3] = {type: 4, index: 223};// RNM(secondarySerialValue)

    /* refToSourceCode */
    this.rules[225].opcodes = [];
    this.rules[225].opcodes[0] = {type: 7, string: [50,53,49]};// TLS

    /* refToSourceValue */
    this.rules[226].opcodes = [];
    this.rules[226].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[226].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* refToSourceParameter */
    this.rules[227].opcodes = [];
    this.rules[227].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[227].opcodes[1] = {type: 4, index: 225};// RNM(refToSourceCode)
    this.rules[227].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[227].opcodes[3] = {type: 4, index: 226};// RNM(refToSourceValue)

    /* amountCode */
    this.rules[228].opcodes = [];
    this.rules[228].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
    this.rules[228].opcodes[1] = {type: 7, string: [51,57,48,48]};// TLS
    this.rules[228].opcodes[2] = {type: 7, string: [51,57,48,49]};// TLS
    this.rules[228].opcodes[3] = {type: 7, string: [51,57,48,50]};// TLS
    this.rules[228].opcodes[4] = {type: 7, string: [51,57,48,51]};// TLS
    this.rules[228].opcodes[5] = {type: 7, string: [51,57,48,52]};// TLS
    this.rules[228].opcodes[6] = {type: 7, string: [51,57,48,53]};// TLS

    /* amountValue */
    this.rules[229].opcodes = [];
    this.rules[229].opcodes[0] = {type: 3, min: 1, max: 15};// REP
    this.rules[229].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* amountParameter */
    this.rules[230].opcodes = [];
    this.rules[230].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[230].opcodes[1] = {type: 4, index: 228};// RNM(amountCode)
    this.rules[230].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[230].opcodes[3] = {type: 4, index: 229};// RNM(amountValue)

    /* amountISOCode */
    this.rules[231].opcodes = [];
    this.rules[231].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
    this.rules[231].opcodes[1] = {type: 7, string: [51,57,49,48]};// TLS
    this.rules[231].opcodes[2] = {type: 7, string: [51,57,49,49]};// TLS
    this.rules[231].opcodes[3] = {type: 7, string: [51,57,49,50]};// TLS
    this.rules[231].opcodes[4] = {type: 7, string: [51,57,49,51]};// TLS
    this.rules[231].opcodes[5] = {type: 7, string: [51,57,49,52]};// TLS
    this.rules[231].opcodes[6] = {type: 7, string: [51,57,49,53]};// TLS

    /* amountISOValue */
    this.rules[232].opcodes = [];
    this.rules[232].opcodes[0] = {type: 2, children: [1,3]};// CAT
    this.rules[232].opcodes[1] = {type: 3, min: 3, max: 3};// REP
    this.rules[232].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[232].opcodes[3] = {type: 3, min: 1, max: 15};// REP
    this.rules[232].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)

    /* amountISOParameter */
    this.rules[233].opcodes = [];
    this.rules[233].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[233].opcodes[1] = {type: 4, index: 231};// RNM(amountISOCode)
    this.rules[233].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[233].opcodes[3] = {type: 4, index: 232};// RNM(amountISOValue)

    /* priceCode */
    this.rules[234].opcodes = [];
    this.rules[234].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
    this.rules[234].opcodes[1] = {type: 7, string: [51,57,50,48]};// TLS
    this.rules[234].opcodes[2] = {type: 7, string: [51,57,50,49]};// TLS
    this.rules[234].opcodes[3] = {type: 7, string: [51,57,50,50]};// TLS
    this.rules[234].opcodes[4] = {type: 7, string: [51,57,50,51]};// TLS
    this.rules[234].opcodes[5] = {type: 7, string: [51,57,50,52]};// TLS
    this.rules[234].opcodes[6] = {type: 7, string: [51,57,50,53]};// TLS

    /* priceValue */
    this.rules[235].opcodes = [];
    this.rules[235].opcodes[0] = {type: 3, min: 1, max: 15};// REP
    this.rules[235].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* priceParameter */
    this.rules[236].opcodes = [];
    this.rules[236].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[236].opcodes[1] = {type: 4, index: 234};// RNM(priceCode)
    this.rules[236].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[236].opcodes[3] = {type: 4, index: 235};// RNM(priceValue)

    /* priceISOCode */
    this.rules[237].opcodes = [];
    this.rules[237].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
    this.rules[237].opcodes[1] = {type: 7, string: [51,57,51,48]};// TLS
    this.rules[237].opcodes[2] = {type: 7, string: [51,57,51,49]};// TLS
    this.rules[237].opcodes[3] = {type: 7, string: [51,57,51,50]};// TLS
    this.rules[237].opcodes[4] = {type: 7, string: [51,57,51,51]};// TLS
    this.rules[237].opcodes[5] = {type: 7, string: [51,57,51,52]};// TLS
    this.rules[237].opcodes[6] = {type: 7, string: [51,57,51,53]};// TLS

    /* priceISOValue */
    this.rules[238].opcodes = [];
    this.rules[238].opcodes[0] = {type: 2, children: [1,3]};// CAT
    this.rules[238].opcodes[1] = {type: 3, min: 3, max: 3};// REP
    this.rules[238].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[238].opcodes[3] = {type: 3, min: 1, max: 15};// REP
    this.rules[238].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)

    /* priceISOParameter */
    this.rules[239].opcodes = [];
    this.rules[239].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[239].opcodes[1] = {type: 4, index: 237};// RNM(priceISOCode)
    this.rules[239].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[239].opcodes[3] = {type: 4, index: 238};// RNM(priceISOValue)

    /* percentOffCode */
    this.rules[240].opcodes = [];
    this.rules[240].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
    this.rules[240].opcodes[1] = {type: 7, string: [51,57,52,48]};// TLS
    this.rules[240].opcodes[2] = {type: 7, string: [51,57,52,49]};// TLS
    this.rules[240].opcodes[3] = {type: 7, string: [51,57,52,50]};// TLS
    this.rules[240].opcodes[4] = {type: 7, string: [51,57,52,51]};// TLS
    this.rules[240].opcodes[5] = {type: 7, string: [51,57,52,52]};// TLS
    this.rules[240].opcodes[6] = {type: 7, string: [51,57,52,53]};// TLS

    /* percentOffValue */
    this.rules[241].opcodes = [];
    this.rules[241].opcodes[0] = {type: 3, min: 4, max: 4};// REP
    this.rules[241].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* percentOffParameter */
    this.rules[242].opcodes = [];
    this.rules[242].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[242].opcodes[1] = {type: 4, index: 240};// RNM(percentOffCode)
    this.rules[242].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[242].opcodes[3] = {type: 4, index: 241};// RNM(percentOffValue)

    /* orderNumberCode */
    this.rules[243].opcodes = [];
    this.rules[243].opcodes[0] = {type: 7, string: [52,48,48]};// TLS

    /* orderNumberValue */
    this.rules[244].opcodes = [];
    this.rules[244].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[244].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* orderNumberParameter */
    this.rules[245].opcodes = [];
    this.rules[245].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[245].opcodes[1] = {type: 4, index: 243};// RNM(orderNumberCode)
    this.rules[245].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[245].opcodes[3] = {type: 4, index: 244};// RNM(orderNumberValue)

    /* routeCode */
    this.rules[246].opcodes = [];
    this.rules[246].opcodes[0] = {type: 7, string: [52,48,51]};// TLS

    /* routeValue */
    this.rules[247].opcodes = [];
    this.rules[247].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[247].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* routeParameter */
    this.rules[248].opcodes = [];
    this.rules[248].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[248].opcodes[1] = {type: 4, index: 246};// RNM(routeCode)
    this.rules[248].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[248].opcodes[3] = {type: 4, index: 247};// RNM(routeValue)

    /* shipToLocCode */
    this.rules[249].opcodes = [];
    this.rules[249].opcodes[0] = {type: 7, string: [52,49,48]};// TLS

    /* shipToLocValue */
    this.rules[250].opcodes = [];
    this.rules[250].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[250].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* shipToLocParameter */
    this.rules[251].opcodes = [];
    this.rules[251].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[251].opcodes[1] = {type: 4, index: 249};// RNM(shipToLocCode)
    this.rules[251].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[251].opcodes[3] = {type: 4, index: 250};// RNM(shipToLocValue)

    /* billToCode */
    this.rules[252].opcodes = [];
    this.rules[252].opcodes[0] = {type: 7, string: [52,49,49]};// TLS

    /* billToValue */
    this.rules[253].opcodes = [];
    this.rules[253].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[253].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* billToParameter */
    this.rules[254].opcodes = [];
    this.rules[254].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[254].opcodes[1] = {type: 4, index: 252};// RNM(billToCode)
    this.rules[254].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[254].opcodes[3] = {type: 4, index: 253};// RNM(billToValue)

    /* purchaseFromCode */
    this.rules[255].opcodes = [];
    this.rules[255].opcodes[0] = {type: 7, string: [52,49,50]};// TLS

    /* purchaseFromValue */
    this.rules[256].opcodes = [];
    this.rules[256].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[256].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* purchaseFromParameter */
    this.rules[257].opcodes = [];
    this.rules[257].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[257].opcodes[1] = {type: 4, index: 255};// RNM(purchaseFromCode)
    this.rules[257].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[257].opcodes[3] = {type: 4, index: 256};// RNM(purchaseFromValue)

    /* shipForLocCode */
    this.rules[258].opcodes = [];
    this.rules[258].opcodes[0] = {type: 7, string: [52,49,51]};// TLS

    /* shipForLocValue */
    this.rules[259].opcodes = [];
    this.rules[259].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[259].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* shipForLocParameter */
    this.rules[260].opcodes = [];
    this.rules[260].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[260].opcodes[1] = {type: 4, index: 258};// RNM(shipForLocCode)
    this.rules[260].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[260].opcodes[3] = {type: 4, index: 259};// RNM(shipForLocValue)

    /* locNoCode */
    this.rules[261].opcodes = [];
    this.rules[261].opcodes[0] = {type: 7, string: [52,49,52]};// TLS

    /* locNoValue */
    this.rules[262].opcodes = [];
    this.rules[262].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[262].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* locNoParameter */
    this.rules[263].opcodes = [];
    this.rules[263].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[263].opcodes[1] = {type: 4, index: 261};// RNM(locNoCode)
    this.rules[263].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[263].opcodes[3] = {type: 4, index: 262};// RNM(locNoValue)

    /* payToCode */
    this.rules[264].opcodes = [];
    this.rules[264].opcodes[0] = {type: 7, string: [52,49,52]};// TLS

    /* payToValue */
    this.rules[265].opcodes = [];
    this.rules[265].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[265].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* payToParameter */
    this.rules[266].opcodes = [];
    this.rules[266].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[266].opcodes[1] = {type: 4, index: 264};// RNM(payToCode)
    this.rules[266].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[266].opcodes[3] = {type: 4, index: 265};// RNM(payToValue)

    /* prodServLocCode */
    this.rules[267].opcodes = [];
    this.rules[267].opcodes[0] = {type: 7, string: [52,49,54]};// TLS

    /* prodServLocValue */
    this.rules[268].opcodes = [];
    this.rules[268].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[268].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* prodServLocParameter */
    this.rules[269].opcodes = [];
    this.rules[269].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[269].opcodes[1] = {type: 4, index: 267};// RNM(prodServLocCode)
    this.rules[269].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[269].opcodes[3] = {type: 4, index: 268};// RNM(prodServLocValue)

    /* shipToPostCode */
    this.rules[270].opcodes = [];
    this.rules[270].opcodes[0] = {type: 7, string: [52,50,48]};// TLS

    /* shipToPostValue */
    this.rules[271].opcodes = [];
    this.rules[271].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[271].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* shipToPostParameter */
    this.rules[272].opcodes = [];
    this.rules[272].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[272].opcodes[1] = {type: 4, index: 270};// RNM(shipToPostCode)
    this.rules[272].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[272].opcodes[3] = {type: 4, index: 271};// RNM(shipToPostValue)

    /* shipToPostISOCode */
    this.rules[273].opcodes = [];
    this.rules[273].opcodes[0] = {type: 7, string: [52,50,49]};// TLS

    /* shipToPostISOValue */
    this.rules[274].opcodes = [];
    this.rules[274].opcodes[0] = {type: 2, children: [1,3]};// CAT
    this.rules[274].opcodes[1] = {type: 3, min: 3, max: 3};// REP
    this.rules[274].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[274].opcodes[3] = {type: 3, min: 1, max: 9};// REP
    this.rules[274].opcodes[4] = {type: 4, index: 25};// RNM(XCHAR)

    /* shipToPostISOParameter */
    this.rules[275].opcodes = [];
    this.rules[275].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[275].opcodes[1] = {type: 4, index: 273};// RNM(shipToPostISOCode)
    this.rules[275].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[275].opcodes[3] = {type: 4, index: 274};// RNM(shipToPostISOValue)

    /* originCode */
    this.rules[276].opcodes = [];
    this.rules[276].opcodes[0] = {type: 7, string: [52,50,50]};// TLS

    /* originValue */
    this.rules[277].opcodes = [];
    this.rules[277].opcodes[0] = {type: 3, min: 3, max: 3};// REP
    this.rules[277].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* originParameter */
    this.rules[278].opcodes = [];
    this.rules[278].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[278].opcodes[1] = {type: 4, index: 276};// RNM(originCode)
    this.rules[278].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[278].opcodes[3] = {type: 4, index: 277};// RNM(originValue)

    /* countryProcessCode */
    this.rules[279].opcodes = [];
    this.rules[279].opcodes[0] = {type: 7, string: [52,50,52]};// TLS

    /* countryProcessValue */
    this.rules[280].opcodes = [];
    this.rules[280].opcodes[0] = {type: 3, min: 3, max: 3};// REP
    this.rules[280].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* countryProcessParameter */
    this.rules[281].opcodes = [];
    this.rules[281].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[281].opcodes[1] = {type: 4, index: 279};// RNM(countryProcessCode)
    this.rules[281].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[281].opcodes[3] = {type: 4, index: 280};// RNM(countryProcessValue)

    /* countryFullProcessCode */
    this.rules[282].opcodes = [];
    this.rules[282].opcodes[0] = {type: 7, string: [52,50,54]};// TLS

    /* countryFullProcessValue */
    this.rules[283].opcodes = [];
    this.rules[283].opcodes[0] = {type: 3, min: 3, max: 3};// REP
    this.rules[283].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* countryFullProcessParameter */
    this.rules[284].opcodes = [];
    this.rules[284].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[284].opcodes[1] = {type: 4, index: 282};// RNM(countryFullProcessCode)
    this.rules[284].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[284].opcodes[3] = {type: 4, index: 283};// RNM(countryFullProcessValue)

    /* countryInitialProcessCode */
    this.rules[285].opcodes = [];
    this.rules[285].opcodes[0] = {type: 7, string: [52,50,51]};// TLS

    /* countryInitialProcessValue */
    this.rules[286].opcodes = [];
    this.rules[286].opcodes[0] = {type: 2, children: [1,3]};// CAT
    this.rules[286].opcodes[1] = {type: 3, min: 3, max: 3};// REP
    this.rules[286].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[286].opcodes[3] = {type: 3, min: 1, max: 12};// REP
    this.rules[286].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)

    /* countryInitialProcessParameter */
    this.rules[287].opcodes = [];
    this.rules[287].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[287].opcodes[1] = {type: 4, index: 285};// RNM(countryInitialProcessCode)
    this.rules[287].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[287].opcodes[3] = {type: 4, index: 286};// RNM(countryInitialProcessValue)

    /* countryDisassemblyCode */
    this.rules[288].opcodes = [];
    this.rules[288].opcodes[0] = {type: 7, string: [52,50,53]};// TLS

    /* countryDisassemblyValue */
    this.rules[289].opcodes = [];
    this.rules[289].opcodes[0] = {type: 2, children: [1,3]};// CAT
    this.rules[289].opcodes[1] = {type: 3, min: 3, max: 3};// REP
    this.rules[289].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[289].opcodes[3] = {type: 3, min: 1, max: 12};// REP
    this.rules[289].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)

    /* countryDisassemblyParameter */
    this.rules[290].opcodes = [];
    this.rules[290].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[290].opcodes[1] = {type: 4, index: 288};// RNM(countryDisassemblyCode)
    this.rules[290].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[290].opcodes[3] = {type: 4, index: 289};// RNM(countryDisassemblyValue)

    /* originSubdivisionCode */
    this.rules[291].opcodes = [];
    this.rules[291].opcodes[0] = {type: 7, string: [52,50,55]};// TLS

    /* originSubdivisionValue */
    this.rules[292].opcodes = [];
    this.rules[292].opcodes[0] = {type: 3, min: 1, max: 3};// REP
    this.rules[292].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* originSubdivisionParameter */
    this.rules[293].opcodes = [];
    this.rules[293].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[293].opcodes[1] = {type: 4, index: 291};// RNM(originSubdivisionCode)
    this.rules[293].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[293].opcodes[3] = {type: 4, index: 292};// RNM(originSubdivisionValue)

    /* nhrnPZNCode */
    this.rules[294].opcodes = [];
    this.rules[294].opcodes[0] = {type: 7, string: [55,49,48]};// TLS

    /* nhrnPZNValue */
    this.rules[295].opcodes = [];
    this.rules[295].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[295].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* nhrnPZNParameter */
    this.rules[296].opcodes = [];
    this.rules[296].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[296].opcodes[1] = {type: 4, index: 294};// RNM(nhrnPZNCode)
    this.rules[296].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[296].opcodes[3] = {type: 4, index: 295};// RNM(nhrnPZNValue)

    /* nhrnCIPCode */
    this.rules[297].opcodes = [];
    this.rules[297].opcodes[0] = {type: 7, string: [55,49,49]};// TLS

    /* nhrnCIPValue */
    this.rules[298].opcodes = [];
    this.rules[298].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[298].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* nhrnCIPParameter */
    this.rules[299].opcodes = [];
    this.rules[299].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[299].opcodes[1] = {type: 4, index: 297};// RNM(nhrnCIPCode)
    this.rules[299].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[299].opcodes[3] = {type: 4, index: 298};// RNM(nhrnCIPValue)

    /* nhrnCNCode */
    this.rules[300].opcodes = [];
    this.rules[300].opcodes[0] = {type: 7, string: [55,49,50]};// TLS

    /* nhrnCNValue */
    this.rules[301].opcodes = [];
    this.rules[301].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[301].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* nhrnCNParameter */
    this.rules[302].opcodes = [];
    this.rules[302].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[302].opcodes[1] = {type: 4, index: 300};// RNM(nhrnCNCode)
    this.rules[302].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[302].opcodes[3] = {type: 4, index: 301};// RNM(nhrnCNValue)

    /* nhrnDRNCode */
    this.rules[303].opcodes = [];
    this.rules[303].opcodes[0] = {type: 7, string: [55,49,51]};// TLS

    /* nhrnDRNValue */
    this.rules[304].opcodes = [];
    this.rules[304].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[304].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* nhrnDRNParameter */
    this.rules[305].opcodes = [];
    this.rules[305].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[305].opcodes[1] = {type: 4, index: 303};// RNM(nhrnDRNCode)
    this.rules[305].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[305].opcodes[3] = {type: 4, index: 304};// RNM(nhrnDRNValue)

    /* nhrnAIMCode */
    this.rules[306].opcodes = [];
    this.rules[306].opcodes[0] = {type: 7, string: [55,49,52]};// TLS

    /* nhrnAIMValue */
    this.rules[307].opcodes = [];
    this.rules[307].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[307].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* nhrnAIMParameter */
    this.rules[308].opcodes = [];
    this.rules[308].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[308].opcodes[1] = {type: 4, index: 306};// RNM(nhrnAIMCode)
    this.rules[308].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[308].opcodes[3] = {type: 4, index: 307};// RNM(nhrnAIMValue)

    /* nsnCode */
    this.rules[309].opcodes = [];
    this.rules[309].opcodes[0] = {type: 7, string: [55,48,48,49]};// TLS

    /* nsnValue */
    this.rules[310].opcodes = [];
    this.rules[310].opcodes[0] = {type: 3, min: 13, max: 13};// REP
    this.rules[310].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* nsnParameter */
    this.rules[311].opcodes = [];
    this.rules[311].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[311].opcodes[1] = {type: 4, index: 309};// RNM(nsnCode)
    this.rules[311].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[311].opcodes[3] = {type: 4, index: 310};// RNM(nsnValue)

    /* meatCutCode */
    this.rules[312].opcodes = [];
    this.rules[312].opcodes[0] = {type: 7, string: [55,48,48,50]};// TLS

    /* meatCutValue */
    this.rules[313].opcodes = [];
    this.rules[313].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[313].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* meatCutParameter */
    this.rules[314].opcodes = [];
    this.rules[314].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[314].opcodes[1] = {type: 4, index: 312};// RNM(meatCutCode)
    this.rules[314].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[314].opcodes[3] = {type: 4, index: 313};// RNM(meatCutValue)

    /* activePotencyCode */
    this.rules[315].opcodes = [];
    this.rules[315].opcodes[0] = {type: 7, string: [55,48,48,52]};// TLS

    /* activePotencyValue */
    this.rules[316].opcodes = [];
    this.rules[316].opcodes[0] = {type: 3, min: 1, max: 4};// REP
    this.rules[316].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* activePotencyParameter */
    this.rules[317].opcodes = [];
    this.rules[317].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[317].opcodes[1] = {type: 4, index: 315};// RNM(activePotencyCode)
    this.rules[317].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[317].opcodes[3] = {type: 4, index: 316};// RNM(activePotencyValue)

    /* catchAreaCode */
    this.rules[318].opcodes = [];
    this.rules[318].opcodes[0] = {type: 7, string: [55,48,48,53]};// TLS

    /* catchAreaValue */
    this.rules[319].opcodes = [];
    this.rules[319].opcodes[0] = {type: 3, min: 1, max: 12};// REP
    this.rules[319].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* catchAreaParameter */
    this.rules[320].opcodes = [];
    this.rules[320].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[320].opcodes[1] = {type: 4, index: 318};// RNM(catchAreaCode)
    this.rules[320].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[320].opcodes[3] = {type: 4, index: 319};// RNM(catchAreaValue)

    /* fishingGearTypeCode */
    this.rules[321].opcodes = [];
    this.rules[321].opcodes[0] = {type: 7, string: [55,48,48,57]};// TLS

    /* fishingGearTypeValue */
    this.rules[322].opcodes = [];
    this.rules[322].opcodes[0] = {type: 3, min: 1, max: 10};// REP
    this.rules[322].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* fishingGearTypeParameter */
    this.rules[323].opcodes = [];
    this.rules[323].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[323].opcodes[1] = {type: 4, index: 321};// RNM(fishingGearTypeCode)
    this.rules[323].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[323].opcodes[3] = {type: 4, index: 322};// RNM(fishingGearTypeValue)

    /* prodMethodCode */
    this.rules[324].opcodes = [];
    this.rules[324].opcodes[0] = {type: 7, string: [55,48,49,48]};// TLS

    /* prodMethodValue */
    this.rules[325].opcodes = [];
    this.rules[325].opcodes[0] = {type: 3, min: 1, max: 2};// REP
    this.rules[325].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* prodMethodParameter */
    this.rules[326].opcodes = [];
    this.rules[326].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[326].opcodes[1] = {type: 4, index: 324};// RNM(prodMethodCode)
    this.rules[326].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[326].opcodes[3] = {type: 4, index: 325};// RNM(prodMethodValue)

    /* refurbLotCode */
    this.rules[327].opcodes = [];
    this.rules[327].opcodes[0] = {type: 7, string: [55,48,50,48]};// TLS

    /* refurbLotValue */
    this.rules[328].opcodes = [];
    this.rules[328].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[328].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* refurbLotParameter */
    this.rules[329].opcodes = [];
    this.rules[329].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[329].opcodes[1] = {type: 4, index: 327};// RNM(refurbLotCode)
    this.rules[329].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[329].opcodes[3] = {type: 4, index: 328};// RNM(refurbLotValue)

    /* funcStatCode */
    this.rules[330].opcodes = [];
    this.rules[330].opcodes[0] = {type: 7, string: [55,48,50,49]};// TLS

    /* funcStatValue */
    this.rules[331].opcodes = [];
    this.rules[331].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[331].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* funcStatParameter */
    this.rules[332].opcodes = [];
    this.rules[332].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[332].opcodes[1] = {type: 4, index: 330};// RNM(funcStatCode)
    this.rules[332].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[332].opcodes[3] = {type: 4, index: 331};// RNM(funcStatValue)

    /* revStatCode */
    this.rules[333].opcodes = [];
    this.rules[333].opcodes[0] = {type: 7, string: [55,48,50,50]};// TLS

    /* revStatValue */
    this.rules[334].opcodes = [];
    this.rules[334].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[334].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* revStatParameter */
    this.rules[335].opcodes = [];
    this.rules[335].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[335].opcodes[1] = {type: 4, index: 333};// RNM(revStatCode)
    this.rules[335].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[335].opcodes[3] = {type: 4, index: 334};// RNM(revStatValue)

    /* giaiAssemblyCode */
    this.rules[336].opcodes = [];
    this.rules[336].opcodes[0] = {type: 7, string: [55,48,50,51]};// TLS

    /* giaiAssemblyValue */
    this.rules[337].opcodes = [];
    this.rules[337].opcodes[0] = {type: 3, min: 1, max: 30};// REP
    this.rules[337].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* giaiAssemblyParameter */
    this.rules[338].opcodes = [];
    this.rules[338].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[338].opcodes[1] = {type: 4, index: 336};// RNM(giaiAssemblyCode)
    this.rules[338].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[338].opcodes[3] = {type: 4, index: 337};// RNM(giaiAssemblyValue)

    /* dimensionsCode */
    this.rules[339].opcodes = [];
    this.rules[339].opcodes[0] = {type: 7, string: [56,48,48,49]};// TLS

    /* dimensionsValue */
    this.rules[340].opcodes = [];
    this.rules[340].opcodes[0] = {type: 3, min: 14, max: 14};// REP
    this.rules[340].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* dimensionsParameter */
    this.rules[341].opcodes = [];
    this.rules[341].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[341].opcodes[1] = {type: 4, index: 339};// RNM(dimensionsCode)
    this.rules[341].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[341].opcodes[3] = {type: 4, index: 340};// RNM(dimensionsValue)

    /* cmtNoCode */
    this.rules[342].opcodes = [];
    this.rules[342].opcodes[0] = {type: 7, string: [56,48,48,50]};// TLS

    /* cmtNoValue */
    this.rules[343].opcodes = [];
    this.rules[343].opcodes[0] = {type: 3, min: 1, max: 20};// REP
    this.rules[343].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* cmtNoParameter */
    this.rules[344].opcodes = [];
    this.rules[344].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[344].opcodes[1] = {type: 4, index: 342};// RNM(cmtNoCode)
    this.rules[344].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[344].opcodes[3] = {type: 4, index: 343};// RNM(cmtNoValue)

    /* ibanCode */
    this.rules[345].opcodes = [];
    this.rules[345].opcodes[0] = {type: 7, string: [56,48,48,55]};// TLS

    /* ibanValue */
    this.rules[346].opcodes = [];
    this.rules[346].opcodes[0] = {type: 3, min: 1, max: 34};// REP
    this.rules[346].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* ibanParameter */
    this.rules[347].opcodes = [];
    this.rules[347].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[347].opcodes[1] = {type: 4, index: 345};// RNM(ibanCode)
    this.rules[347].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[347].opcodes[3] = {type: 4, index: 346};// RNM(ibanValue)

    /* prodTimeCode */
    this.rules[348].opcodes = [];
    this.rules[348].opcodes[0] = {type: 7, string: [56,48,48,56]};// TLS

    /* prodTimeValue */
    this.rules[349].opcodes = [];
    this.rules[349].opcodes[0] = {type: 2, children: [1,3]};// CAT
    this.rules[349].opcodes[1] = {type: 3, min: 8, max: 8};// REP
    this.rules[349].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[349].opcodes[3] = {type: 3, min: 1, max: 4};// REP
    this.rules[349].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)

    /* prodTimeParameter */
    this.rules[350].opcodes = [];
    this.rules[350].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[350].opcodes[1] = {type: 4, index: 348};// RNM(prodTimeCode)
    this.rules[350].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[350].opcodes[3] = {type: 4, index: 349};// RNM(prodTimeValue)

    /* versionCode */
    this.rules[351].opcodes = [];
    this.rules[351].opcodes[0] = {type: 7, string: [56,48,49,50]};// TLS

    /* versionValue */
    this.rules[352].opcodes = [];
    this.rules[352].opcodes[0] = {type: 2, children: [1,3]};// CAT
    this.rules[352].opcodes[1] = {type: 3, min: 4, max: 4};// REP
    this.rules[352].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[352].opcodes[3] = {type: 3, min: 1, max: 20};// REP
    this.rules[352].opcodes[4] = {type: 4, index: 25};// RNM(XCHAR)

    /* versionParameter */
    this.rules[353].opcodes = [];
    this.rules[353].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[353].opcodes[1] = {type: 4, index: 351};// RNM(versionCode)
    this.rules[353].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[353].opcodes[3] = {type: 4, index: 352};// RNM(versionValue)

    /* refNoCode */
    this.rules[354].opcodes = [];
    this.rules[354].opcodes[0] = {type: 7, string: [56,48,50,48]};// TLS

    /* refNoValue */
    this.rules[355].opcodes = [];
    this.rules[355].opcodes[0] = {type: 3, min: 1, max: 25};// REP
    this.rules[355].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* refNoParameter */
    this.rules[356].opcodes = [];
    this.rules[356].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[356].opcodes[1] = {type: 4, index: 354};// RNM(refNoCode)
    this.rules[356].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[356].opcodes[3] = {type: 4, index: 355};// RNM(refNoValue)

    /* couponIDNACode */
    this.rules[357].opcodes = [];
    this.rules[357].opcodes[0] = {type: 7, string: [56,49,49,48]};// TLS

    /* couponIDNAValue */
    this.rules[358].opcodes = [];
    this.rules[358].opcodes[0] = {type: 3, min: 1, max: 70};// REP
    this.rules[358].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* couponIDNAParameter */
    this.rules[359].opcodes = [];
    this.rules[359].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[359].opcodes[1] = {type: 4, index: 357};// RNM(couponIDNACode)
    this.rules[359].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[359].opcodes[3] = {type: 4, index: 358};// RNM(couponIDNAValue)

    /* pointsCode */
    this.rules[360].opcodes = [];
    this.rules[360].opcodes[0] = {type: 7, string: [56,49,49,49]};// TLS

    /* pointsValue */
    this.rules[361].opcodes = [];
    this.rules[361].opcodes[0] = {type: 3, min: 4, max: 4};// REP
    this.rules[361].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* pointsParameter */
    this.rules[362].opcodes = [];
    this.rules[362].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[362].opcodes[1] = {type: 4, index: 360};// RNM(pointsCode)
    this.rules[362].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[362].opcodes[3] = {type: 4, index: 361};// RNM(pointsValue)

    /* paperlessCouponIDNACode */
    this.rules[363].opcodes = [];
    this.rules[363].opcodes[0] = {type: 7, string: [56,49,49,50]};// TLS

    /* paperlessCouponIDNAValue */
    this.rules[364].opcodes = [];
    this.rules[364].opcodes[0] = {type: 3, min: 1, max: 70};// REP
    this.rules[364].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* paperlessCouponIDNAParameter */
    this.rules[365].opcodes = [];
    this.rules[365].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[365].opcodes[1] = {type: 4, index: 363};// RNM(paperlessCouponIDNACode)
    this.rules[365].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[365].opcodes[3] = {type: 4, index: 364};// RNM(paperlessCouponIDNAValue)

    /* internalCode */
    this.rules[366].opcodes = [];
    this.rules[366].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9]};// ALT
    this.rules[366].opcodes[1] = {type: 7, string: [57,49]};// TLS
    this.rules[366].opcodes[2] = {type: 7, string: [57,50]};// TLS
    this.rules[366].opcodes[3] = {type: 7, string: [57,51]};// TLS
    this.rules[366].opcodes[4] = {type: 7, string: [57,52]};// TLS
    this.rules[366].opcodes[5] = {type: 7, string: [57,53]};// TLS
    this.rules[366].opcodes[6] = {type: 7, string: [57,54]};// TLS
    this.rules[366].opcodes[7] = {type: 7, string: [57,55]};// TLS
    this.rules[366].opcodes[8] = {type: 7, string: [57,56]};// TLS
    this.rules[366].opcodes[9] = {type: 7, string: [57,57]};// TLS

    /* internalValue */
    this.rules[367].opcodes = [];
    this.rules[367].opcodes[0] = {type: 3, min: 1, max: 90};// REP
    this.rules[367].opcodes[1] = {type: 4, index: 25};// RNM(XCHAR)

    /* internalParameter */
    this.rules[368].opcodes = [];
    this.rules[368].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[368].opcodes[1] = {type: 4, index: 366};// RNM(internalCode)
    this.rules[368].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[368].opcodes[3] = {type: 4, index: 367};// RNM(internalValue)

    /* LotParameter */
    this.rules[369].opcodes = [];
    this.rules[369].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[369].opcodes[1] = {type: 4, index: 48};// RNM(lot-code)
    this.rules[369].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[369].opcodes[3] = {type: 4, index: 75};// RNM(lot-value)

    /* expiryDateCode */
    this.rules[370].opcodes = [];
    this.rules[370].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[370].opcodes[1] = {type: 7, string: [49,55]};// TLS
    this.rules[370].opcodes[2] = {type: 6, string: [101,120,112]};// TBS

    /* expiryDateValue */
    this.rules[371].opcodes = [];
    this.rules[371].opcodes[0] = {type: 3, min: 6, max: 6};// REP
    this.rules[371].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* expiryDateParameter */
    this.rules[372].opcodes = [];
    this.rules[372].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[372].opcodes[1] = {type: 4, index: 370};// RNM(expiryDateCode)
    this.rules[372].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[372].opcodes[3] = {type: 4, index: 371};// RNM(expiryDateValue)

    /* expiryTimeCode */
    this.rules[373].opcodes = [];
    this.rules[373].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[373].opcodes[1] = {type: 7, string: [55,48,48,51]};// TLS
    this.rules[373].opcodes[2] = {type: 6, string: [101,120,112,100,116]};// TBS

    /* expiryTimeValue */
    this.rules[374].opcodes = [];
    this.rules[374].opcodes[0] = {type: 3, min: 10, max: 10};// REP
    this.rules[374].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* expiryTimeParameter */
    this.rules[375].opcodes = [];
    this.rules[375].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[375].opcodes[1] = {type: 4, index: 373};// RNM(expiryTimeCode)
    this.rules[375].opcodes[2] = {type: 7, string: [61]};// TLS
    this.rules[375].opcodes[3] = {type: 4, index: 374};// RNM(expiryTimeValue)

    /* extensionParameter */
    this.rules[376].opcodes = [];
    this.rules[376].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
    this.rules[376].opcodes[1] = {type: 1, children: [2,3,4]};// ALT
    this.rules[376].opcodes[2] = {type: 4, index: 384};// RNM(pchar)
    this.rules[376].opcodes[3] = {type: 7, string: [47]};// TLS
    this.rules[376].opcodes[4] = {type: 7, string: [63]};// TLS

    /* queryStringParam */
    this.rules[377].opcodes = [];
    this.rules[377].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83]};// ALT
    this.rules[377].opcodes[1] = {type: 4, index: 131};// RNM(netWeightVMTIParameter)
    this.rules[377].opcodes[2] = {type: 4, index: 134};// RNM(lengthVMTIParameter)
    this.rules[377].opcodes[3] = {type: 4, index: 137};// RNM(widthVMTIParameter)
    this.rules[377].opcodes[4] = {type: 4, index: 140};// RNM(depthVMTIParameter)
    this.rules[377].opcodes[5] = {type: 4, index: 143};// RNM(areaVMTIParameter)
    this.rules[377].opcodes[6] = {type: 4, index: 146};// RNM(netVolumeVMTIParameter)
    this.rules[377].opcodes[7] = {type: 4, index: 149};// RNM(massPerUnitAreaVMTIParameter)
    this.rules[377].opcodes[8] = {type: 4, index: 152};// RNM(grossWeightParameter)
    this.rules[377].opcodes[9] = {type: 4, index: 155};// RNM(logisticLengthParameter)
    this.rules[377].opcodes[10] = {type: 4, index: 158};// RNM(logisticWidthParameter)
    this.rules[377].opcodes[11] = {type: 4, index: 161};// RNM(logisticDepthParameter)
    this.rules[377].opcodes[12] = {type: 4, index: 164};// RNM(logisticAreaParameter)
    this.rules[377].opcodes[13] = {type: 4, index: 167};// RNM(logisticVolumeParameter)
    this.rules[377].opcodes[14] = {type: 4, index: 170};// RNM(processorParameter)
    this.rules[377].opcodes[15] = {type: 4, index: 369};// RNM(LotParameter)
    this.rules[377].opcodes[16] = {type: 4, index: 372};// RNM(expiryDateParameter)
    this.rules[377].opcodes[17] = {type: 4, index: 375};// RNM(expiryTimeParameter)
    this.rules[377].opcodes[18] = {type: 4, index: 173};// RNM(contentParameter)
    this.rules[377].opcodes[19] = {type: 4, index: 176};// RNM(prodDateParameter)
    this.rules[377].opcodes[20] = {type: 4, index: 179};// RNM(dueDateParameter)
    this.rules[377].opcodes[21] = {type: 4, index: 182};// RNM(packDateParameter)
    this.rules[377].opcodes[22] = {type: 4, index: 185};// RNM(bestBeforeDateParameter)
    this.rules[377].opcodes[23] = {type: 4, index: 188};// RNM(sellByDateParameter)
    this.rules[377].opcodes[24] = {type: 4, index: 191};// RNM(firstFreezeDateParameter)
    this.rules[377].opcodes[25] = {type: 4, index: 194};// RNM(harvestDateParameter)
    this.rules[377].opcodes[26] = {type: 4, index: 197};// RNM(pricePerUnitParameter)
    this.rules[377].opcodes[27] = {type: 4, index: 200};// RNM(variantParameter)
    this.rules[377].opcodes[28] = {type: 4, index: 203};// RNM(varCountParameter)
    this.rules[377].opcodes[29] = {type: 4, index: 206};// RNM(countParameter)
    this.rules[377].opcodes[30] = {type: 4, index: 368};// RNM(internalParameter)
    this.rules[377].opcodes[31] = {type: 4, index: 212};// RNM(additionalIdParameter)
    this.rules[377].opcodes[32] = {type: 4, index: 215};// RNM(custPartNoParameter)
    this.rules[377].opcodes[33] = {type: 4, index: 218};// RNM(mtoVariantParameter)
    this.rules[377].opcodes[34] = {type: 4, index: 221};// RNM(pcnParameter)
    this.rules[377].opcodes[35] = {type: 4, index: 224};// RNM(secondarySerialParameter)
    this.rules[377].opcodes[36] = {type: 4, index: 227};// RNM(refToSourceParameter)
    this.rules[377].opcodes[37] = {type: 4, index: 230};// RNM(amountParameter)
    this.rules[377].opcodes[38] = {type: 4, index: 233};// RNM(amountISOParameter)
    this.rules[377].opcodes[39] = {type: 4, index: 236};// RNM(priceParameter)
    this.rules[377].opcodes[40] = {type: 4, index: 239};// RNM(priceISOParameter)
    this.rules[377].opcodes[41] = {type: 4, index: 242};// RNM(percentOffParameter)
    this.rules[377].opcodes[42] = {type: 4, index: 245};// RNM(orderNumberParameter)
    this.rules[377].opcodes[43] = {type: 4, index: 248};// RNM(routeParameter)
    this.rules[377].opcodes[44] = {type: 4, index: 251};// RNM(shipToLocParameter)
    this.rules[377].opcodes[45] = {type: 4, index: 254};// RNM(billToParameter)
    this.rules[377].opcodes[46] = {type: 4, index: 257};// RNM(purchaseFromParameter)
    this.rules[377].opcodes[47] = {type: 4, index: 260};// RNM(shipForLocParameter)
    this.rules[377].opcodes[48] = {type: 4, index: 263};// RNM(locNoParameter)
    this.rules[377].opcodes[49] = {type: 4, index: 269};// RNM(prodServLocParameter)
    this.rules[377].opcodes[50] = {type: 4, index: 272};// RNM(shipToPostParameter)
    this.rules[377].opcodes[51] = {type: 4, index: 275};// RNM(shipToPostISOParameter)
    this.rules[377].opcodes[52] = {type: 4, index: 278};// RNM(originParameter)
    this.rules[377].opcodes[53] = {type: 4, index: 281};// RNM(countryProcessParameter)
    this.rules[377].opcodes[54] = {type: 4, index: 284};// RNM(countryFullProcessParameter)
    this.rules[377].opcodes[55] = {type: 4, index: 287};// RNM(countryInitialProcessParameter)
    this.rules[377].opcodes[56] = {type: 4, index: 290};// RNM(countryDisassemblyParameter)
    this.rules[377].opcodes[57] = {type: 4, index: 293};// RNM(originSubdivisionParameter)
    this.rules[377].opcodes[58] = {type: 4, index: 296};// RNM(nhrnPZNParameter)
    this.rules[377].opcodes[59] = {type: 4, index: 299};// RNM(nhrnCIPParameter)
    this.rules[377].opcodes[60] = {type: 4, index: 302};// RNM(nhrnCNParameter)
    this.rules[377].opcodes[61] = {type: 4, index: 305};// RNM(nhrnDRNParameter)
    this.rules[377].opcodes[62] = {type: 4, index: 311};// RNM(nsnParameter)
    this.rules[377].opcodes[63] = {type: 4, index: 314};// RNM(meatCutParameter)
    this.rules[377].opcodes[64] = {type: 4, index: 317};// RNM(activePotencyParameter)
    this.rules[377].opcodes[65] = {type: 4, index: 320};// RNM(catchAreaParameter)
    this.rules[377].opcodes[66] = {type: 4, index: 323};// RNM(fishingGearTypeParameter)
    this.rules[377].opcodes[67] = {type: 4, index: 326};// RNM(prodMethodParameter)
    this.rules[377].opcodes[68] = {type: 4, index: 329};// RNM(refurbLotParameter)
    this.rules[377].opcodes[69] = {type: 4, index: 332};// RNM(funcStatParameter)
    this.rules[377].opcodes[70] = {type: 4, index: 335};// RNM(revStatParameter)
    this.rules[377].opcodes[71] = {type: 4, index: 338};// RNM(giaiAssemblyParameter)
    this.rules[377].opcodes[72] = {type: 4, index: 341};// RNM(dimensionsParameter)
    this.rules[377].opcodes[73] = {type: 4, index: 344};// RNM(cmtNoParameter)
    this.rules[377].opcodes[74] = {type: 4, index: 347};// RNM(ibanParameter)
    this.rules[377].opcodes[75] = {type: 4, index: 350};// RNM(prodTimeParameter)
    this.rules[377].opcodes[76] = {type: 4, index: 353};// RNM(versionParameter)
    this.rules[377].opcodes[77] = {type: 4, index: 356};// RNM(refNoParameter)
    this.rules[377].opcodes[78] = {type: 4, index: 359};// RNM(couponIDNAParameter)
    this.rules[377].opcodes[79] = {type: 4, index: 362};// RNM(pointsParameter)
    this.rules[377].opcodes[80] = {type: 4, index: 365};// RNM(paperlessCouponIDNAParameter)
    this.rules[377].opcodes[81] = {type: 4, index: 368};// RNM(internalParameter)
    this.rules[377].opcodes[82] = {type: 4, index: 209};// RNM(mutualParameter)
    this.rules[377].opcodes[83] = {type: 4, index: 376};// RNM(extensionParameter)

    /* scheme */
    this.rules[378].opcodes = [];
    this.rules[378].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[378].opcodes[1] = {type: 7, string: [104,116,116,112,115]};// TLS
    this.rules[378].opcodes[2] = {type: 7, string: [104,116,116,112]};// TLS

    /* unreserved */
    this.rules[379].opcodes = [];
    this.rules[379].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
    this.rules[379].opcodes[1] = {type: 4, index: 3};// RNM(ALPHA)
    this.rules[379].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[379].opcodes[3] = {type: 7, string: [45]};// TLS
    this.rules[379].opcodes[4] = {type: 7, string: [46]};// TLS
    this.rules[379].opcodes[5] = {type: 7, string: [95]};// TLS
    this.rules[379].opcodes[6] = {type: 7, string: [126]};// TLS

    /* reserved */
    this.rules[380].opcodes = [];
    this.rules[380].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[380].opcodes[1] = {type: 4, index: 382};// RNM(gen-delims)
    this.rules[380].opcodes[2] = {type: 4, index: 383};// RNM(sub-delims)

    /* pct-encoded */
    this.rules[381].opcodes = [];
    this.rules[381].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[381].opcodes[1] = {type: 7, string: [37]};// TLS
    this.rules[381].opcodes[2] = {type: 4, index: 4};// RNM(HEXDIG)
    this.rules[381].opcodes[3] = {type: 4, index: 4};// RNM(HEXDIG)

    /* gen-delims */
    this.rules[382].opcodes = [];
    this.rules[382].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7]};// ALT
    this.rules[382].opcodes[1] = {type: 7, string: [58]};// TLS
    this.rules[382].opcodes[2] = {type: 7, string: [47]};// TLS
    this.rules[382].opcodes[3] = {type: 7, string: [63]};// TLS
    this.rules[382].opcodes[4] = {type: 7, string: [35]};// TLS
    this.rules[382].opcodes[5] = {type: 7, string: [91]};// TLS
    this.rules[382].opcodes[6] = {type: 7, string: [93]};// TLS
    this.rules[382].opcodes[7] = {type: 7, string: [64]};// TLS

    /* sub-delims */
    this.rules[383].opcodes = [];
    this.rules[383].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11]};// ALT
    this.rules[383].opcodes[1] = {type: 7, string: [33]};// TLS
    this.rules[383].opcodes[2] = {type: 7, string: [36]};// TLS
    this.rules[383].opcodes[3] = {type: 7, string: [38]};// TLS
    this.rules[383].opcodes[4] = {type: 7, string: [39]};// TLS
    this.rules[383].opcodes[5] = {type: 7, string: [40]};// TLS
    this.rules[383].opcodes[6] = {type: 7, string: [41]};// TLS
    this.rules[383].opcodes[7] = {type: 7, string: [42]};// TLS
    this.rules[383].opcodes[8] = {type: 7, string: [43]};// TLS
    this.rules[383].opcodes[9] = {type: 7, string: [44]};// TLS
    this.rules[383].opcodes[10] = {type: 7, string: [59]};// TLS
    this.rules[383].opcodes[11] = {type: 7, string: [61]};// TLS

    /* pchar */
    this.rules[384].opcodes = [];
    this.rules[384].opcodes[0] = {type: 1, children: [1,2,3,4,5]};// ALT
    this.rules[384].opcodes[1] = {type: 4, index: 379};// RNM(unreserved)
    this.rules[384].opcodes[2] = {type: 4, index: 381};// RNM(pct-encoded)
    this.rules[384].opcodes[3] = {type: 4, index: 383};// RNM(sub-delims)
    this.rules[384].opcodes[4] = {type: 7, string: [58]};// TLS
    this.rules[384].opcodes[5] = {type: 7, string: [64]};// TLS

    /* segment */
    this.rules[385].opcodes = [];
    this.rules[385].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
    this.rules[385].opcodes[1] = {type: 4, index: 384};// RNM(pchar)

    /* reg-name */
    this.rules[386].opcodes = [];
    this.rules[386].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
    this.rules[386].opcodes[1] = {type: 1, children: [2,3,4]};// ALT
    this.rules[386].opcodes[2] = {type: 4, index: 379};// RNM(unreserved)
    this.rules[386].opcodes[3] = {type: 4, index: 381};// RNM(pct-encoded)
    this.rules[386].opcodes[4] = {type: 4, index: 383};// RNM(sub-delims)

    /* dec-octet */
    this.rules[387].opcodes = [];
    this.rules[387].opcodes[0] = {type: 1, children: [1,2,5,9,13]};// ALT
    this.rules[387].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[387].opcodes[2] = {type: 2, children: [3,4]};// CAT
    this.rules[387].opcodes[3] = {type: 5, min: 49, max: 57};// TRG
    this.rules[387].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[387].opcodes[5] = {type: 2, children: [6,7]};// CAT
    this.rules[387].opcodes[6] = {type: 7, string: [49]};// TLS
    this.rules[387].opcodes[7] = {type: 3, min: 2, max: 2};// REP
    this.rules[387].opcodes[8] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[387].opcodes[9] = {type: 2, children: [10,11,12]};// CAT
    this.rules[387].opcodes[10] = {type: 7, string: [50]};// TLS
    this.rules[387].opcodes[11] = {type: 5, min: 48, max: 52};// TRG
    this.rules[387].opcodes[12] = {type: 4, index: 0};// RNM(DIGIT)
    this.rules[387].opcodes[13] = {type: 2, children: [14,15]};// CAT
    this.rules[387].opcodes[14] = {type: 7, string: [50,53]};// TLS
    this.rules[387].opcodes[15] = {type: 5, min: 48, max: 53};// TRG

    /* IPv4address */
    this.rules[388].opcodes = [];
    this.rules[388].opcodes[0] = {type: 2, children: [1,2,3,4,5,6,7]};// CAT
    this.rules[388].opcodes[1] = {type: 4, index: 387};// RNM(dec-octet)
    this.rules[388].opcodes[2] = {type: 7, string: [46]};// TLS
    this.rules[388].opcodes[3] = {type: 4, index: 387};// RNM(dec-octet)
    this.rules[388].opcodes[4] = {type: 7, string: [46]};// TLS
    this.rules[388].opcodes[5] = {type: 4, index: 387};// RNM(dec-octet)
    this.rules[388].opcodes[6] = {type: 7, string: [46]};// TLS
    this.rules[388].opcodes[7] = {type: 4, index: 387};// RNM(dec-octet)

    /* IPv6address */
    this.rules[389].opcodes = [];
    this.rules[389].opcodes[0] = {type: 1, children: [1,7,14,23,37,51,63,73,83]};// ALT
    this.rules[389].opcodes[1] = {type: 2, children: [2,6]};// CAT
    this.rules[389].opcodes[2] = {type: 3, min: 6, max: 6};// REP
    this.rules[389].opcodes[3] = {type: 2, children: [4,5]};// CAT
    this.rules[389].opcodes[4] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[5] = {type: 7, string: [58]};// TLS
    this.rules[389].opcodes[6] = {type: 4, index: 390};// RNM(ls32)
    this.rules[389].opcodes[7] = {type: 2, children: [8,9,13]};// CAT
    this.rules[389].opcodes[8] = {type: 7, string: [58,58]};// TLS
    this.rules[389].opcodes[9] = {type: 3, min: 5, max: 5};// REP
    this.rules[389].opcodes[10] = {type: 2, children: [11,12]};// CAT
    this.rules[389].opcodes[11] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[12] = {type: 7, string: [58]};// TLS
    this.rules[389].opcodes[13] = {type: 4, index: 390};// RNM(ls32)
    this.rules[389].opcodes[14] = {type: 2, children: [15,17,18,22]};// CAT
    this.rules[389].opcodes[15] = {type: 3, min: 0, max: 1};// REP
    this.rules[389].opcodes[16] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[17] = {type: 7, string: [58,58]};// TLS
    this.rules[389].opcodes[18] = {type: 3, min: 4, max: 4};// REP
    this.rules[389].opcodes[19] = {type: 2, children: [20,21]};// CAT
    this.rules[389].opcodes[20] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[21] = {type: 7, string: [58]};// TLS
    this.rules[389].opcodes[22] = {type: 4, index: 390};// RNM(ls32)
    this.rules[389].opcodes[23] = {type: 2, children: [24,31,32,36]};// CAT
    this.rules[389].opcodes[24] = {type: 3, min: 0, max: 1};// REP
    this.rules[389].opcodes[25] = {type: 2, children: [26,30]};// CAT
    this.rules[389].opcodes[26] = {type: 3, min: 0, max: 1};// REP
    this.rules[389].opcodes[27] = {type: 2, children: [28,29]};// CAT
    this.rules[389].opcodes[28] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[29] = {type: 7, string: [58]};// TLS
    this.rules[389].opcodes[30] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[31] = {type: 7, string: [58,58]};// TLS
    this.rules[389].opcodes[32] = {type: 3, min: 3, max: 3};// REP
    this.rules[389].opcodes[33] = {type: 2, children: [34,35]};// CAT
    this.rules[389].opcodes[34] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[35] = {type: 7, string: [58]};// TLS
    this.rules[389].opcodes[36] = {type: 4, index: 390};// RNM(ls32)
    this.rules[389].opcodes[37] = {type: 2, children: [38,45,46,50]};// CAT
    this.rules[389].opcodes[38] = {type: 3, min: 0, max: 1};// REP
    this.rules[389].opcodes[39] = {type: 2, children: [40,44]};// CAT
    this.rules[389].opcodes[40] = {type: 3, min: 0, max: 2};// REP
    this.rules[389].opcodes[41] = {type: 2, children: [42,43]};// CAT
    this.rules[389].opcodes[42] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[43] = {type: 7, string: [58]};// TLS
    this.rules[389].opcodes[44] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[45] = {type: 7, string: [58,58]};// TLS
    this.rules[389].opcodes[46] = {type: 3, min: 2, max: 2};// REP
    this.rules[389].opcodes[47] = {type: 2, children: [48,49]};// CAT
    this.rules[389].opcodes[48] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[49] = {type: 7, string: [58]};// TLS
    this.rules[389].opcodes[50] = {type: 4, index: 390};// RNM(ls32)
    this.rules[389].opcodes[51] = {type: 2, children: [52,59,60,61,62]};// CAT
    this.rules[389].opcodes[52] = {type: 3, min: 0, max: 1};// REP
    this.rules[389].opcodes[53] = {type: 2, children: [54,58]};// CAT
    this.rules[389].opcodes[54] = {type: 3, min: 0, max: 3};// REP
    this.rules[389].opcodes[55] = {type: 2, children: [56,57]};// CAT
    this.rules[389].opcodes[56] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[57] = {type: 7, string: [58]};// TLS
    this.rules[389].opcodes[58] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[59] = {type: 7, string: [58,58]};// TLS
    this.rules[389].opcodes[60] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[61] = {type: 7, string: [58]};// TLS
    this.rules[389].opcodes[62] = {type: 4, index: 390};// RNM(ls32)
    this.rules[389].opcodes[63] = {type: 2, children: [64,71,72]};// CAT
    this.rules[389].opcodes[64] = {type: 3, min: 0, max: 1};// REP
    this.rules[389].opcodes[65] = {type: 2, children: [66,70]};// CAT
    this.rules[389].opcodes[66] = {type: 3, min: 0, max: 4};// REP
    this.rules[389].opcodes[67] = {type: 2, children: [68,69]};// CAT
    this.rules[389].opcodes[68] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[69] = {type: 7, string: [58]};// TLS
    this.rules[389].opcodes[70] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[71] = {type: 7, string: [58,58]};// TLS
    this.rules[389].opcodes[72] = {type: 4, index: 390};// RNM(ls32)
    this.rules[389].opcodes[73] = {type: 2, children: [74,81,82]};// CAT
    this.rules[389].opcodes[74] = {type: 3, min: 0, max: 1};// REP
    this.rules[389].opcodes[75] = {type: 2, children: [76,80]};// CAT
    this.rules[389].opcodes[76] = {type: 3, min: 0, max: 5};// REP
    this.rules[389].opcodes[77] = {type: 2, children: [78,79]};// CAT
    this.rules[389].opcodes[78] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[79] = {type: 7, string: [58]};// TLS
    this.rules[389].opcodes[80] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[81] = {type: 7, string: [58,58]};// TLS
    this.rules[389].opcodes[82] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[83] = {type: 2, children: [84,91]};// CAT
    this.rules[389].opcodes[84] = {type: 3, min: 0, max: 1};// REP
    this.rules[389].opcodes[85] = {type: 2, children: [86,90]};// CAT
    this.rules[389].opcodes[86] = {type: 3, min: 0, max: 6};// REP
    this.rules[389].opcodes[87] = {type: 2, children: [88,89]};// CAT
    this.rules[389].opcodes[88] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[89] = {type: 7, string: [58]};// TLS
    this.rules[389].opcodes[90] = {type: 4, index: 391};// RNM(h16)
    this.rules[389].opcodes[91] = {type: 7, string: [58,58]};// TLS

    /* ls32 */
    this.rules[390].opcodes = [];
    this.rules[390].opcodes[0] = {type: 1, children: [1,5]};// ALT
    this.rules[390].opcodes[1] = {type: 2, children: [2,3,4]};// CAT
    this.rules[390].opcodes[2] = {type: 4, index: 391};// RNM(h16)
    this.rules[390].opcodes[3] = {type: 7, string: [58]};// TLS
    this.rules[390].opcodes[4] = {type: 4, index: 391};// RNM(h16)
    this.rules[390].opcodes[5] = {type: 4, index: 388};// RNM(IPv4address)

    /* h16 */
    this.rules[391].opcodes = [];
    this.rules[391].opcodes[0] = {type: 3, min: 1, max: 4};// REP
    this.rules[391].opcodes[1] = {type: 4, index: 4};// RNM(HEXDIG)

    /* IP-literal */
    this.rules[392].opcodes = [];
    this.rules[392].opcodes[0] = {type: 2, children: [1,2,5]};// CAT
    this.rules[392].opcodes[1] = {type: 7, string: [91]};// TLS
    this.rules[392].opcodes[2] = {type: 1, children: [3,4]};// ALT
    this.rules[392].opcodes[3] = {type: 4, index: 389};// RNM(IPv6address)
    this.rules[392].opcodes[4] = {type: 4, index: 393};// RNM(IPvFuture)
    this.rules[392].opcodes[5] = {type: 7, string: [93]};// TLS

    /* IPvFuture */
    this.rules[393].opcodes = [];
    this.rules[393].opcodes[0] = {type: 2, children: [1,2,4,5]};// CAT
    this.rules[393].opcodes[1] = {type: 7, string: [118]};// TLS
    this.rules[393].opcodes[2] = {type: 3, min: 1, max: Infinity};// REP
    this.rules[393].opcodes[3] = {type: 4, index: 4};// RNM(HEXDIG)
    this.rules[393].opcodes[4] = {type: 7, string: [46]};// TLS
    this.rules[393].opcodes[5] = {type: 3, min: 1, max: Infinity};// REP
    this.rules[393].opcodes[6] = {type: 1, children: [7,8,9]};// ALT
    this.rules[393].opcodes[7] = {type: 4, index: 379};// RNM(unreserved)
    this.rules[393].opcodes[8] = {type: 4, index: 383};// RNM(sub-delims)
    this.rules[393].opcodes[9] = {type: 7, string: [58]};// TLS

    /* host */
    this.rules[394].opcodes = [];
    this.rules[394].opcodes[0] = {type: 1, children: [1,2,3]};// ALT
    this.rules[394].opcodes[1] = {type: 4, index: 392};// RNM(IP-literal)
    this.rules[394].opcodes[2] = {type: 4, index: 388};// RNM(IPv4address)
    this.rules[394].opcodes[3] = {type: 4, index: 386};// RNM(reg-name)

    /* port */
    this.rules[395].opcodes = [];
    this.rules[395].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
    this.rules[395].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)

    /* hostname */
    this.rules[396].opcodes = [];
    this.rules[396].opcodes[0] = {type: 2, children: [1,2]};// CAT
    this.rules[396].opcodes[1] = {type: 4, index: 394};// RNM(host)
    this.rules[396].opcodes[2] = {type: 3, min: 0, max: 1};// REP
    this.rules[396].opcodes[3] = {type: 2, children: [4,5]};// CAT
    this.rules[396].opcodes[4] = {type: 7, string: [58]};// TLS
    this.rules[396].opcodes[5] = {type: 4, index: 395};// RNM(port)

    /* queryStringDelim */
    this.rules[397].opcodes = [];
    this.rules[397].opcodes[0] = {type: 1, children: [1,2]};// ALT
    this.rules[397].opcodes[1] = {type: 7, string: [38]};// TLS
    this.rules[397].opcodes[2] = {type: 7, string: [59]};// TLS

    /* queryStringComp */
    this.rules[398].opcodes = [];
    this.rules[398].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[398].opcodes[1] = {type: 7, string: [63]};// TLS
    this.rules[398].opcodes[2] = {type: 4, index: 377};// RNM(queryStringParam)
    this.rules[398].opcodes[3] = {type: 3, min: 0, max: Infinity};// REP
    this.rules[398].opcodes[4] = {type: 2, children: [5,6]};// CAT
    this.rules[398].opcodes[5] = {type: 4, index: 397};// RNM(queryStringDelim)
    this.rules[398].opcodes[6] = {type: 4, index: 377};// RNM(queryStringParam)

    /* gs1uriPattern */
    this.rules[399].opcodes = [];
    this.rules[399].opcodes[0] = {type: 2, children: [1,2]};// CAT
    this.rules[399].opcodes[1] = {type: 4, index: 128};// RNM(gs1path)
    this.rules[399].opcodes[2] = {type: 3, min: 0, max: 1};// REP
    this.rules[399].opcodes[3] = {type: 4, index: 398};// RNM(queryStringComp)

    /* canonicalGS1webURI */
    this.rules[400].opcodes = [];
    this.rules[400].opcodes[0] = {type: 2, children: [1,2]};// CAT
    this.rules[400].opcodes[1] = {type: 7, string: [104,116,116,112,115,58,47,47,105,100,46,103,115,49,46,111,114,103]};// TLS
    this.rules[400].opcodes[2] = {type: 4, index: 399};// RNM(gs1uriPattern)

    /* customURIstem */
    this.rules[401].opcodes = [];
    this.rules[401].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
    this.rules[401].opcodes[1] = {type: 4, index: 378};// RNM(scheme)
    this.rules[401].opcodes[2] = {type: 7, string: [58,47,47]};// TLS
    this.rules[401].opcodes[3] = {type: 4, index: 396};// RNM(hostname)

    /* customGS1webURI */
    this.rules[402].opcodes = [];
    this.rules[402].opcodes[0] = {type: 2, children: [1,2]};// CAT
    this.rules[402].opcodes[1] = {type: 4, index: 401};// RNM(customURIstem)
    this.rules[402].opcodes[2] = {type: 4, index: 399};// RNM(gs1uriPattern)

    // The `toString()` function will display the original grammar file(s) that produced these opcodes.
    this.toString = function(){
      var str = "";
      str += "DIGIT   = \"0\" / \"1\" / \"2\" / \"3\" / \"4\" /\n";
      str += "     \"5\" / \"6\" / \"7\" / \"8\" / \"9\"\n";
      str += "\n";
      str += "UPPERALPHA  = %x41-5A ; A-Z  ( ASCII characters 65-90 decimal, 41-5A hex)\n";
      str += "\n";
      str += "LOWERALPHA  = %x61-7A ; a-z  ( ASCII characters 97-122 decimal, 61-7A hex)\n";
      str += "\n";
      str += "ALPHA   = UPPERALPHA / LOWERALPHA ; A-Z or a-z\n";
      str += "\n";
      str += "HEXDIG   = DIGIT / \"A\" / \"B\" / \"C\" / \"D\" / \"E\" / \"F\"\n";
      str += "\n";
      str += "DoubleQuote   = '\"' ; the double-quote character \"\n";
      str += "\n";
      str += "Octothorpe  = \"%x23\" ; percent-encoding of the # character\n";
      str += "ForwardSlash  = \"%x2F\" ; percent-encoding of the / character\n";
      str += "\n";
      str += "Percent   = \"%x25\" ; percent-encoding of the % character\n";
      str += "Ampersand  = \"%x26\" ; percent-encoding of the & character\n";
      str += "Plus   = \"%x2B\" ; percent-encoding of the + character\n";
      str += "Comma   = \"%x2C\" ; percent-encoding of the , character\n";
      str += "\n";
      str += "Exclamation  = \"%x21\" ; percent-encoding of the ! character\n";
      str += "LeftBracket  = \"%x28\" ; percent-encoding of the ( character\n";
      str += "RightBracket  = \"%x29\" ; percent-encoding of the ) character\n";
      str += "Asterisk  = \"%x2A\" ; percent-encoding of the * character\n";
      str += "\n";
      str += "Apostrophe  = \"%x27\" ; percent-encoding of the ' character\n";
      str += "Colon   = \"%x3A\" ; percent-encoding of the : character\n";
      str += "Semicolon  = \"%x3B\" ; percent-encoding of the ; character\n";
      str += "LeftAngleBracket = \"%x3C\" ; percent-encoding of the < character\n";
      str += "Equals   = \"%x3D\" ; percent-encoding of the = character\n";
      str += "RightAngleBracket = \"%x3E\" ; percent-encoding of the > character\n";
      str += "QuestionMark  = \"%x3F\" ; percent-encoding of the ? character\n";
      str += "\n";
      str += "\n";
      str += "XSYMBOL   = DoubleQuote / \"-\" / \".\" / \"_\" / Exclamation / Percent /\n";
      str += "     Ampersand / Plus / Comma / ForwardSlash / Asterisk /\n";
      str += "     LeftBracket / RightBracket / Apostrophe / Semicolon / Colon /\n";
      str += "     LeftAngleBracket / RightAngleBracket / Equals / QuestionMark\n";
      str += "\n";
      str += "YSYMBOL   = \"-\" / Octothorpe / ForwardSlash\n";
      str += "\n";
      str += "XCHAR    = DIGIT / UPPERALPHA / LOWERALPHA / XSYMBOL\n";
      str += "\n";
      str += "YCHAR    = DIGIT / UPPERALPHA / YSYMBOL\n";
      str += "\n";
      str += "gtin-code  = \"01\"  / %s\"gtin\"  ; GTIN\n";
      str += "itip-code  = \"8006\" / %s\"itip\"  ; ITIP\n";
      str += "gmn-code  = \"8013\" / %s\"gmn\"  ; Global Model Number\n";
      str += "cpid-code  = \"8010\" / %s\"cpid\"  ; CPID\n";
      str += "shipTo-code   = \"410\" / %s\"shipTo\"  ; ship-to\n";
      str += "billTo-code   = \"411\" / %s\"billTo\"  ; bill-to\n";
      str += "purchasedFrom-code = \"412\" / %s\"purchasedFrom\" ; ship-to\n";
      str += "shipFor-code  = \"413\" / %s\"shipFor\"  ; ship-for\n";
      str += "gln-code   = \"414\" / %s\"gln\"  ; Physical Location GLN\n";
      str += "payTo-code   = \"415\" / %s\"payTo\"  ; GLN of invoicing party\n";
      str += "glnProd-code   = \"416\" / %s\"glnProd\"  ; GLN of production/service loc.\n";
      str += "gsrnp-code   = \"8017\" / %s\"gsrnp\"  ; GSRN of the Provider\n";
      str += "gsrn-code   = \"8018\" / %s\"gsrn\"  ; GSRN of the Recipient\n";
      str += "gcn-code   = \"255\" / %s\"gcn\"  ; GCN\n";
      str += "sscc-code   = \"00\"  / %s\"sscc\"  ; SSCC\n";
      str += "gdti-code   = \"253\" / %s\"gdti\"  ; GDTI\n";
      str += "ginc-code   = \"401\" / %s\"ginc\"  ; GINC\n";
      str += "gsin-code   = \"402\" / %s\"gsin\"  ; GSIN\n";
      str += "grai-code   = \"8003\" / %s\"grai\"  ; GRAI\n";
      str += "giai-code   = \"8004\" / %s\"giai\"  ; GIAI\n";
      str += "\n";
      str += "cpv-code   = \"22\"  / %s\"cpv\"   ; Consumer Product Variant\n";
      str += "lot-code   = \"10\"  / %s\"lot\"   ; Batch/Lot identifier\n";
      str += "ser-code   = \"21\"  / %s\"ser\"   ; GTIN Serial Number\n";
      str += "cpsn-code   = \"8011\" / %s\"cpsn\"  ; CPID Serial Number\n";
      str += "glnx-code   = \"254\" / %s\"glnx\"  ; GLN extension\n";
      str += "refno-code  = \"8020\" / %s\"refno\" ; Payment Reference Number\n";
      str += "srin-code   = \"8019\" / %s\"srin\"  ; Service Relation Instance Number\n";
      str += "\n";
      str += "gtin-value  = 14DIGIT / 13DIGIT / 12DIGIT / 8DIGIT\n";
      str += "itip-value  = 14DIGIT 2DIGIT 2DIGIT\n";
      str += "    ; 14 digits then 2 digits then 2 digits\n";
      str += "gmn-value   = 1*30XCHAR  ; 1-30 characters from 82-chr subset\n";
      str += "cpid-value   = 1*30YCHAR  ; 1-30 characters from 39-chr subset\n";
      str += "shipTo-value   = 13DIGIT   ; exactly 13 digits\n";
      str += "billTo-value   = 13DIGIT   ; exactly 13 digits\n";
      str += "purchasedFrom-value  = 13DIGIT   ; exactly 13 digits\n";
      str += "shipFor-value   = 13DIGIT   ; exactly 13 digits\n";
      str += "gln-value   = 13DIGIT   ; exactly 13 digits\n";
      str += "payTo-value   = 13DIGIT   ; exactly 13 digits\n";
      str += "glnProd-value   = 13DIGIT   ; exactly 13 digits\n";
      str += "gsrnp-value   = 18DIGIT   ; exactly 18 digits\n";
      str += "gsrn-value   = 18DIGIT   ; exactly 18 digits\n";
      str += "gcn-value   = 13DIGIT 1*12DIGIT  ; 13 digits then 1-12 digits\n";
      str += "sscc-value   = 18DIGIT   ; exactly 18 digits\n";
      str += "gdti-value   = 13DIGIT 1*17XCHAR\n";
      str += "    ; 13 digits then 1-17 characters\n";
      str += "    ; from the 82-character subset\n";
      str += "ginc-value   = 1*30XCHAR\n";
      str += "    ; 1-30 characters from the 82-character subset\n";
      str += "gsin-value   = 17DIGIT   ; exactly 17 digits\n";
      str += "grai-value   = 14DIGIT 1*16XCHAR\n";
      str += "    ; 14 digits then 1-16 characters\n";
      str += "    ; from the 82-character subset of ISO/IEC 646\n";
      str += "giai-value   = 1*30XCHAR  ; 1-30 characters from 82-chr subset\n";
      str += "\n";
      str += "cpv-value  = 1*20XCHAR  ; 1-20 characters from 82-chr subset\n";
      str += "lot-value  = 1*20XCHAR  ; 1-20 characters from 82-chr subset\n";
      str += "ser-value  = 1*20XCHAR  ; 1-20 characters from 82-chr subset\n";
      str += "cpsn-value  = 1*12DIGIT  ; 1-12 digits\n";
      str += "glnx-value  = 1*20XCHAR  ; 1-20 characters from 82-chr subset\n";
      str += "refno-value   = 1*25XCHAR  ; 1-25 characters from 82-chr subset\n";
      str += "srin-value   = 1*10DIGIT  ; 1-10 digits\n";
      str += "\n";
      str += "gtin-comp   = \"/\" gtin-code \"/\" gtin-value\n";
      str += "itip-comp    = \"/\" itip-code \"/\" itip-value\n";
      str += "gmn-comp    = \"/\" gmn-code \"/\" gmn-value\n";
      str += "cpid-comp    = \"/\" cpid-code \"/\" cpid-value\n";
      str += "shipTo-comp   = \"/\" shipTo-code \"/\" shipTo-value\n";
      str += "billTo-comp   = \"/\" billTo-code \"/\" billTo-value\n";
      str += "purchasedFrom-comp = \"/\" purchasedFrom-code \"/\" purchasedFrom-value\n";
      str += "shipFor-comp   = \"/\" shipFor-code \"/\" shipFor-value\n";
      str += "gln-comp    = \"/\" gln-code \"/\" gln-value\n";
      str += "payTo-comp   = \"/\" payTo-code \"/\" payTo-value\n";
      str += "glnProd-comp   = \"/\" glnProd-code \"/\" glnProd-value\n";
      str += "gsrnp-comp   = \"/\" gsrnp-code \"/\" gsrnp-value\n";
      str += "gsrn-comp   = \"/\" gsrn-code \"/\" gsrn-value\n";
      str += "gcn-comp    = \"/\" gcn-code \"/\" gcn-value\n";
      str += "sscc-comp    = \"/\" sscc-code \"/\" sscc-value\n";
      str += "gdti-comp    = \"/\" gdti-code \"/\" gdti-value\n";
      str += "ginc-comp    = \"/\" ginc-code \"/\" ginc-value\n";
      str += "gsin-comp    = \"/\" gsin-code \"/\" gsin-value\n";
      str += "grai-comp    = \"/\" grai-code \"/\" grai-value\n";
      str += "giai-comp    = \"/\" giai-code \"/\" giai-value\n";
      str += "\n";
      str += "cpv-comp    = \"/\" cpv-code \"/\" cpv-value\n";
      str += "lot-comp    = \"/\" lot-code \"/\" lot-value\n";
      str += "ser-comp    = \"/\" ser-code \"/\" ser-value\n";
      str += "cpsn-comp    = \"/\" cpsn-code \"/\" cpsn-value\n";
      str += "glnx-comp    = \"/\" glnx-code \"/\" glnx-value\n";
      str += "refno-comp   = \"/\" refno-code \"/\" refno-value\n";
      str += "srin-comp    = \"/\" srin-code \"/\" srin-value\n";
      str += "\n";
      str += "gtin-path   = gtin-comp  [cpv-comp] [lot-comp] [ser-comp]\n";
      str += "itip-path   = itip-comp  [cpv-comp] [lot-comp] [ser-comp]\n";
      str += "gmn-path   = gmn-comp\n";
      str += "cpid-path   = cpid-comp  [cpsn-comp]\n";
      str += "shipTo-path  = shipTo-comp\n";
      str += "billTo-path  = billTo-comp\n";
      str += "purchasedFrom-path = purchasedFrom-comp\n";
      str += "shipFor-path  = shipFor-comp\n";
      str += "gln-path   = gln-comp   [glnx-comp]\n";
      str += "payTo-path  = payTo-comp\n";
      str += "glnProd-path  = glnProd-comp\n";
      str += "gsrnp-path  = gsrnp-comp [srin-comp]\n";
      str += "gsrn-path   = gsrn-comp  [srin-comp]\n";
      str += "gcn-path   = gcn-comp\n";
      str += "sscc-path   = sscc-comp\n";
      str += "gdti-path   = gdti-comp\n";
      str += "ginc-path   = ginc-comp\n";
      str += "gsin-path   = gsin-comp\n";
      str += "grai-path   = grai-comp\n";
      str += "giai-path   = giai-comp\n";
      str += "\n";
      str += "gs1path   = gtin-path / itip-path / gmn-path / cpid-path / shipTo-path /\n";
      str += "     billTo-path / purchasedFrom-path / shipFor-path / gln-path /\n";
      str += "     payTo-path / glnProd-path / gsrnp-path / gsrn-path / gcn-path /\n";
      str += "     sscc-path / gdti-path / ginc-path / gsin-path / grai-path / giai-path\n";
      str += "\n";
      str += "netWeightVMTICode  = \"3100\" / \"3101\" / \"3102\" / \"3103\" / \"3104\" / \"3105\" /\n";
      str += "      \"3200\" / \"3201\" / \"3202\" / \"3203\" / \"3204\" / \"3205\" /\n";
      str += "      \"3560\" / \"3561\" / \"3562\" / \"3563\" / \"3564\" / \"3565\" /\n";
      str += "      \"3570\" / \"3571\" / \"3572\" / \"3573\" / \"3574\" / \"3575\"\n";
      str += "netWeightVMTIValue = 6DIGIT\n";
      str += "netWeightVMTIParameter = netWeightVMTICode \"=\" netWeightVMTIValue\n";
      str += "\n";
      str += "lengthVMTICode   = \"3110\" / \"3111\" / \"3112\" / \"3113\" / \"3114\" / \"3115\" /\n";
      str += "      \"3210\" / \"3211\" / \"3212\" / \"3213\" / \"3214\" / \"3215\" /\n";
      str += "      \"3220\" / \"3221\" / \"3222\" / \"3223\" / \"3224\" / \"3225\" /\n";
      str += "      \"3230\" / \"3231\" / \"3232\" / \"3233\" / \"3234\" / \"3235\"\n";
      str += "lengthVMTIValue  = 6DIGIT\n";
      str += "lengthVMTIParameter = lengthVMTICode \"=\" lengthVMTIValue\n";
      str += "\n";
      str += "widthVMTICode   = \"3120\" / \"3121\" / \"3122\" / \"3123\" / \"3124\" / \"3125\" /\n";
      str += "      \"3240\" / \"3241\" / \"3242\" / \"3243\" / \"3244\" / \"3245\" /\n";
      str += "      \"3250\" / \"3251\" / \"3252\" / \"3253\" / \"3254\" / \"3255\" /\n";
      str += "      \"3260\" / \"3261\" / \"3262\" / \"3263\" / \"3264\" / \"3265\"\n";
      str += "widthVMTIValue   = 6DIGIT\n";
      str += "widthVMTIParameter  = widthVMTICode \"=\" widthVMTIValue\n";
      str += "\n";
      str += "depthVMTICode   = \"3130\" / \"3131\" / \"3132\" / \"3133\" / \"3134\" / \"3135\" /\n";
      str += "      \"3270\" / \"3271\" / \"3272\" / \"3273\" / \"3274\" / \"3275\" /\n";
      str += "      \"3280\" / \"3281\" / \"3282\" / \"3283\" / \"3284\" / \"3285\" /\n";
      str += "      \"3290\" / \"3291\" / \"3292\" / \"3293\" / \"3294\" / \"3295\"\n";
      str += "depthVMTIValue   = 6DIGIT\n";
      str += "depthVMTIParameter  = depthVMTICode \"=\" depthVMTIValue\n";
      str += "\n";
      str += "areaVMTICode   = \"3140\" / \"3141\" / \"3142\" / \"3143\" / \"3144\" / \"3145\" /\n";
      str += "      \"3500\" / \"3501\" / \"3502\" / \"3503\" / \"3504\" / \"3505\" /\n";
      str += "      \"3510\" / \"3511\" / \"3512\" / \"3513\" / \"3514\" / \"3515\" /\n";
      str += "      \"3520\" / \"3521\" / \"3522\" / \"3523\" / \"3524\" / \"3525\"\n";
      str += "areaVMTIValue   = 6DIGIT\n";
      str += "areaVMTIParameter  = areaVMTICode \"=\" areaVMTIValue\n";
      str += "\n";
      str += "netVolumeVMTICode  = \"3150\" / \"3151\" / \"3152\" / \"3153\" / \"3154\" / \"3155\" /\n";
      str += "      \"3160\" / \"3161\" / \"3162\" / \"3163\" / \"3164\" / \"3165\" /\n";
      str += "      \"3600\" / \"3601\" / \"3602\" / \"3603\" / \"3604\" / \"3605\" /\n";
      str += "      \"3610\" / \"3611\" / \"3612\" / \"3613\" / \"3614\" / \"3615\" /\n";
      str += "      \"3640\" / \"3641\" / \"3642\" / \"3643\" / \"3644\" / \"3645\" /\n";
      str += "      \"3650\" / \"3651\" / \"3652\" / \"3653\" / \"3654\" / \"3655\" /\n";
      str += "      \"3660\" / \"3661\" / \"3662\" / \"3663\" / \"3664\" / \"3665\"\n";
      str += "netVolumeVMTIValue  = 6DIGIT\n";
      str += "netVolumeVMTIParameter  = netVolumeVMTICode \"=\" netVolumeVMTIValue\n";
      str += "\n";
      str += "\n";
      str += "massPerUnitAreaVMTICode  = \"3370\" / \"3371\" / \"3372\" / \"3373\" / \"3374\" / \"3375\"\n";
      str += "massPerUnitAreaVMTIValue  = 6DIGIT\n";
      str += "massPerUnitAreaVMTIParameter = massPerUnitAreaVMTICode \"=\" massPerUnitAreaVMTIValue\n";
      str += "\n";
      str += "\n";
      str += "grossWeightCode   = \"3300\" / \"3301\" / \"3302\" / \"3303\" / \"3304\" / \"3305\" /\n";
      str += "      \"3400\" / \"3401\" / \"3402\" / \"3403\" / \"3404\" / \"3405\"\n";
      str += "grossWeightValue   = 6DIGIT\n";
      str += "grossWeightParameter   = grossWeightCode \"=\" grossWeightValue\n";
      str += "\n";
      str += "logisticLengthCode   = \"3310\" / \"3311\" / \"3312\" / \"3313\" / \"3314\" / \"3315\" /\n";
      str += "      \"3410\" / \"3411\" / \"3412\" / \"3413\" / \"3414\" / \"3415\" /\n";
      str += "      \"3420\" / \"3421\" / \"3422\" / \"3423\" / \"3424\" / \"3425\" /\n";
      str += "      \"3430\" / \"3431\" / \"3432\" / \"3433\" / \"3434\" / \"3435\"\n";
      str += "logisticLengthValue   = 6DIGIT\n";
      str += "logisticLengthParameter  = logisticLengthCode \"=\" logisticLengthValue\n";
      str += "\n";
      str += "logisticWidthCode   = \"3320\" / \"3321\" / \"3322\" / \"3323\" / \"3324\" / \"3325\" /\n";
      str += "      \"3440\" / \"3441\" / \"3442\" / \"3443\" / \"3444\" / \"3445\" /\n";
      str += "      \"3450\" / \"3451\" / \"3452\" / \"3453\" / \"3454\" / \"3455\" /\n";
      str += "      \"3460\" / \"3461\" / \"3462\" / \"3463\" / \"3464\" / \"3465\"\n";
      str += "logisticWidthValue   = 6DIGIT\n";
      str += "logisticWidthParameter   = logisticWidthCode \"=\" logisticWidthValue\n";
      str += "\n";
      str += "logisticDepthCode   = \"3330\" / \"3331\" / \"3332\" / \"3333\" / \"3334\" / \"3335\" /\n";
      str += "      \"3470\" / \"3471\" / \"3472\" / \"3473\" / \"3474\" / \"3475\" /\n";
      str += "      \"3480\" / \"3481\" / \"3482\" / \"3483\" / \"3484\" / \"3485\" /\n";
      str += "      \"3490\" / \"3491\" / \"3492\" / \"3493\" / \"3494\" / \"3495\"\n";
      str += "logisticDepthValue   = 6DIGIT\n";
      str += "logisticDepthParameter   = logisticDepthCode \"=\" logisticDepthValue\n";
      str += "\n";
      str += "logisticAreaCode   = \"3340\" / \"3341\" / \"3342\" / \"3343\" / \"3344\" / \"3345\" /\n";
      str += "      \"3530\" / \"3531\" / \"3532\" / \"3533\" / \"3534\" / \"3535\" /\n";
      str += "      \"3540\" / \"3541\" / \"3542\" / \"3543\" / \"3544\" / \"3545\" /\n";
      str += "      \"3550\" / \"3551\" / \"3552\" / \"3553\" / \"3554\" / \"3555\"\n";
      str += "logisticAreaValue   = 6DIGIT\n";
      str += "logisticAreaParameter   = logisticAreaCode \"=\" logisticAreaValue\n";
      str += "\n";
      str += "logisticVolumeCode   = \"3350\" / \"3351\" / \"3352\" / \"3353\" / \"3354\" / \"3355\" /\n";
      str += "      \"3360\" / \"3361\" / \"3362\" / \"3363\" / \"3364\" / \"3365\" /\n";
      str += "      \"3620\" / \"3621\" / \"3622\" / \"3623\" / \"3624\" / \"3625\" /\n";
      str += "      \"3630\" / \"3631\" / \"3632\" / \"3633\" / \"3634\" / \"3635\" /\n";
      str += "      \"3670\" / \"3671\" / \"3672\" / \"3673\" / \"3674\" / \"3675\" /\n";
      str += "      \"3680\" / \"3681\" / \"3682\" / \"3683\" / \"3684\" / \"3685\" /\n";
      str += "      \"3690\" / \"3691\" / \"3692\" / \"3693\" / \"3694\" / \"3695\"\n";
      str += "logisticVolumeValue   = 6DIGIT\n";
      str += "logisticVolumeParameter  = logisticVolumeCode \"=\" logisticVolumeValue\n";
      str += "\n";
      str += "processorCode    = \"7030\" / \"7031\" / \"7032\" / \"7033\" / \"7034\" / \"7035\" /\n";
      str += "      \"7036\" / \"7037\" / \"7038\" / \"7039\"\n";
      str += "processorValue       = 3DIGIT   1*27XCHAR\n";
      str += "processorParameter   = processorCode \"=\" processorValue\n";
      str += "\n";
      str += "contentCode    = \"02\"\n";
      str += "contentValue    = 14DIGIT\n";
      str += "contentParameter   = contentCode \"=\" contentValue\n";
      str += "\n";
      str += "prodDateCode    = \"11\"\n";
      str += "prodDateValue    = 6DIGIT\n";
      str += "prodDateParameter   = prodDateCode \"=\" prodDateValue\n";
      str += "\n";
      str += "dueDateCode    = \"12\"\n";
      str += "dueDateValue    = 6DIGIT\n";
      str += "dueDateParameter   = dueDateCode \"=\" dueDateValue\n";
      str += "\n";
      str += "packDateCode    = \"13\"\n";
      str += "packDateValue    = 6DIGIT\n";
      str += "packDateParameter   = packDateCode \"=\" packDateValue\n";
      str += "\n";
      str += "bestBeforeDateCode   = \"15\"\n";
      str += "bestBeforeDateValue   = 6DIGIT\n";
      str += "bestBeforeDateParameter  = bestBeforeDateCode \"=\" bestBeforeDateValue\n";
      str += "\n";
      str += "sellByDateCode    = \"16\"\n";
      str += "sellByDateValue   = 6DIGIT\n";
      str += "sellByDateParameter   = sellByDateCode \"=\" sellByDateValue\n";
      str += "\n";
      str += "firstFreezeDateCode   = \"7006\"\n";
      str += "firstFreezeDateValue   = 6DIGIT\n";
      str += "firstFreezeDateParameter  = firstFreezeDateCode \"=\" firstFreezeDateValue\n";
      str += "\n";
      str += "harvestDateCode   = \"7007\"\n";
      str += "harvestDateValue   = 6*12DIGIT\n";
      str += "harvestDateParameter   = harvestDateCode \"=\" harvestDateValue\n";
      str += "\n";
      str += "pricePerUnitCode   = \"8005\"\n";
      str += "pricePerUnitValue   = 6DIGIT\n";
      str += "pricePerUnitParameter   = pricePerUnitCode \"=\" pricePerUnitValue\n";
      str += "\n";
      str += "variantCode    = \"20\"\n";
      str += "variantValue    = 2DIGIT\n";
      str += "variantParameter   = variantCode \"=\" variantValue\n";
      str += "\n";
      str += "varCountCode    = \"30\"\n";
      str += "varCountValue    = 1*8DIGIT\n";
      str += "varCountParameter   = varCountCode \"=\" varCountValue\n";
      str += "\n";
      str += "countCode    = \"37\"\n";
      str += "countValue    = 1*8DIGIT\n";
      str += "countParameter    = countCode \"=\" countValue\n";
      str += "\n";
      str += "mutualCode    = \"90\"\n";
      str += "mutualValue    = 1*30DIGIT\n";
      str += "mutualParameter   = mutualCode \"=\" mutualValue\n";
      str += "\n";
      str += "additionalIdCode   = \"240\"\n";
      str += "additionalIdValue   = 1*30DIGIT\n";
      str += "additionalIdParameter   = additionalIdCode \"=\" additionalIdValue\n";
      str += "\n";
      str += "custPartNoCode    = \"241\"\n";
      str += "custPartNoValue   = 1*30DIGIT\n";
      str += "custPartNoParameter   = custPartNoCode \"=\" custPartNoValue\n";
      str += "\n";
      str += "mtoVariantCode    = \"242\"\n";
      str += "mtoVariantValue   = 6DIGIT\n";
      str += "mtoVariantParameter   = mtoVariantCode \"=\" mtoVariantValue\n";
      str += "\n";
      str += "pcnCode    = \"243\"\n";
      str += "pcnValue    = 1*20DIGIT\n";
      str += "pcnParameter    = pcnCode \"=\" pcnValue\n";
      str += "\n";
      str += "secondarySerialCode   = \"250\"\n";
      str += "secondarySerialValue   = 1*30DIGIT\n";
      str += "secondarySerialParameter = secondarySerialCode \"=\" secondarySerialValue\n";
      str += "\n";
      str += "refToSourceCode   = \"251\"\n";
      str += "refToSourceValue   = 1*30DIGIT\n";
      str += "refToSourceParameter   = refToSourceCode \"=\" refToSourceValue\n";
      str += "\n";
      str += "amountCode    = \"3900\" / \"3901\" / \"3902\" / \"3903\" / \"3904\" / \"3905\"\n";
      str += "amountValue    = 1*15DIGIT\n";
      str += "amountParameter   = amountCode \"=\" amountValue\n";
      str += "\n";
      str += "amountISOCode    = \"3910\" / \"3911\" / \"3912\" / \"3913\" / \"3914\" / \"3915\"\n";
      str += "amountISOValue    = 3DIGIT 1*15DIGIT\n";
      str += "amountISOParameter   = amountISOCode \"=\" amountISOValue\n";
      str += "\n";
      str += "priceCode    = \"3920\" / \"3921\" / \"3922\" / \"3923\" / \"3924\" / \"3925\"\n";
      str += "priceValue    = 1*15DIGIT\n";
      str += "priceParameter    = priceCode \"=\" priceValue\n";
      str += "\n";
      str += "priceISOCode    = \"3930\" / \"3931\" / \"3932\" / \"3933\" / \"3934\" / \"3935\"\n";
      str += "priceISOValue    = 3DIGIT  1*15DIGIT\n";
      str += "priceISOParameter   = priceISOCode \"=\" priceISOValue\n";
      str += "\n";
      str += "percentOffCode    = \"3940\" / \"3941\" / \"3942\" / \"3943\" / \"3944\" / \"3945\"\n";
      str += "percentOffValue   = 4DIGIT\n";
      str += "percentOffParameter   = percentOffCode \"=\" percentOffValue\n";
      str += "\n";
      str += "orderNumberCode   = \"400\"\n";
      str += "orderNumberValue   = 1*30DIGIT\n";
      str += "orderNumberParameter   = orderNumberCode \"=\" orderNumberValue\n";
      str += "\n";
      str += "routeCode    = \"403\"\n";
      str += "routeValue    = 1*30DIGIT\n";
      str += "routeParameter    = routeCode \"=\" routeValue\n";
      str += "\n";
      str += "shipToLocCode    = \"410\"\n";
      str += "shipToLocValue    = 13DIGIT\n";
      str += "shipToLocParameter   = shipToLocCode \"=\" shipToLocValue\n";
      str += "\n";
      str += "billToCode    = \"411\"\n";
      str += "billToValue    = 13DIGIT\n";
      str += "billToParameter   = billToCode \"=\" billToValue\n";
      str += "\n";
      str += "purchaseFromCode   = \"412\"\n";
      str += "purchaseFromValue   = 13DIGIT\n";
      str += "purchaseFromParameter   = purchaseFromCode \"=\" purchaseFromValue\n";
      str += "\n";
      str += "shipForLocCode    = \"413\"\n";
      str += "shipForLocValue   = 13DIGIT\n";
      str += "shipForLocParameter   = shipForLocCode \"=\" shipForLocValue\n";
      str += "\n";
      str += "locNoCode    = \"414\"\n";
      str += "locNoValue    = 13DIGIT\n";
      str += "locNoParameter    = locNoCode \"=\" locNoValue\n";
      str += "\n";
      str += "payToCode    = \"414\"\n";
      str += "payToValue    = 13DIGIT\n";
      str += "payToParameter    = payToCode \"=\" payToValue\n";
      str += "\n";
      str += "prodServLocCode   = \"416\"\n";
      str += "prodServLocValue   = 13DIGIT\n";
      str += "prodServLocParameter   = prodServLocCode \"=\" prodServLocValue\n";
      str += "\n";
      str += "shipToPostCode    = \"420\"\n";
      str += "shipToPostValue   = 1*20XCHAR\n";
      str += "shipToPostParameter   = shipToPostCode \"=\" shipToPostValue\n";
      str += "\n";
      str += "shipToPostISOCode   = \"421\"\n";
      str += "shipToPostISOValue   = 3DIGIT 1*9XCHAR\n";
      str += "shipToPostISOParameter   = shipToPostISOCode \"=\" shipToPostISOValue\n";
      str += "\n";
      str += "originCode    = \"422\"\n";
      str += "originValue    = 3DIGIT\n";
      str += "originParameter   = originCode \"=\" originValue\n";
      str += "\n";
      str += "countryProcessCode   = \"424\"\n";
      str += "countryProcessValue   = 3DIGIT\n";
      str += "countryProcessParameter  = countryProcessCode \"=\" countryProcessValue\n";
      str += "\n";
      str += "countryFullProcessCode  = \"426\"\n";
      str += "countryFullProcessValue  = 3DIGIT\n";
      str += "countryFullProcessParameter  = countryFullProcessCode \"=\" countryFullProcessValue\n";
      str += "\n";
      str += "countryInitialProcessCode = \"423\"\n";
      str += "countryInitialProcessValue  = 3DIGIT 1*12DIGIT\n";
      str += "countryInitialProcessParameter = countryInitialProcessCode \"=\" countryInitialProcessValue\n";
      str += "\n";
      str += "countryDisassemblyCode   = \"425\"\n";
      str += "countryDisassemblyValue  = 3DIGIT 1*12DIGIT\n";
      str += "countryDisassemblyParameter  = countryDisassemblyCode \"=\" countryDisassemblyValue\n";
      str += "\n";
      str += "originSubdivisionCode   = \"427\"\n";
      str += "originSubdivisionValue   = 1*3XCHAR\n";
      str += "originSubdivisionParameter  = originSubdivisionCode \"=\" originSubdivisionValue\n";
      str += "\n";
      str += "nhrnPZNCode    = \"710\"\n";
      str += "nhrnPZNValue    = 1*20XCHAR\n";
      str += "nhrnPZNParameter   = nhrnPZNCode \"=\" nhrnPZNValue\n";
      str += "\n";
      str += "nhrnCIPCode    = \"711\"\n";
      str += "nhrnCIPValue    = 1*20XCHAR\n";
      str += "nhrnCIPParameter   = nhrnCIPCode \"=\" nhrnCIPValue\n";
      str += "\n";
      str += "nhrnCNCode    = \"712\"\n";
      str += "nhrnCNValue    = 1*20XCHAR\n";
      str += "nhrnCNParameter   = nhrnCNCode \"=\" nhrnCNValue\n";
      str += "\n";
      str += "nhrnDRNCode    = \"713\"\n";
      str += "nhrnDRNValue    = 1*20XCHAR\n";
      str += "nhrnDRNParameter   = nhrnDRNCode \"=\" nhrnDRNValue\n";
      str += "\n";
      str += "nhrnAIMCode    = \"714\"\n";
      str += "nhrnAIMValue    = 1*20XCHAR\n";
      str += "nhrnAIMParameter   = nhrnAIMCode \"=\" nhrnAIMValue\n";
      str += "\n";
      str += "nsnCode    = \"7001\"\n";
      str += "nsnValue    = 13DIGIT\n";
      str += "nsnParameter    = nsnCode \"=\" nsnValue\n";
      str += "\n";
      str += "meatCutCode    = \"7002\"\n";
      str += "meatCutValue    = 1*30XCHAR\n";
      str += "meatCutParameter   = meatCutCode \"=\" meatCutValue\n";
      str += "\n";
      str += "activePotencyCode   = \"7004\"\n";
      str += "activePotencyValue   = 1*4DIGIT\n";
      str += "activePotencyParameter   = activePotencyCode \"=\" activePotencyValue\n";
      str += "\n";
      str += "catchAreaCode    = \"7005\"\n";
      str += "catchAreaValue    = 1*12XCHAR\n";
      str += "catchAreaParameter   = catchAreaCode \"=\" catchAreaValue\n";
      str += "\n";
      str += "fishingGearTypeCode   = \"7009\"\n";
      str += "fishingGearTypeValue   = 1*10XCHAR\n";
      str += "fishingGearTypeParameter  = fishingGearTypeCode \"=\" fishingGearTypeValue\n";
      str += "\n";
      str += "prodMethodCode    = \"7010\"\n";
      str += "prodMethodValue   = 1*2XCHAR\n";
      str += "prodMethodParameter   = prodMethodCode \"=\" prodMethodValue\n";
      str += "\n";
      str += "refurbLotCode    = \"7020\"\n";
      str += "refurbLotValue    = 1*20XCHAR\n";
      str += "refurbLotParameter   = refurbLotCode \"=\" refurbLotValue\n";
      str += "\n";
      str += "funcStatCode    = \"7021\"\n";
      str += "funcStatValue    = 1*20XCHAR\n";
      str += "funcStatParameter   = funcStatCode \"=\" funcStatValue\n";
      str += "\n";
      str += "revStatCode    = \"7022\"\n";
      str += "revStatValue    = 1*20XCHAR\n";
      str += "revStatParameter   = revStatCode \"=\" revStatValue\n";
      str += "\n";
      str += "giaiAssemblyCode   = \"7023\"\n";
      str += "giaiAssemblyValue   = 1*30XCHAR\n";
      str += "giaiAssemblyParameter   = giaiAssemblyCode \"=\" giaiAssemblyValue\n";
      str += "\n";
      str += "dimensionsCode    = \"8001\"\n";
      str += "dimensionsValue   = 14DIGIT\n";
      str += "dimensionsParameter   = dimensionsCode \"=\" dimensionsValue\n";
      str += "\n";
      str += "cmtNoCode    = \"8002\"\n";
      str += "cmtNoValue    = 1*20XCHAR\n";
      str += "cmtNoParameter    = cmtNoCode \"=\" cmtNoValue\n";
      str += "\n";
      str += "ibanCode    = \"8007\"\n";
      str += "ibanValue    = 1*34XCHAR\n";
      str += "ibanParameter    = ibanCode \"=\" ibanValue\n";
      str += "\n";
      str += "prodTimeCode    = \"8008\"\n";
      str += "prodTimeValue    = 8DIGIT 1*4DIGIT\n";
      str += "prodTimeParameter   = prodTimeCode \"=\" prodTimeValue\n";
      str += "\n";
      str += "versionCode    = \"8012\"\n";
      str += "versionValue    = 4DIGIT  1*20XCHAR\n";
      str += "versionParameter   = versionCode \"=\" versionValue\n";
      str += "\n";
      str += "refNoCode    = \"8020\"\n";
      str += "refNoValue    = 1*25XCHAR\n";
      str += "refNoParameter    = refNoCode \"=\" refNoValue\n";
      str += "\n";
      str += "couponIDNACode    = \"8110\"\n";
      str += "couponIDNAValue   = 1*70XCHAR\n";
      str += "couponIDNAParameter   = couponIDNACode \"=\" couponIDNAValue\n";
      str += "\n";
      str += "pointsCode    = \"8111\"\n";
      str += "pointsValue    = 4DIGIT\n";
      str += "pointsParameter   = pointsCode \"=\" pointsValue\n";
      str += "\n";
      str += "paperlessCouponIDNACode  = \"8112\"\n";
      str += "paperlessCouponIDNAValue  = 1*70XCHAR\n";
      str += "paperlessCouponIDNAParameter = paperlessCouponIDNACode \"=\" paperlessCouponIDNAValue\n";
      str += "\n";
      str += "internalCode    = \"91\" / \"92\" / \"93\" / \"94\" / \"95\" / \"96\" / \"97\" / \"98\" / \"99\"\n";
      str += "internalValue    = 1*90XCHAR\n";
      str += "internalParameter  = internalCode \"=\" internalValue\n";
      str += "\n";
      str += "LotParameter    = lot-code \"=\" lot-value\n";
      str += "\n";
      str += "expiryDateCode    = \"17\" / %s\"exp\"\n";
      str += "expiryDateValue   = 6DIGIT\n";
      str += "expiryDateParameter   = expiryDateCode \"=\" expiryDateValue\n";
      str += "\n";
      str += "expiryTimeCode    = \"7003\" / %s\"expdt\"\n";
      str += "expiryTimeValue   = 10DIGIT\n";
      str += "expiryTimeParameter   = expiryTimeCode \"=\" expiryTimeValue\n";
      str += "\n";
      str += "extensionParameter  = *( pchar / \"/\" / \"?\" )\n";
      str += "    ; any other query string parameter permitted by RFC 3986\n";
      str += "    ; including additional arbitrary key=value pairs\n";
      str += "\n";
      str += "queryStringParam  = netWeightVMTIParameter / lengthVMTIParameter /\n";
      str += "   widthVMTIParameter  / depthVMTIParameter / areaVMTIParameter /\n";
      str += "   netVolumeVMTIParameter / massPerUnitAreaVMTIParameter /\n";
      str += "   grossWeightParameter / logisticLengthParameter /\n";
      str += "   logisticWidthParameter / logisticDepthParameter /\n";
      str += "   logisticAreaParameter / logisticVolumeParameter /\n";
      str += "   processorParameter / LotParameter / expiryDateParameter /\n";
      str += "   expiryTimeParameter / contentParameter / prodDateParameter /\n";
      str += "   dueDateParameter / packDateParameter / bestBeforeDateParameter /\n";
      str += "   sellByDateParameter / firstFreezeDateParameter /\n";
      str += "   harvestDateParameter / pricePerUnitParameter / variantParameter /\n";
      str += "   varCountParameter / countParameter / internalParameter /\n";
      str += "   additionalIdParameter / custPartNoParameter /\n";
      str += "   mtoVariantParameter / pcnParameter / secondarySerialParameter /\n";
      str += "   refToSourceParameter / amountParameter / amountISOParameter /\n";
      str += "   priceParameter / priceISOParameter / percentOffParameter /\n";
      str += "   orderNumberParameter / routeParameter / shipToLocParameter /\n";
      str += "   billToParameter / purchaseFromParameter / shipForLocParameter /\n";
      str += "   locNoParameter / prodServLocParameter / shipToPostParameter /\n";
      str += "   shipToPostISOParameter / originParameter /\n";
      str += "   countryProcessParameter / countryFullProcessParameter /\n";
      str += "   countryInitialProcessParameter / countryDisassemblyParameter /\n";
      str += "   originSubdivisionParameter / nhrnPZNParameter / nhrnCIPParameter /\n";
      str += "   nhrnCNParameter / nhrnDRNParameter / nsnParameter /\n";
      str += "   meatCutParameter / activePotencyParameter / catchAreaParameter /\n";
      str += "   fishingGearTypeParameter / prodMethodParameter /\n";
      str += "   refurbLotParameter / funcStatParameter / revStatParameter /\n";
      str += "   giaiAssemblyParameter / dimensionsParameter / cmtNoParameter /\n";
      str += "   ibanParameter / prodTimeParameter / versionParameter /\n";
      str += "   refNoParameter / couponIDNAParameter / pointsParameter /\n";
      str += "   paperlessCouponIDNAParameter /\n";
      str += "   internalParameter / mutualParameter / extensionParameter\n";
      str += "\n";
      str += "scheme    = \"https\" / \"http\"\n";
      str += "\n";
      str += "unreserved    = ALPHA / DIGIT / \"-\" / \".\" / \"_\" / \"~\"\n";
      str += "\n";
      str += "reserved      = gen-delims / sub-delims\n";
      str += "\n";
      str += "pct-encoded   = \"%\" HEXDIG HEXDIG\n";
      str += "\n";
      str += "gen-delims    = \":\" / \"/\" / \"?\" / \"#\" / \"[\" / \"]\" / \"@\"\n";
      str += "\n";
      str += "sub-delims    = \"!\" / \"$\" / \"&\" / \"'\" / \"(\" / \")\" / \"*\" /\n";
      str += "      \"+\" / \",\" / \";\" / \"=\"\n";
      str += "\n";
      str += "pchar          = unreserved / pct-encoded / sub-delims / \":\" / \"@\"\n";
      str += "\n";
      str += "segment         = *pchar\n";
      str += "\n";
      str += "reg-name        = *( unreserved / pct-encoded / sub-delims )\n";
      str += "\n";
      str += "\n";
      str += "dec-octet  = DIGIT                 ; 0-9\n";
      str += "     / %x31-39 DIGIT         ; 10-99\n";
      str += "     / \"1\" 2DIGIT            ; 100-199\n";
      str += "     / \"2\" %x30-34 DIGIT     ; 200-249\n";
      str += "     / \"25\" %x30-35          ; 250-255\n";
      str += "\n";
      str += "IPv4address   = dec-octet \".\" dec-octet \".\" dec-octet \".\" dec-octet\n";
      str += "\n";
      str += "IPv6address   = 6( h16 \":\" ) ls32\n";
      str += "     /                       \"::\" 5( h16 \":\" ) ls32\n";
      str += "     / [               h16 ] \"::\" 4( h16 \":\" ) ls32\n";
      str += "     / [ *1( h16 \":\" ) h16 ] \"::\" 3( h16 \":\" ) ls32\n";
      str += "     / [ *2( h16 \":\" ) h16 ] \"::\" 2( h16 \":\" ) ls32\n";
      str += "     / [ *3( h16 \":\" ) h16 ] \"::\"    h16 \":\"   ls32\n";
      str += "     / [ *4( h16 \":\" ) h16 ] \"::\"              ls32\n";
      str += "     / [ *5( h16 \":\" ) h16 ] \"::\"              h16\n";
      str += "     / [ *6( h16 \":\" ) h16 ] \"::\"\n";
      str += "\n";
      str += "ls32          = ( h16 \":\" h16 ) / IPv4address\n";
      str += "     ; least-significant 32 bits of address\n";
      str += "\n";
      str += "h16           = 1*4HEXDIG\n";
      str += "     ; 16 bits of address represented in hexadecimal\n";
      str += "\n";
      str += "IP-literal   = \"[\" ( IPv6address / IPvFuture  ) \"]\"\n";
      str += "\n";
      str += "IPvFuture    = \"v\" 1*HEXDIG \".\" 1*( unreserved / sub-delims / \":\" )\n";
      str += "\n";
      str += "host          = IP-literal / IPv4address / reg-name\n";
      str += "\n";
      str += "port    = *DIGIT\n";
      str += "\n";
      str += "hostname  = host [ \":\" port ]\n";
      str += "\n";
      str += "queryStringDelim  = \"&\" / \";\"\n";
      str += "\n";
      str += "queryStringComp  = \"?\" queryStringParam *( queryStringDelim queryStringParam)\n";
      str += "\n";
      str += "gs1uriPattern   = gs1path [queryStringComp]\n";
      str += "\n";
      str += "canonicalGS1webURI  = \"https://id.gs1.org\" gs1uriPattern\n";
      str += "\n";
      str += "customURIstem  = scheme \"://\" hostname ; *( \"/\" segment )\n";
      str += "\n";
      str += "customGS1webURI  = customURIstem gs1uriPattern\n";
      return str;
    }
  }
};